import {AuthorizedApiBase, IConfig, CancelToken } from "./authorization"
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.0.0 (NJsonSchema v11.6.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IActeurDossierPatientClient {

    /**
     * Récupère la liste des acteurs avec infos nécessaires pour affichage (habilitation, spécialité, structure morale)
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param ippr Identifiant du patient.
     * @return OK
     */
    getListeActeursPatientsByIppr(idTechPsIdentifie: string, ippr: string,  cancelToken?: CancelToken): Promise<ActeurPatient[]>;

    /**
     * Retourne la liste des patients suivis par le PS
     * @param idTechPsIdentifie (optional) 
     * @return OK
     */
    getPatientsSuivisParProfessionnel(idTechPsIdentifie?: string | undefined,  cancelToken?: CancelToken): Promise<PatientSuiviFileActive[]>;

    /**
     * Appel le service de l'APISante pour ajouter un acteur à un patient
     * @param body (optional) ippr
     * @return OK
     */
    ajouterActeurPatientPS(body?: AjouterActeurPatientPSRequest | undefined,  cancelToken?: CancelToken): Promise<number>;

    /**
     * Appel le service de l'APISante pour supprimer un acteur d'un patient
     * @param body (optional) idActeur, passeDroit
     * @return OK
     */
    supprimerActeurPatientPS(body?: SupprimerActeurPatientPSRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class ActeurDossierPatientClient extends AuthorizedApiBase implements IActeurDossierPatientClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Récupère la liste des acteurs avec infos nécessaires pour affichage (habilitation, spécialité, structure morale)
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param ippr Identifiant du patient.
     * @return OK
     */
    getListeActeursPatientsByIppr(idTechPsIdentifie: string, ippr: string): Promise<ActeurPatient[]> {
        let url_ = this.baseUrl + "/api/ActeurDossierPatient/GetListeActeursPatientsByIppr?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (ippr === undefined || ippr === null)
            throw new globalThis.Error("The parameter 'ippr' must be defined and cannot be null.");
        else
            url_ += "ippr=" + encodeURIComponent("" + ippr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListeActeursPatientsByIppr(_response);
        });
    }

    protected processGetListeActeursPatientsByIppr(response: Response): Promise<ActeurPatient[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActeurPatient[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActeurPatient[]>(null as any);
    }

    /**
     * Retourne la liste des patients suivis par le PS
     * @param idTechPsIdentifie (optional) 
     * @return OK
     */
    getPatientsSuivisParProfessionnel(idTechPsIdentifie?: string | undefined): Promise<PatientSuiviFileActive[]> {
        let url_ = this.baseUrl + "/api/ActeurDossierPatient/GetPatientsSuivisParProfessionnel?";
        if (idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' cannot be null.");
        else if (idTechPsIdentifie !== undefined)
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPatientsSuivisParProfessionnel(_response);
        });
    }

    protected processGetPatientsSuivisParProfessionnel(response: Response): Promise<PatientSuiviFileActive[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatientSuiviFileActive[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientSuiviFileActive[]>(null as any);
    }

    /**
     * Appel le service de l'APISante pour ajouter un acteur à un patient
     * @param body (optional) ippr
     * @return OK
     */
    ajouterActeurPatientPS(body?: AjouterActeurPatientPSRequest | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ActeurDossierPatient/AjouterActeurPatientPS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAjouterActeurPatientPS(_response);
        });
    }

    protected processAjouterActeurPatientPS(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Appel le service de l'APISante pour supprimer un acteur d'un patient
     * @param body (optional) idActeur, passeDroit
     * @return OK
     */
    supprimerActeurPatientPS(body?: SupprimerActeurPatientPSRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ActeurDossierPatient/SupprimerActeurPatientPS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSupprimerActeurPatientPS(_response);
        });
    }

    protected processSupprimerActeurPatientPS(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAnnuaireDpprClient {

    /**
     * Récupère les préférences du Ps via son Id
     * @return OK
     */
    getPSPreferencesMonSisra(value: boolean,  cancelToken?: CancelToken): Promise<PreferencePSMonSisra>;

    /**
     * Ajout d'une trace lors d'une connection
     * @param body (optional) Informations concernant la connection (IdPsConnecté, Application, Versions, ...
     * @return OK
     */
    addTraceConnexion(body?: TraceConnection | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Mise à jour des préférences du PS connecté
     * @param body (optional) 
     * @return OK
     */
    mAJPreferencesPSMonSisra(body?: MAJPreferencesPSMonSisraRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Mise à jour du mot de passe du PS
     * @param login login du PS
     * @param newPassword nouveau mdp
     * @param oldPassword ancien mdp
     * @return OK
     */
    updatePsPassword(login: string, newPassword: string, oldPassword: string,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Permet l'authentification d'un utilisateur
     * @param body (optional) les credentiels avec userLogin et password
     * @return OK
     */
    authenticateUser(body?: UserCredentiels | undefined,  cancelToken?: CancelToken): Promise<boolean>;

    /**
     * Envoie une invitation à un confrère
     * @param body (optional) 
     * @return OK
     */
    sendInvitationConfrere(body?: InvitationConfrereRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class AnnuaireDpprClient extends AuthorizedApiBase implements IAnnuaireDpprClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Récupère les préférences du Ps via son Id
     * @return OK
     */
    getPSPreferencesMonSisra(value: boolean): Promise<PreferencePSMonSisra> {
        let url_ = this.baseUrl + "/api/AnnuaireDppr/GetPSPreferencesMonSisra?";
        if (value === undefined || value === null)
            throw new globalThis.Error("The parameter 'value' must be defined and cannot be null.");
        else
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPSPreferencesMonSisra(_response);
        });
    }

    protected processGetPSPreferencesMonSisra(response: Response): Promise<PreferencePSMonSisra> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreferencePSMonSisra;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreferencePSMonSisra>(null as any);
    }

    /**
     * Ajout d'une trace lors d'une connection
     * @param body (optional) Informations concernant la connection (IdPsConnecté, Application, Versions, ...
     * @return OK
     */
    addTraceConnexion(body?: TraceConnection | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AnnuaireDppr/AddTraceConnexion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddTraceConnexion(_response);
        });
    }

    protected processAddTraceConnexion(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Mise à jour des préférences du PS connecté
     * @param body (optional) 
     * @return OK
     */
    mAJPreferencesPSMonSisra(body?: MAJPreferencesPSMonSisraRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AnnuaireDppr/MAJPreferencesPSMonSisra";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMAJPreferencesPSMonSisra(_response);
        });
    }

    protected processMAJPreferencesPSMonSisra(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Mise à jour du mot de passe du PS
     * @param login login du PS
     * @param newPassword nouveau mdp
     * @param oldPassword ancien mdp
     * @return OK
     */
    updatePsPassword(login: string, newPassword: string, oldPassword: string): Promise<void> {
        let url_ = this.baseUrl + "/api/AnnuaireDppr/UpdatePsPassword?";
        if (login === undefined || login === null)
            throw new globalThis.Error("The parameter 'login' must be defined and cannot be null.");
        else
            url_ += "login=" + encodeURIComponent("" + login) + "&";
        if (newPassword === undefined || newPassword === null)
            throw new globalThis.Error("The parameter 'newPassword' must be defined and cannot be null.");
        else
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        if (oldPassword === undefined || oldPassword === null)
            throw new globalThis.Error("The parameter 'oldPassword' must be defined and cannot be null.");
        else
            url_ += "oldPassword=" + encodeURIComponent("" + oldPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePsPassword(_response);
        });
    }

    protected processUpdatePsPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Permet l'authentification d'un utilisateur
     * @param body (optional) les credentiels avec userLogin et password
     * @return OK
     */
    authenticateUser(body?: UserCredentiels | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AnnuaireDppr/AuthenticateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAuthenticateUser(_response);
        });
    }

    protected processAuthenticateUser(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Envoie une invitation à un confrère
     * @param body (optional) 
     * @return OK
     */
    sendInvitationConfrere(body?: InvitationConfrereRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AnnuaireDppr/SendInvitationConfrere";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendInvitationConfrere(_response);
        });
    }

    protected processSendInvitationConfrere(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IConfigurationClient {

    /**
     * Permet de récupérer la configuration des applications Web + Bureau
     * @return OK
     */
    getFeaturesConfigurations( cancelToken?: CancelToken): Promise<ConfigurationFront>;

    /**
     * Permet de récupérer la configuration de l'application Mobile
     * @return OK
     */
    getFeaturesConfigurationsMobile( cancelToken?: CancelToken): Promise<ConfigurationMobile>;
}

export class ConfigurationClient extends AuthorizedApiBase implements IConfigurationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Permet de récupérer la configuration des applications Web + Bureau
     * @return OK
     */
    getFeaturesConfigurations(): Promise<ConfigurationFront> {
        let url_ = this.baseUrl + "/api/Configuration/GetFeaturesConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFeaturesConfigurations(_response);
        });
    }

    protected processGetFeaturesConfigurations(response: Response): Promise<ConfigurationFront> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConfigurationFront;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigurationFront>(null as any);
    }

    /**
     * Permet de récupérer la configuration de l'application Mobile
     * @return OK
     */
    getFeaturesConfigurationsMobile(): Promise<ConfigurationMobile> {
        let url_ = this.baseUrl + "/api/Configuration/GetFeaturesConfigurationsMobile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFeaturesConfigurationsMobile(_response);
        });
    }

    protected processGetFeaturesConfigurationsMobile(response: Response): Promise<ConfigurationMobile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConfigurationMobile;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigurationMobile>(null as any);
    }
}

export interface IDeviceClient {

    /**
     * Recherche si un appareil existe via son uuid
     * @param uuid id de l'appareil
     * @return OK
     * @deprecated
     */
    deviceV1ExistByUUID(uuid: string, registrationId: string,  cancelToken?: CancelToken): Promise<boolean>;

    /**
     * Récupère l'AtefactId et le status via l'Uuid
     * @return OK
     * @deprecated
     */
    getArtefactIdByUUIDAndPassword(uuid: string, password: string, registrationId: string,  cancelToken?: CancelToken): Promise<GetArtefactIdByUUIDAndPasswordResult>;

    /**
     * Initie un device pour un utilisateur de MonSisra Mobile v3.4+ après la création du ProtectedCertificate ou migration device existant
     * @param body (optional) 
     * @return OK
     */
    createDevice(body?: CreateDeviceRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Supprime un appareil par son UUID
     * @param body (optional) 
     * @return OK
     */
    desactivateByUuid(body?: DesactivateDeviceRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class DeviceClient extends AuthorizedApiBase implements IDeviceClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Recherche si un appareil existe via son uuid
     * @param uuid id de l'appareil
     * @return OK
     * @deprecated
     */
    deviceV1ExistByUUID(uuid: string, registrationId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Device/DeviceV1ExistByUUID?";
        if (uuid === undefined || uuid === null)
            throw new globalThis.Error("The parameter 'uuid' must be defined and cannot be null.");
        else
            url_ += "uuid=" + encodeURIComponent("" + uuid) + "&";
        if (registrationId === undefined || registrationId === null)
            throw new globalThis.Error("The parameter 'registrationId' must be defined and cannot be null.");
        else
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeviceV1ExistByUUID(_response);
        });
    }

    protected processDeviceV1ExistByUUID(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Récupère l'AtefactId et le status via l'Uuid
     * @return OK
     * @deprecated
     */
    getArtefactIdByUUIDAndPassword(uuid: string, password: string, registrationId: string): Promise<GetArtefactIdByUUIDAndPasswordResult> {
        let url_ = this.baseUrl + "/api/Device/GetArtefactIdByUUIDAndPassword?";
        if (uuid === undefined || uuid === null)
            throw new globalThis.Error("The parameter 'uuid' must be defined and cannot be null.");
        else
            url_ += "uuid=" + encodeURIComponent("" + uuid) + "&";
        if (password === undefined || password === null)
            throw new globalThis.Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (registrationId === undefined || registrationId === null)
            throw new globalThis.Error("The parameter 'registrationId' must be defined and cannot be null.");
        else
            url_ += "registrationId=" + encodeURIComponent("" + registrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetArtefactIdByUUIDAndPassword(_response);
        });
    }

    protected processGetArtefactIdByUUIDAndPassword(response: Response): Promise<GetArtefactIdByUUIDAndPasswordResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetArtefactIdByUUIDAndPasswordResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetArtefactIdByUUIDAndPasswordResult>(null as any);
    }

    /**
     * Initie un device pour un utilisateur de MonSisra Mobile v3.4+ après la création du ProtectedCertificate ou migration device existant
     * @param body (optional) 
     * @return OK
     */
    createDevice(body?: CreateDeviceRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Device/CreateDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDevice(_response);
        });
    }

    protected processCreateDevice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Supprime un appareil par son UUID
     * @param body (optional) 
     * @return OK
     */
    desactivateByUuid(body?: DesactivateDeviceRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Device/DesactivateByUuid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDesactivateByUuid(_response);
        });
    }

    protected processDesactivateByUuid(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IDocumentClient {

    /**
     * @param typeMessagerie (optional) 
     * @return le document
     */
    downloadDoc(idLocalDoc: string, idEtablissement: number, typeConversation: ConversationType, typeMessagerie?: MessagerieType | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;

    /**
     * @return OK
     */
    getDocumentFromCouchDb(url: string,  cancelToken?: CancelToken): Promise<string>;

    /**
     * Renvoie le contenu binaire des fichiers aux formats demandés
    Vérification d'habilitation du destinataire sur le document
     * @param body (optional) 
     * @return OK
     */
    getMultiDoc(body?: GetMultiDocRequest | undefined,  cancelToken?: CancelToken): Promise<MultiDoc[]>;

    /**
     * Renvoie le contenu binaire des fichiers aux formats demandés
    Vérification d'habilitation du destinataire sur le document
     * @param body (optional) 
     * @return OK
     */
    getMultiDocBase64(body?: GetMultiDocRequest | undefined,  cancelToken?: CancelToken): Promise<MultiDocBase64[]>;

    /**
     * Renvoie le contenu binaire d'un fichiers d'un expert au format Base64.
     * @param body (optional) 
     * @return OK
     */
    getDocumentExpertBase64(body?: GetDocumentExpertBase64Request | undefined,  cancelToken?: CancelToken): Promise<FichierBase64>;

    /**
     * Renvoie le contenu binaire d'un fichiers d'une équipe ressource au format Base64.
     * @param body (optional) 
     * @return OK
     */
    getDocumentEquipeRessourceBase64(body?: GetDocumentEquipeRessourceBase64Request | undefined,  cancelToken?: CancelToken): Promise<FichierBase64>;

    /**
     * Appel getmultidoc pour MSB (FormatAsString = en entrée, msb demande le format pdf ou original)
     * @param body (optional) 
     * @return OK
     */
    getMultiDocFormatAsString(body?: GetMultiDocFormatAsStringRequest | undefined,  cancelToken?: CancelToken): Promise<MultiDoc[]>;

    /**
     * Récupère le document suivant du PS connecté
     * @param body (optional) Contenu de la requête
     * @return OK
     */
    getNextDocConvTypesWithLastRead(body?: GetNextDocConvTypesWithLastReadRequest | undefined,  cancelToken?: CancelToken): Promise<MetadataMultiDoc>;

    /**
     * Récupère les informations du premier document à partir duquel une synchro doit être faite
     * @param body (optional) Données de la requête
     * @return OK
     */
    getInfosDocInitial(body?: GetInfosDocInitialRequest | undefined,  cancelToken?: CancelToken): Promise<InfosDoc>;
}

export class DocumentClient extends AuthorizedApiBase implements IDocumentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * @param typeMessagerie (optional) 
     * @return le document
     */
    downloadDoc(idLocalDoc: string, idEtablissement: number, typeConversation: ConversationType, typeMessagerie?: MessagerieType | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Document/download-doc?";
        if (idLocalDoc === undefined || idLocalDoc === null)
            throw new globalThis.Error("The parameter 'idLocalDoc' must be defined and cannot be null.");
        else
            url_ += "idLocalDoc=" + encodeURIComponent("" + idLocalDoc) + "&";
        if (idEtablissement === undefined || idEtablissement === null)
            throw new globalThis.Error("The parameter 'idEtablissement' must be defined and cannot be null.");
        else
            url_ += "idEtablissement=" + encodeURIComponent("" + idEtablissement) + "&";
        if (typeConversation === undefined || typeConversation === null)
            throw new globalThis.Error("The parameter 'typeConversation' must be defined and cannot be null.");
        else
            url_ += "typeConversation=" + encodeURIComponent("" + typeConversation) + "&";
        if (typeMessagerie === null)
            throw new globalThis.Error("The parameter 'typeMessagerie' cannot be null.");
        else if (typeMessagerie !== undefined)
            url_ += "typeMessagerie=" + encodeURIComponent("" + typeMessagerie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadDoc(_response);
        });
    }

    protected processDownloadDoc(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("si le document n\'a pas \u00e9t\u00e9 trouv\u00e9", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    getDocumentFromCouchDb(url: string): Promise<string> {
        let url_ = this.baseUrl + "/api/Document/from-couchdb?";
        if (url === undefined || url === null)
            throw new globalThis.Error("The parameter 'url' must be defined and cannot be null.");
        else
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentFromCouchDb(_response);
        });
    }

    protected processGetDocumentFromCouchDb(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Renvoie le contenu binaire des fichiers aux formats demandés
    Vérification d'habilitation du destinataire sur le document
     * @param body (optional) 
     * @return OK
     */
    getMultiDoc(body?: GetMultiDocRequest | undefined): Promise<MultiDoc[]> {
        let url_ = this.baseUrl + "/api/Document/GetMultiDoc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMultiDoc(_response);
        });
    }

    protected processGetMultiDoc(response: Response): Promise<MultiDoc[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MultiDoc[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiDoc[]>(null as any);
    }

    /**
     * Renvoie le contenu binaire des fichiers aux formats demandés
    Vérification d'habilitation du destinataire sur le document
     * @param body (optional) 
     * @return OK
     */
    getMultiDocBase64(body?: GetMultiDocRequest | undefined): Promise<MultiDocBase64[]> {
        let url_ = this.baseUrl + "/api/Document/GetMultiDocBase64";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMultiDocBase64(_response);
        });
    }

    protected processGetMultiDocBase64(response: Response): Promise<MultiDocBase64[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MultiDocBase64[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiDocBase64[]>(null as any);
    }

    /**
     * Renvoie le contenu binaire d'un fichiers d'un expert au format Base64.
     * @param body (optional) 
     * @return OK
     */
    getDocumentExpertBase64(body?: GetDocumentExpertBase64Request | undefined): Promise<FichierBase64> {
        let url_ = this.baseUrl + "/api/Document/GetDocumentExpertBase64";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentExpertBase64(_response);
        });
    }

    protected processGetDocumentExpertBase64(response: Response): Promise<FichierBase64> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FichierBase64;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FichierBase64>(null as any);
    }

    /**
     * Renvoie le contenu binaire d'un fichiers d'une équipe ressource au format Base64.
     * @param body (optional) 
     * @return OK
     */
    getDocumentEquipeRessourceBase64(body?: GetDocumentEquipeRessourceBase64Request | undefined): Promise<FichierBase64> {
        let url_ = this.baseUrl + "/api/Document/GetDocumentEquipeRessourceBase64";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentEquipeRessourceBase64(_response);
        });
    }

    protected processGetDocumentEquipeRessourceBase64(response: Response): Promise<FichierBase64> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FichierBase64;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FichierBase64>(null as any);
    }

    /**
     * Appel getmultidoc pour MSB (FormatAsString = en entrée, msb demande le format pdf ou original)
     * @param body (optional) 
     * @return OK
     */
    getMultiDocFormatAsString(body?: GetMultiDocFormatAsStringRequest | undefined): Promise<MultiDoc[]> {
        let url_ = this.baseUrl + "/api/Document/GetMultiDocFormatAsString";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMultiDocFormatAsString(_response);
        });
    }

    protected processGetMultiDocFormatAsString(response: Response): Promise<MultiDoc[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MultiDoc[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiDoc[]>(null as any);
    }

    /**
     * Récupère le document suivant du PS connecté
     * @param body (optional) Contenu de la requête
     * @return OK
     */
    getNextDocConvTypesWithLastRead(body?: GetNextDocConvTypesWithLastReadRequest | undefined): Promise<MetadataMultiDoc> {
        let url_ = this.baseUrl + "/api/Document/GetNextDocConvTypesWithLastRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNextDocConvTypesWithLastRead(_response);
        });
    }

    protected processGetNextDocConvTypesWithLastRead(response: Response): Promise<MetadataMultiDoc> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MetadataMultiDoc;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MetadataMultiDoc>(null as any);
    }

    /**
     * Récupère les informations du premier document à partir duquel une synchro doit être faite
     * @param body (optional) Données de la requête
     * @return OK
     */
    getInfosDocInitial(body?: GetInfosDocInitialRequest | undefined): Promise<InfosDoc> {
        let url_ = this.baseUrl + "/api/Document/GetInfosDocInitial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInfosDocInitial(_response);
        });
    }

    protected processGetInfosDocInitial(response: Response): Promise<InfosDoc> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InfosDoc;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InfosDoc>(null as any);
    }
}

export interface IDocumentTravailClient {

    /**
     * Récupération d’une liste de documents de travail
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param ippr (optional) Identifiant du patient
     * @param body (optional) 
     * @return OK
     */
    getListeDocumentsTravail(idTechPsIdentifie: string, ippr?: string | undefined, body?: InfoPsIdentifie[] | undefined,  cancelToken?: CancelToken): Promise<DocumentTravailWithSource[]>;

    /**
     * Récupération d’un document de travail par son id
     * @param idDocumentTravail Identifiant du document de travail à récupérer
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param typeMessagerie (optional) 
     * @return OK
     */
    getDocumentTravailById(idDocumentTravail: string, idTechPsIdentifie: string, typeMessagerie?: MessagerieType | undefined,  cancelToken?: CancelToken): Promise<DocumentTravail>;

    /**
     * Envoie d’un document de travail
     * @param idDocumentTravail Identifiant du document de travail à envoyer
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param ippr (optional) 
     * @param idLocalDoc (optional) 
     * @param typeMessagerie (optional) 
     * @return OK
     */
    send(idDocumentTravail: string, idTechPsIdentifie: string, idEvnPlanning: number, domaineIdLocalDoc: number, ippr?: string | undefined, idLocalDoc?: string | undefined, typeMessagerie?: MessagerieType | undefined,  cancelToken?: CancelToken): Promise<DocumentTravailSendResult>;

    /**
     * Envoi d'une demande d'avis à partir d'un document de travail
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param idDocumentTravail Identifiant du document de travail à envoyer
     * @param idTechPsExpert Destinataire de la demande
     * @param modeEquipeRessource false (par défaut) pour demande d'expertise, true si si send a une equipe ressource
     * @param typeMessagerie (optional) 
     * @param numeroSecuriteSocialePatient (optional) numéro de sécurité sociale du patient
     * @return OK
     */
    sendDemandeAvis(idTechPsIdentifie: string, idDocumentTravail: string, idTechPsExpert: string, modeEquipeRessource: boolean, typeMessagerie?: MessagerieType | undefined, numeroSecuriteSocialePatient?: string | undefined,  cancelToken?: CancelToken): Promise<DocumentTravailSendResult>;

    /**
     * Envoi réponse à un auteur de doc
     * @param body (optional) contient idtechps identifié et les infos pour faire la réponse à 'auteur du doc
     * @return OK
     */
    sendReponseAuteur(body?: ReponseInfosRequest | undefined,  cancelToken?: CancelToken): Promise<DocumentTravailSendResult>;

    /**
     * Création d’un document de travail lors de l’ajout d’une pièce jointe
     * @param body (optional) Requête.
     * @return OK
     */
    createDocumentTravail(body?: CreateDocumentTravailRequest | undefined,  cancelToken?: CancelToken): Promise<DocumentTravail>;

    /**
     * Création d'un document de travail pour préparer la création d'une conversation de sollicitation
     * @param body (optional) Données nécessaires à la création du document de travail
     * @return Created
     */
    createDocumentTravailSollicitation(body?: CreateDocumentTravailSollicitationRequest | undefined,  cancelToken?: CancelToken): Promise<DocumentTravail>;

    /**
     * Modification d'un document de travail
     * @param body (optional) 
     * @return OK
     */
    updateDocumentTravail(body?: UpdateDocumentTravailRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Supprime un document de travail via son id
     * @param body (optional) Requête.
     * @return OK
     */
    deleteDocumentTravail(body?: DeleteDocumentTravailRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Transfere un document
     * @param idTechPsIdentifie (optional) 
     * @param body (optional) requête comportant
     * @return OK
     * @deprecated
     */
    transfererDocument(idTechPsIdentifie?: string | undefined, body?: TransfererDocumentRequest | undefined,  cancelToken?: CancelToken): Promise<DocumentTravailSendResult>;

    /**
     * Envoi d'un message en récupérant le contenu d'un ou plusieurs fichiers avec les idLocal / idEts d'un doc existant
     * @param idTechPsIdentifie (optional) Param depuis les anciennes version MSB qui est automatiquement envoyé par le ajax.js
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    transfererDocuments(idTechPsIdentifie?: string | undefined, body?: TransfererDocumentsRequest | undefined,  cancelToken?: CancelToken): Promise<DocumentTravailSendResult>;

    /**
     * Envoi d'un document à une conversation spécifique
     * @param idTechPsIdentifie (optional) Param depuis les anciennes version MSB qui est automatiquement envoyé par le ajax.js
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    sendDocumentToConversation(idTechPsIdentifie?: string | undefined, body?: SendDocumentToConversationRequest | undefined,  cancelToken?: CancelToken): Promise<DocumentTravailSendResult>;
}

export class DocumentTravailClient extends AuthorizedApiBase implements IDocumentTravailClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Récupération d’une liste de documents de travail
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param ippr (optional) Identifiant du patient
     * @param body (optional) 
     * @return OK
     */
    getListeDocumentsTravail(idTechPsIdentifie: string, ippr?: string | undefined, body?: InfoPsIdentifie[] | undefined): Promise<DocumentTravailWithSource[]> {
        let url_ = this.baseUrl + "/api/DocumentTravail/GetListeDocumentsTravail?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (ippr === null)
            throw new globalThis.Error("The parameter 'ippr' cannot be null.");
        else if (ippr !== undefined)
            url_ += "ippr=" + encodeURIComponent("" + ippr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListeDocumentsTravail(_response);
        });
    }

    protected processGetListeDocumentsTravail(response: Response): Promise<DocumentTravailWithSource[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravailWithSource[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravailWithSource[]>(null as any);
    }

    /**
     * Récupération d’un document de travail par son id
     * @param idDocumentTravail Identifiant du document de travail à récupérer
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param typeMessagerie (optional) 
     * @return OK
     */
    getDocumentTravailById(idDocumentTravail: string, idTechPsIdentifie: string, typeMessagerie?: MessagerieType | undefined): Promise<DocumentTravail> {
        let url_ = this.baseUrl + "/api/DocumentTravail/GetDocumentTravailById?";
        if (idDocumentTravail === undefined || idDocumentTravail === null)
            throw new globalThis.Error("The parameter 'idDocumentTravail' must be defined and cannot be null.");
        else
            url_ += "idDocumentTravail=" + encodeURIComponent("" + idDocumentTravail) + "&";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (typeMessagerie === null)
            throw new globalThis.Error("The parameter 'typeMessagerie' cannot be null.");
        else if (typeMessagerie !== undefined)
            url_ += "typeMessagerie=" + encodeURIComponent("" + typeMessagerie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentTravailById(_response);
        });
    }

    protected processGetDocumentTravailById(response: Response): Promise<DocumentTravail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravail;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravail>(null as any);
    }

    /**
     * Envoie d’un document de travail
     * @param idDocumentTravail Identifiant du document de travail à envoyer
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param ippr (optional) 
     * @param idLocalDoc (optional) 
     * @param typeMessagerie (optional) 
     * @return OK
     */
    send(idDocumentTravail: string, idTechPsIdentifie: string, idEvnPlanning: number, domaineIdLocalDoc: number, ippr?: string | undefined, idLocalDoc?: string | undefined, typeMessagerie?: MessagerieType | undefined): Promise<DocumentTravailSendResult> {
        let url_ = this.baseUrl + "/api/DocumentTravail/Send?";
        if (idDocumentTravail === undefined || idDocumentTravail === null)
            throw new globalThis.Error("The parameter 'idDocumentTravail' must be defined and cannot be null.");
        else
            url_ += "idDocumentTravail=" + encodeURIComponent("" + idDocumentTravail) + "&";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (idEvnPlanning === undefined || idEvnPlanning === null)
            throw new globalThis.Error("The parameter 'idEvnPlanning' must be defined and cannot be null.");
        else
            url_ += "idEvnPlanning=" + encodeURIComponent("" + idEvnPlanning) + "&";
        if (domaineIdLocalDoc === undefined || domaineIdLocalDoc === null)
            throw new globalThis.Error("The parameter 'domaineIdLocalDoc' must be defined and cannot be null.");
        else
            url_ += "domaineIdLocalDoc=" + encodeURIComponent("" + domaineIdLocalDoc) + "&";
        if (ippr === null)
            throw new globalThis.Error("The parameter 'ippr' cannot be null.");
        else if (ippr !== undefined)
            url_ += "ippr=" + encodeURIComponent("" + ippr) + "&";
        if (idLocalDoc === null)
            throw new globalThis.Error("The parameter 'idLocalDoc' cannot be null.");
        else if (idLocalDoc !== undefined)
            url_ += "idLocalDoc=" + encodeURIComponent("" + idLocalDoc) + "&";
        if (typeMessagerie === null)
            throw new globalThis.Error("The parameter 'typeMessagerie' cannot be null.");
        else if (typeMessagerie !== undefined)
            url_ += "typeMessagerie=" + encodeURIComponent("" + typeMessagerie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSend(_response);
        });
    }

    protected processSend(response: Response): Promise<DocumentTravailSendResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravailSendResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravailSendResult>(null as any);
    }

    /**
     * Envoi d'une demande d'avis à partir d'un document de travail
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param idDocumentTravail Identifiant du document de travail à envoyer
     * @param idTechPsExpert Destinataire de la demande
     * @param modeEquipeRessource false (par défaut) pour demande d'expertise, true si si send a une equipe ressource
     * @param typeMessagerie (optional) 
     * @param numeroSecuriteSocialePatient (optional) numéro de sécurité sociale du patient
     * @return OK
     */
    sendDemandeAvis(idTechPsIdentifie: string, idDocumentTravail: string, idTechPsExpert: string, modeEquipeRessource: boolean, typeMessagerie?: MessagerieType | undefined, numeroSecuriteSocialePatient?: string | undefined): Promise<DocumentTravailSendResult> {
        let url_ = this.baseUrl + "/api/DocumentTravail/SendDemandeAvis?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (idDocumentTravail === undefined || idDocumentTravail === null)
            throw new globalThis.Error("The parameter 'idDocumentTravail' must be defined and cannot be null.");
        else
            url_ += "idDocumentTravail=" + encodeURIComponent("" + idDocumentTravail) + "&";
        if (idTechPsExpert === undefined || idTechPsExpert === null)
            throw new globalThis.Error("The parameter 'idTechPsExpert' must be defined and cannot be null.");
        else
            url_ += "idTechPsExpert=" + encodeURIComponent("" + idTechPsExpert) + "&";
        if (modeEquipeRessource === undefined || modeEquipeRessource === null)
            throw new globalThis.Error("The parameter 'modeEquipeRessource' must be defined and cannot be null.");
        else
            url_ += "modeEquipeRessource=" + encodeURIComponent("" + modeEquipeRessource) + "&";
        if (typeMessagerie === null)
            throw new globalThis.Error("The parameter 'typeMessagerie' cannot be null.");
        else if (typeMessagerie !== undefined)
            url_ += "typeMessagerie=" + encodeURIComponent("" + typeMessagerie) + "&";
        if (numeroSecuriteSocialePatient === null)
            throw new globalThis.Error("The parameter 'numeroSecuriteSocialePatient' cannot be null.");
        else if (numeroSecuriteSocialePatient !== undefined)
            url_ += "numeroSecuriteSocialePatient=" + encodeURIComponent("" + numeroSecuriteSocialePatient) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendDemandeAvis(_response);
        });
    }

    protected processSendDemandeAvis(response: Response): Promise<DocumentTravailSendResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravailSendResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravailSendResult>(null as any);
    }

    /**
     * Envoi réponse à un auteur de doc
     * @param body (optional) contient idtechps identifié et les infos pour faire la réponse à 'auteur du doc
     * @return OK
     */
    sendReponseAuteur(body?: ReponseInfosRequest | undefined): Promise<DocumentTravailSendResult> {
        let url_ = this.baseUrl + "/api/DocumentTravail/SendReponseAuteur";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendReponseAuteur(_response);
        });
    }

    protected processSendReponseAuteur(response: Response): Promise<DocumentTravailSendResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravailSendResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravailSendResult>(null as any);
    }

    /**
     * Création d’un document de travail lors de l’ajout d’une pièce jointe
     * @param body (optional) Requête.
     * @return OK
     */
    createDocumentTravail(body?: CreateDocumentTravailRequest | undefined): Promise<DocumentTravail> {
        let url_ = this.baseUrl + "/api/DocumentTravail/CreateDocumentTravail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDocumentTravail(_response);
        });
    }

    protected processCreateDocumentTravail(response: Response): Promise<DocumentTravail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravail;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravail>(null as any);
    }

    /**
     * Création d'un document de travail pour préparer la création d'une conversation de sollicitation
     * @param body (optional) Données nécessaires à la création du document de travail
     * @return Created
     */
    createDocumentTravailSollicitation(body?: CreateDocumentTravailSollicitationRequest | undefined): Promise<DocumentTravail> {
        let url_ = this.baseUrl + "/api/DocumentTravail/sollicitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDocumentTravailSollicitation(_response);
        });
    }

    protected processCreateDocumentTravailSollicitation(response: Response): Promise<DocumentTravail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravail;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravail>(null as any);
    }

    /**
     * Modification d'un document de travail
     * @param body (optional) 
     * @return OK
     */
    updateDocumentTravail(body?: UpdateDocumentTravailRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DocumentTravail/UpdateDocumentTravail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDocumentTravail(_response);
        });
    }

    protected processUpdateDocumentTravail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Supprime un document de travail via son id
     * @param body (optional) Requête.
     * @return OK
     */
    deleteDocumentTravail(body?: DeleteDocumentTravailRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DocumentTravail/DeleteDocumentTravail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDocumentTravail(_response);
        });
    }

    protected processDeleteDocumentTravail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Transfere un document
     * @param idTechPsIdentifie (optional) 
     * @param body (optional) requête comportant
     * @return OK
     * @deprecated
     */
    transfererDocument(idTechPsIdentifie?: string | undefined, body?: TransfererDocumentRequest | undefined): Promise<DocumentTravailSendResult> {
        let url_ = this.baseUrl + "/api/DocumentTravail/TransfererDocument?";
        if (idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' cannot be null.");
        else if (idTechPsIdentifie !== undefined)
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTransfererDocument(_response);
        });
    }

    protected processTransfererDocument(response: Response): Promise<DocumentTravailSendResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravailSendResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravailSendResult>(null as any);
    }

    /**
     * Envoi d'un message en récupérant le contenu d'un ou plusieurs fichiers avec les idLocal / idEts d'un doc existant
     * @param idTechPsIdentifie (optional) Param depuis les anciennes version MSB qui est automatiquement envoyé par le ajax.js
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    transfererDocuments(idTechPsIdentifie?: string | undefined, body?: TransfererDocumentsRequest | undefined): Promise<DocumentTravailSendResult> {
        let url_ = this.baseUrl + "/api/DocumentTravail/TransfererDocuments?";
        if (idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' cannot be null.");
        else if (idTechPsIdentifie !== undefined)
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTransfererDocuments(_response);
        });
    }

    protected processTransfererDocuments(response: Response): Promise<DocumentTravailSendResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravailSendResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravailSendResult>(null as any);
    }

    /**
     * Envoi d'un document à une conversation spécifique
     * @param idTechPsIdentifie (optional) Param depuis les anciennes version MSB qui est automatiquement envoyé par le ajax.js
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    sendDocumentToConversation(idTechPsIdentifie?: string | undefined, body?: SendDocumentToConversationRequest | undefined): Promise<DocumentTravailSendResult> {
        let url_ = this.baseUrl + "/api/DocumentTravail/SendDocumentToConversation?";
        if (idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' cannot be null.");
        else if (idTechPsIdentifie !== undefined)
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendDocumentToConversation(_response);
        });
    }

    protected processSendDocumentToConversation(response: Response): Promise<DocumentTravailSendResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravailSendResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravailSendResult>(null as any);
    }
}

export interface IDossierPatientClient {

    /**
     * Récupérer un dossier patient par son IPPR
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param idPatient IPPL
     * @param idDomaine id SIH de l'établissement
     * @return OK
     */
    recupererDossierParIdentifiantPatient(idTechPsIdentifie: string, idPatient: string, idDomaine: number,  cancelToken?: CancelToken): Promise<Patient>;

    /**
     * Rechercher Patient Utilisateur Par IPPR
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param ippr Identifiant du patient.
     * @return OK
     */
    rechercherPatientMyHopParIPPR(idTechPsIdentifie: string, ippr: string,  cancelToken?: CancelToken): Promise<boolean>;

    /**
     * Vérifie s'il existe un dossier patient pour un ippr donné
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param ippr Identifiant du patient
     * @return OK
     */
    doesDossierPatientExistAndIsSupprime(idTechPsIdentifie: string, ippr: string,  cancelToken?: CancelToken): Promise<boolean>;

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompteViaPatient(body?: CreateCompteViaPatientRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class DossierPatientClient extends AuthorizedApiBase implements IDossierPatientClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Récupérer un dossier patient par son IPPR
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param idPatient IPPL
     * @param idDomaine id SIH de l'établissement
     * @return OK
     */
    recupererDossierParIdentifiantPatient(idTechPsIdentifie: string, idPatient: string, idDomaine: number): Promise<Patient> {
        let url_ = this.baseUrl + "/api/DossierPatient/RecupererDossierParIdentifiantPatient?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (idPatient === undefined || idPatient === null)
            throw new globalThis.Error("The parameter 'idPatient' must be defined and cannot be null.");
        else
            url_ += "idPatient=" + encodeURIComponent("" + idPatient) + "&";
        if (idDomaine === undefined || idDomaine === null)
            throw new globalThis.Error("The parameter 'idDomaine' must be defined and cannot be null.");
        else
            url_ += "idDomaine=" + encodeURIComponent("" + idDomaine) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecupererDossierParIdentifiantPatient(_response);
        });
    }

    protected processRecupererDossierParIdentifiantPatient(response: Response): Promise<Patient> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Patient;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Patient>(null as any);
    }

    /**
     * Rechercher Patient Utilisateur Par IPPR
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param ippr Identifiant du patient.
     * @return OK
     */
    rechercherPatientMyHopParIPPR(idTechPsIdentifie: string, ippr: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DossierPatient/RechercherPatientMyHopParIPPR?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (ippr === undefined || ippr === null)
            throw new globalThis.Error("The parameter 'ippr' must be defined and cannot be null.");
        else
            url_ += "ippr=" + encodeURIComponent("" + ippr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRechercherPatientMyHopParIPPR(_response);
        });
    }

    protected processRechercherPatientMyHopParIPPR(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Vérifie s'il existe un dossier patient pour un ippr donné
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param ippr Identifiant du patient
     * @return OK
     */
    doesDossierPatientExistAndIsSupprime(idTechPsIdentifie: string, ippr: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DossierPatient/DoesDossierPatientExistAndIsSupprime?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (ippr === undefined || ippr === null)
            throw new globalThis.Error("The parameter 'ippr' must be defined and cannot be null.");
        else
            url_ += "ippr=" + encodeURIComponent("" + ippr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDoesDossierPatientExistAndIsSupprime(_response);
        });
    }

    protected processDoesDossierPatientExistAndIsSupprime(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createCompteViaPatient(body?: CreateCompteViaPatientRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DossierPatient/CreateCompteViaPatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompteViaPatient(_response);
        });
    }

    protected processCreateCompteViaPatient(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IFichierTravailClient {

    /**
     * Récupération d'un fichier de travail par son id
     * @param idFichierTravail Identifiant du fichier à récupérer
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param typeMessagerie (optional) 
     * @return OK
     */
    getFichierTravailById(idFichierTravail: string, idTechPsIdentifie: string, typeMessagerie?: MessagerieType | undefined,  cancelToken?: CancelToken): Promise<FichierTravail>;

    /**
     * Création d'un fichier de travail
     * @param body (optional) Requête
     * @return OK
     * @deprecated
     */
    createFichierTravail(body?: CreateFichierTravailRequest | undefined,  cancelToken?: CancelToken): Promise<string>;

    /**
     * Mise à jour d'un fichier de travail
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    updateFichierTravail(body?: UpdateFichierTravailRequest | undefined,  cancelToken?: CancelToken): Promise<string>;

    /**
     * Supprime un document de travail via son id
     * @param body (optional) Requête.
     * @return OK
     * @deprecated
     */
    deleteFichierTravail(body?: DeleteFichierTravailRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Création d'un fichier de travail en affectant à fichierTravail.ContenuFichierTravail les données téléchargé depuis l'url
     * @param body (optional) 
     * @return OK
     */
    createFichierTravailFromUrl(body?: CreateFichierTravailFromUrlRequest | undefined,  cancelToken?: CancelToken): Promise<string>;

    /**
     * Mise à jour du nom d'un fichier de travail
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    updateNomFichierTravail(body?: UpdateNomFichierTravailRequest | undefined,  cancelToken?: CancelToken): Promise<number>;
}

export class FichierTravailClient extends AuthorizedApiBase implements IFichierTravailClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Récupération d'un fichier de travail par son id
     * @param idFichierTravail Identifiant du fichier à récupérer
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param typeMessagerie (optional) 
     * @return OK
     */
    getFichierTravailById(idFichierTravail: string, idTechPsIdentifie: string, typeMessagerie?: MessagerieType | undefined): Promise<FichierTravail> {
        let url_ = this.baseUrl + "/api/FichierTravail/GetFichierTravailById?";
        if (idFichierTravail === undefined || idFichierTravail === null)
            throw new globalThis.Error("The parameter 'idFichierTravail' must be defined and cannot be null.");
        else
            url_ += "idFichierTravail=" + encodeURIComponent("" + idFichierTravail) + "&";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (typeMessagerie === null)
            throw new globalThis.Error("The parameter 'typeMessagerie' cannot be null.");
        else if (typeMessagerie !== undefined)
            url_ += "typeMessagerie=" + encodeURIComponent("" + typeMessagerie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFichierTravailById(_response);
        });
    }

    protected processGetFichierTravailById(response: Response): Promise<FichierTravail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FichierTravail;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FichierTravail>(null as any);
    }

    /**
     * Création d'un fichier de travail
     * @param body (optional) Requête
     * @return OK
     * @deprecated
     */
    createFichierTravail(body?: CreateFichierTravailRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/FichierTravail/CreateFichierTravail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFichierTravail(_response);
        });
    }

    protected processCreateFichierTravail(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : _responseText as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Mise à jour d'un fichier de travail
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    updateFichierTravail(body?: UpdateFichierTravailRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/FichierTravail/UpdateFichierTravail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFichierTravail(_response);
        });
    }

    protected processUpdateFichierTravail(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : _responseText as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Supprime un document de travail via son id
     * @param body (optional) Requête.
     * @return OK
     * @deprecated
     */
    deleteFichierTravail(body?: DeleteFichierTravailRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/FichierTravail/DeleteFichierTravail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFichierTravail(_response);
        });
    }

    protected processDeleteFichierTravail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Création d'un fichier de travail en affectant à fichierTravail.ContenuFichierTravail les données téléchargé depuis l'url
     * @param body (optional) 
     * @return OK
     */
    createFichierTravailFromUrl(body?: CreateFichierTravailFromUrlRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/FichierTravail/CreateFichierTravailFromUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFichierTravailFromUrl(_response);
        });
    }

    protected processCreateFichierTravailFromUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : _responseText as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Mise à jour du nom d'un fichier de travail
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    updateNomFichierTravail(body?: UpdateNomFichierTravailRequest | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/FichierTravail/UpdateNomFichierTravail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNomFichierTravail(_response);
        });
    }

    protected processUpdateNomFichierTravail(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IJournalClient {

    /**
     * Récupérer les derniers dossiers patient consultés par le PS connecté.
     * @param nbMax Nombre maximum de dossiers patient à récupérer
     * @return OK
     */
    getDerniersDossiersConsultes(nbMax: number,  cancelToken?: CancelToken): Promise<Patient[]>;
}

export class JournalClient extends AuthorizedApiBase implements IJournalClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Récupérer les derniers dossiers patient consultés par le PS connecté.
     * @param nbMax Nombre maximum de dossiers patient à récupérer
     * @return OK
     */
    getDerniersDossiersConsultes(nbMax: number): Promise<Patient[]> {
        let url_ = this.baseUrl + "/api/Journal/GetDerniersDossiersConsultes?";
        if (nbMax === undefined || nbMax === null)
            throw new globalThis.Error("The parameter 'nbMax' must be defined and cannot be null.");
        else
            url_ += "nbMax=" + encodeURIComponent("" + nbMax) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDerniersDossiersConsultes(_response);
        });
    }

    protected processGetDerniersDossiersConsultes(response: Response): Promise<Patient[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Patient[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Patient[]>(null as any);
    }
}

export interface IMessagerieClient {

    /**
     * Récupère le nombre de conversations avec des échanges non lus pour un tech PS par type de conversations
     * @param idTechPsCible (optional) Identifiat du PS sélectionnné ou null si toutes les boites
     * @return OK
     * @deprecated
     */
    getCountNbConvNonLusParMenu(idTechPsCible?: string | undefined,  cancelToken?: CancelToken): Promise<CountConversationsNonLu[]>;

    /**
     * Renvoie toutes les conversations pour un PS
     * @param body (optional) Contient les données permettant de récupérer les conversations d'un PS
     * @return OK
     * @deprecated
     */
    getListeConversationsByIdTechPs(body?: GetListeConversationsByIdTechPsRequest | undefined,  cancelToken?: CancelToken): Promise<ConversationLight[]>;

    /**
     * Récupère le détail d'une conversation : liste des échanges, destinataires, ...
     * @param idTechPsIdentifie Identifiant du PS déléguant pour lequel l'utilisateur travaille
     * @param idConversation Identifiant de la conversation à récupérer
     * @param marquerCommeLu Indication s'il faut marquer la conversation en lue pour le PS identifié
     * @return OK
     * @deprecated
     */
    getDetailConversationById(idTechPsIdentifie: string, idConversation: string, marquerCommeLu: boolean, depuisMP: boolean, type: ConversationType,  cancelToken?: CancelToken): Promise<ConversationDetail>;

    /**
     * Récupère le nombre d'échange non lus pour la boite de réception ou pour une conversation
     * @param type Filtre sur le type de conversation
     * @param dateDebut (optional) Optimisation : ne vérifie que les conv qui postérieures à cette date
     * @param idConversation (optional) si passé, contexte conversation
     * @return OK
     * @deprecated
     */
    getCountNbEchangesNonLus(idTechPs: string, type: ConversationType, dateDebut?: Date | undefined, idConversation?: string | undefined,  cancelToken?: CancelToken): Promise<CountEchangesNonLu>;

    /**
     * Récupère les métadonnées des documents de la conversation (Libelle / IdLocalDoc / IdEts...)
     * @param idConversation Identifiant de la conversation à récupérer
     * @param emailMssPsIdentifie (optional) 
     * @param source (optional) 
     * @return OK
     */
    getListeDocumentsByConversationId(idTechPsIdentifie: string, idConversation: string, type: ConversationType, emailMssPsIdentifie?: string | undefined, source?: ConversationSource | undefined,  cancelToken?: CancelToken): Promise<WebmailMessageDocument[]>;

    /**
     * Récupère la première conversation avec le patient
     * @param idTechPsIdentifie idTechPsIdentifie
     * @param ippr ippr
     * @param type type de la conversation
     * @return La conversation
     * @deprecated
     */
    getFirstConversationWithPatient(idTechPsIdentifie: string, ippr: string, type: ConversationType,  cancelToken?: CancelToken): Promise<ConversationLight>;

    /**
     * Permet de mettre à jour le statut d'une conversation pour un utilisateur
     * @param body (optional) Requête contenant les statuts de la conversation à mettre à jour
     * @return OK
     */
    updateStatutConversation(body?: UpdateStatutConversationRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Génére un échange contenant la synthèse de la conversation
     * @param body (optional) Objet contenant les données nécessaires à la synthèse d'une conversation
     * @return OK
     */
    syntheseConversation(body?: SyntheseConversationRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Génére un échange contenant la synthèse de la conversation
     * @param body (optional) Objet contenant les données nécessaires à la synthèse d'une conversation
     * @return OK
     */
    syntheseConversationTLE(body?: SyntheseConversationTLERequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Démarre une visioconférence
     * @param body (optional) Contient les données nécessaires pour démarrer la visio
     * @return OK
     */
    startVisio(body?: StartVisioRequest | undefined,  cancelToken?: CancelToken): Promise<string>;

    /**
     * Quitter la conversation (Mettre à jour la date de fin de participation)
     * @param body (optional) Contient les données nécessaires pour qu'un PS puisse quitter une conversation
     * @return OK
     */
    leaveConversation(body?: LeaveConversationRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Modifie le titre de la conversation
     * @param body (optional) Contient les données permettant de modifier le titre de la conversation
     * @return OK
     */
    updateConversationContenu(body?: UpdateConversationContenuRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Marque toutes les conversations de l'utilisateur comme lues/archivées
     * @param body (optional) Contient les données permettant de mettre à jour les conversations de l'utilisateur
     * @return No Content
     * @deprecated
     */
    updateConversationsUtilisateur(body?: UpdateConversationsUtilisateurRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Autorise ou non un patient à répondre à une conversation
     * @param body (optional) 
     * @return OK
     */
    setConversationEchangePatientPeutRepondre(body?: SetPatientPeutRepondreRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Renvoie toutes les conversations pour un PS
     * @param body (optional) Requête permettant de récupérer les conversations d'un PS
     * @return OK
     * @deprecated
     */
    getListeConversationsByIdTechPs_v2(body?: GetListeConversationsByIdTechPsV2Request | undefined,  cancelToken?: CancelToken): Promise<ConversationLight[]>;

    /**
     * Delete d'un message sur une conversation donnée
     * @param body (optional) 
     * @return OK
     */
    deleteEchange(body?: DeleteEchangeRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Récupère le détail d'une conversation : liste des échanges, destinataires, ...
     * @param emailMssPsIdentifie (optional) 
     * @param source (optional) 
     * @param marquerCommeLu (optional) 
     * @param depuisMP (optional) 
     * @param type (optional) 
     * @param typeMessagerie (optional) 
     * @param search (optional) 
     * @return OK
     */
    getDetailConversationByIdWithMss(idTechPsIdentifie: string, idConversation: string, pageSize: number, pageIndex: number, emailMssPsIdentifie?: string | undefined, source?: ConversationSource | undefined, marquerCommeLu?: boolean | undefined, depuisMP?: boolean | undefined, type?: ConversationType | undefined, typeMessagerie?: MessagerieType | undefined, search?: string | undefined,  cancelToken?: CancelToken): Promise<ConversationDetail>;

    /**
     * Renvoie les infos pour se connecter de manière sécurisée au serveur visio
     * @param roomName Nom de la salle de visio
     * @return OK
     */
    getInfosVisio(roomName: string,  cancelToken?: CancelToken): Promise<InfosVisioResult>;

    /**
     * Récupère le nombre de courriers MSS non lus pour un tech PS par type de conversation
     * @param idTechPsCible (optional) 
     * @return OK
     */
    getCountNbConvNonLusParMenuWithMss(idTechPsCible?: string | undefined,  cancelToken?: CancelToken): Promise<CountConversationsNonLu[]>;

    /**
     * Récupère le détail d'une ou plusieurs conversations : liste des échanges, destinataires, ...
     * @param typeMessagerie (optional) 
     * @param body (optional) Contient les données nécessaires à la récupération du détail de plusieurs conversations
     * @return OK
     */
    getConversationsByIds(typeMessagerie?: MessagerieType | undefined, body?: GetConversationsByIdsRequest | undefined,  cancelToken?: CancelToken): Promise<ConversationLight[]>;

    /**
     * Récupère les conversations correspondant au patient et PS en paramètre pour envoyer les conversationsBase correspondantes
     * @param body (optional) Contient les données pour renvoyer les conversations correspondant au patient et PS spécifiés en paramètre
     * @return OK
     */
    getConversationByPSAndPatient(body?: GetConversationByPSAndPatientRequest | undefined,  cancelToken?: CancelToken): Promise<ConversationLight[]>;

    /**
     * Récupère les conversations ayant au moins pour destinataires le PS identifié, la liste de PS et le patient
     * @param idTechPsList Liste d'identifiants des PS destinataires
     * @param pageSize Limite d'affichage de conversations
     * @param idTechPsIdentifie (optional) Identifiant du PS identifié
     * @param idPatient (optional) Identifiant du patient
     * @return OK
     */
    getListeConversationsWithDestinatairesAndPatient(idTechPsList: string[], pageSize: number, idTechPsIdentifie?: string | undefined, idPatient?: string | undefined,  cancelToken?: CancelToken): Promise<ConversationLight[]>;

    /**
     * Nouvelle méthode GetListeConversationsByIdTechPs pour les nouveaux acteurs ayant MSS
     * @param body (optional) Contient les données permettant de récupérer les conversations d'un acteur ayant MSS
     * @return OK
     * @deprecated
     */
    getListeConversationsByIdTechPs_v2_withMSS(body?: GetListeConversationsByIdTechPs_v2_withMSSRequest | undefined,  cancelToken?: CancelToken): Promise<ConversationLight[]>;

    /**
     * Permet d'envoyer un message dans une conversation au nom de l'auteur spécifié en paramètre. Un fichier peut être envoyé avec le message dans la conversation.
     * @param body (optional) Données nécessaires à l'ajout d'un message dans une conversation
     * @return Identifiant du message créé.
     */
    addMessageToConversation(body?: AddMessageToConversationRequest | undefined,  cancelToken?: CancelToken): Promise<number>;
}

export class MessagerieClient extends AuthorizedApiBase implements IMessagerieClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Récupère le nombre de conversations avec des échanges non lus pour un tech PS par type de conversations
     * @param idTechPsCible (optional) Identifiat du PS sélectionnné ou null si toutes les boites
     * @return OK
     * @deprecated
     */
    getCountNbConvNonLusParMenu(idTechPsCible?: string | undefined): Promise<CountConversationsNonLu[]> {
        let url_ = this.baseUrl + "/api/Messagerie/GetCountNbConvNonLusParMenu?";
        if (idTechPsCible === null)
            throw new globalThis.Error("The parameter 'idTechPsCible' cannot be null.");
        else if (idTechPsCible !== undefined)
            url_ += "idTechPsCible=" + encodeURIComponent("" + idTechPsCible) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCountNbConvNonLusParMenu(_response);
        });
    }

    protected processGetCountNbConvNonLusParMenu(response: Response): Promise<CountConversationsNonLu[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountConversationsNonLu[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountConversationsNonLu[]>(null as any);
    }

    /**
     * Renvoie toutes les conversations pour un PS
     * @param body (optional) Contient les données permettant de récupérer les conversations d'un PS
     * @return OK
     * @deprecated
     */
    getListeConversationsByIdTechPs(body?: GetListeConversationsByIdTechPsRequest | undefined): Promise<ConversationLight[]> {
        let url_ = this.baseUrl + "/api/Messagerie/GetListeConversationsByIdTechPs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListeConversationsByIdTechPs(_response);
        });
    }

    protected processGetListeConversationsByIdTechPs(response: Response): Promise<ConversationLight[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConversationLight[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationLight[]>(null as any);
    }

    /**
     * Récupère le détail d'une conversation : liste des échanges, destinataires, ...
     * @param idTechPsIdentifie Identifiant du PS déléguant pour lequel l'utilisateur travaille
     * @param idConversation Identifiant de la conversation à récupérer
     * @param marquerCommeLu Indication s'il faut marquer la conversation en lue pour le PS identifié
     * @return OK
     * @deprecated
     */
    getDetailConversationById(idTechPsIdentifie: string, idConversation: string, marquerCommeLu: boolean, depuisMP: boolean, type: ConversationType): Promise<ConversationDetail> {
        let url_ = this.baseUrl + "/api/Messagerie/GetDetailConversationById?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined and cannot be null.");
        else
            url_ += "idConversation=" + encodeURIComponent("" + idConversation) + "&";
        if (marquerCommeLu === undefined || marquerCommeLu === null)
            throw new globalThis.Error("The parameter 'marquerCommeLu' must be defined and cannot be null.");
        else
            url_ += "marquerCommeLu=" + encodeURIComponent("" + marquerCommeLu) + "&";
        if (depuisMP === undefined || depuisMP === null)
            throw new globalThis.Error("The parameter 'depuisMP' must be defined and cannot be null.");
        else
            url_ += "depuisMP=" + encodeURIComponent("" + depuisMP) + "&";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDetailConversationById(_response);
        });
    }

    protected processGetDetailConversationById(response: Response): Promise<ConversationDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConversationDetail;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationDetail>(null as any);
    }

    /**
     * Récupère le nombre d'échange non lus pour la boite de réception ou pour une conversation
     * @param type Filtre sur le type de conversation
     * @param dateDebut (optional) Optimisation : ne vérifie que les conv qui postérieures à cette date
     * @param idConversation (optional) si passé, contexte conversation
     * @return OK
     * @deprecated
     */
    getCountNbEchangesNonLus(idTechPs: string, type: ConversationType, dateDebut?: Date | undefined, idConversation?: string | undefined): Promise<CountEchangesNonLu> {
        let url_ = this.baseUrl + "/api/Messagerie/GetCountNbEchangesNonLus?";
        if (idTechPs === undefined || idTechPs === null)
            throw new globalThis.Error("The parameter 'idTechPs' must be defined and cannot be null.");
        else
            url_ += "idTechPs=" + encodeURIComponent("" + idTechPs) + "&";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (dateDebut === null)
            throw new globalThis.Error("The parameter 'dateDebut' cannot be null.");
        else if (dateDebut !== undefined)
            url_ += "dateDebut=" + encodeURIComponent(dateDebut ? "" + dateDebut.toISOString() : "") + "&";
        if (idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' cannot be null.");
        else if (idConversation !== undefined)
            url_ += "idConversation=" + encodeURIComponent("" + idConversation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCountNbEchangesNonLus(_response);
        });
    }

    protected processGetCountNbEchangesNonLus(response: Response): Promise<CountEchangesNonLu> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountEchangesNonLu;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountEchangesNonLu>(null as any);
    }

    /**
     * Récupère les métadonnées des documents de la conversation (Libelle / IdLocalDoc / IdEts...)
     * @param idConversation Identifiant de la conversation à récupérer
     * @param emailMssPsIdentifie (optional) 
     * @param source (optional) 
     * @return OK
     */
    getListeDocumentsByConversationId(idTechPsIdentifie: string, idConversation: string, type: ConversationType, emailMssPsIdentifie?: string | undefined, source?: ConversationSource | undefined): Promise<WebmailMessageDocument[]> {
        let url_ = this.baseUrl + "/api/Messagerie/GetListeDocumentsByConversationId?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined and cannot be null.");
        else
            url_ += "idConversation=" + encodeURIComponent("" + idConversation) + "&";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (emailMssPsIdentifie === null)
            throw new globalThis.Error("The parameter 'emailMssPsIdentifie' cannot be null.");
        else if (emailMssPsIdentifie !== undefined)
            url_ += "emailMssPsIdentifie=" + encodeURIComponent("" + emailMssPsIdentifie) + "&";
        if (source === null)
            throw new globalThis.Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListeDocumentsByConversationId(_response);
        });
    }

    protected processGetListeDocumentsByConversationId(response: Response): Promise<WebmailMessageDocument[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebmailMessageDocument[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebmailMessageDocument[]>(null as any);
    }

    /**
     * Récupère la première conversation avec le patient
     * @param idTechPsIdentifie idTechPsIdentifie
     * @param ippr ippr
     * @param type type de la conversation
     * @return La conversation
     * @deprecated
     */
    getFirstConversationWithPatient(idTechPsIdentifie: string, ippr: string, type: ConversationType): Promise<ConversationLight> {
        let url_ = this.baseUrl + "/api/Messagerie/GetFirstConversationWithPatient?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (ippr === undefined || ippr === null)
            throw new globalThis.Error("The parameter 'ippr' must be defined and cannot be null.");
        else
            url_ += "ippr=" + encodeURIComponent("" + ippr) + "&";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFirstConversationWithPatient(_response);
        });
    }

    protected processGetFirstConversationWithPatient(response: Response): Promise<ConversationLight> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConversationLight;
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("Dans le cas s\'il n\'y a aucune conversation", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationLight>(null as any);
    }

    /**
     * Permet de mettre à jour le statut d'une conversation pour un utilisateur
     * @param body (optional) Requête contenant les statuts de la conversation à mettre à jour
     * @return OK
     */
    updateStatutConversation(body?: UpdateStatutConversationRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Messagerie/UpdateStatutConversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateStatutConversation(_response);
        });
    }

    protected processUpdateStatutConversation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Génére un échange contenant la synthèse de la conversation
     * @param body (optional) Objet contenant les données nécessaires à la synthèse d'une conversation
     * @return OK
     */
    syntheseConversation(body?: SyntheseConversationRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Messagerie/SyntheseConversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSyntheseConversation(_response);
        });
    }

    protected processSyntheseConversation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Génére un échange contenant la synthèse de la conversation
     * @param body (optional) Objet contenant les données nécessaires à la synthèse d'une conversation
     * @return OK
     */
    syntheseConversationTLE(body?: SyntheseConversationTLERequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Messagerie/SyntheseConversationTLE";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSyntheseConversationTLE(_response);
        });
    }

    protected processSyntheseConversationTLE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Démarre une visioconférence
     * @param body (optional) Contient les données nécessaires pour démarrer la visio
     * @return OK
     */
    startVisio(body?: StartVisioRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Messagerie/StartVisio";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartVisio(_response);
        });
    }

    protected processStartVisio(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Quitter la conversation (Mettre à jour la date de fin de participation)
     * @param body (optional) Contient les données nécessaires pour qu'un PS puisse quitter une conversation
     * @return OK
     */
    leaveConversation(body?: LeaveConversationRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Messagerie/LeaveConversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLeaveConversation(_response);
        });
    }

    protected processLeaveConversation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Modifie le titre de la conversation
     * @param body (optional) Contient les données permettant de modifier le titre de la conversation
     * @return OK
     */
    updateConversationContenu(body?: UpdateConversationContenuRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Messagerie/UpdateConversationContenu";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateConversationContenu(_response);
        });
    }

    protected processUpdateConversationContenu(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Marque toutes les conversations de l'utilisateur comme lues/archivées
     * @param body (optional) Contient les données permettant de mettre à jour les conversations de l'utilisateur
     * @return No Content
     * @deprecated
     */
    updateConversationsUtilisateur(body?: UpdateConversationsUtilisateurRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Messagerie/UpdateConversationsUtilisateur";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateConversationsUtilisateur(_response);
        });
    }

    protected processUpdateConversationsUtilisateur(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("La requ\u00eate ne contient aucune action \u00e0 effectuer", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Autorise ou non un patient à répondre à une conversation
     * @param body (optional) 
     * @return OK
     */
    setConversationEchangePatientPeutRepondre(body?: SetPatientPeutRepondreRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Messagerie/SetConversationEchangePatientPeutRepondre";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetConversationEchangePatientPeutRepondre(_response);
        });
    }

    protected processSetConversationEchangePatientPeutRepondre(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Renvoie toutes les conversations pour un PS
     * @param body (optional) Requête permettant de récupérer les conversations d'un PS
     * @return OK
     * @deprecated
     */
    getListeConversationsByIdTechPs_v2(body?: GetListeConversationsByIdTechPsV2Request | undefined): Promise<ConversationLight[]> {
        let url_ = this.baseUrl + "/api/Messagerie/GetListeConversationsByIdTechPs_v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListeConversationsByIdTechPs_v2(_response);
        });
    }

    protected processGetListeConversationsByIdTechPs_v2(response: Response): Promise<ConversationLight[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConversationLight[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationLight[]>(null as any);
    }

    /**
     * Delete d'un message sur une conversation donnée
     * @param body (optional) 
     * @return OK
     */
    deleteEchange(body?: DeleteEchangeRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Messagerie/DeleteEchange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteEchange(_response);
        });
    }

    protected processDeleteEchange(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Récupère le détail d'une conversation : liste des échanges, destinataires, ...
     * @param emailMssPsIdentifie (optional) 
     * @param source (optional) 
     * @param marquerCommeLu (optional) 
     * @param depuisMP (optional) 
     * @param type (optional) 
     * @param typeMessagerie (optional) 
     * @param search (optional) 
     * @return OK
     */
    getDetailConversationByIdWithMss(idTechPsIdentifie: string, idConversation: string, pageSize: number, pageIndex: number, emailMssPsIdentifie?: string | undefined, source?: ConversationSource | undefined, marquerCommeLu?: boolean | undefined, depuisMP?: boolean | undefined, type?: ConversationType | undefined, typeMessagerie?: MessagerieType | undefined, search?: string | undefined): Promise<ConversationDetail> {
        let url_ = this.baseUrl + "/api/Messagerie/GetDetailConversationByIdWithMss?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined and cannot be null.");
        else
            url_ += "idConversation=" + encodeURIComponent("" + idConversation) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageIndex === undefined || pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (emailMssPsIdentifie === null)
            throw new globalThis.Error("The parameter 'emailMssPsIdentifie' cannot be null.");
        else if (emailMssPsIdentifie !== undefined)
            url_ += "emailMssPsIdentifie=" + encodeURIComponent("" + emailMssPsIdentifie) + "&";
        if (source === null)
            throw new globalThis.Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        if (marquerCommeLu === null)
            throw new globalThis.Error("The parameter 'marquerCommeLu' cannot be null.");
        else if (marquerCommeLu !== undefined)
            url_ += "marquerCommeLu=" + encodeURIComponent("" + marquerCommeLu) + "&";
        if (depuisMP === null)
            throw new globalThis.Error("The parameter 'depuisMP' cannot be null.");
        else if (depuisMP !== undefined)
            url_ += "depuisMP=" + encodeURIComponent("" + depuisMP) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (typeMessagerie === null)
            throw new globalThis.Error("The parameter 'typeMessagerie' cannot be null.");
        else if (typeMessagerie !== undefined)
            url_ += "typeMessagerie=" + encodeURIComponent("" + typeMessagerie) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDetailConversationByIdWithMss(_response);
        });
    }

    protected processGetDetailConversationByIdWithMss(response: Response): Promise<ConversationDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConversationDetail;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationDetail>(null as any);
    }

    /**
     * Renvoie les infos pour se connecter de manière sécurisée au serveur visio
     * @param roomName Nom de la salle de visio
     * @return OK
     */
    getInfosVisio(roomName: string): Promise<InfosVisioResult> {
        let url_ = this.baseUrl + "/api/Messagerie/GetInfosVisio?";
        if (roomName === undefined || roomName === null)
            throw new globalThis.Error("The parameter 'roomName' must be defined and cannot be null.");
        else
            url_ += "roomName=" + encodeURIComponent("" + roomName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInfosVisio(_response);
        });
    }

    protected processGetInfosVisio(response: Response): Promise<InfosVisioResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InfosVisioResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InfosVisioResult>(null as any);
    }

    /**
     * Récupère le nombre de courriers MSS non lus pour un tech PS par type de conversation
     * @param idTechPsCible (optional) 
     * @return OK
     */
    getCountNbConvNonLusParMenuWithMss(idTechPsCible?: string | undefined): Promise<CountConversationsNonLu[]> {
        let url_ = this.baseUrl + "/api/Messagerie/GetCountNbConvNonLusParMenuWithMss?";
        if (idTechPsCible === null)
            throw new globalThis.Error("The parameter 'idTechPsCible' cannot be null.");
        else if (idTechPsCible !== undefined)
            url_ += "idTechPsCible=" + encodeURIComponent("" + idTechPsCible) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCountNbConvNonLusParMenuWithMss(_response);
        });
    }

    protected processGetCountNbConvNonLusParMenuWithMss(response: Response): Promise<CountConversationsNonLu[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountConversationsNonLu[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountConversationsNonLu[]>(null as any);
    }

    /**
     * Récupère le détail d'une ou plusieurs conversations : liste des échanges, destinataires, ...
     * @param typeMessagerie (optional) 
     * @param body (optional) Contient les données nécessaires à la récupération du détail de plusieurs conversations
     * @return OK
     */
    getConversationsByIds(typeMessagerie?: MessagerieType | undefined, body?: GetConversationsByIdsRequest | undefined): Promise<ConversationLight[]> {
        let url_ = this.baseUrl + "/api/Messagerie/GetConversationsByIds?";
        if (typeMessagerie === null)
            throw new globalThis.Error("The parameter 'typeMessagerie' cannot be null.");
        else if (typeMessagerie !== undefined)
            url_ += "typeMessagerie=" + encodeURIComponent("" + typeMessagerie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConversationsByIds(_response);
        });
    }

    protected processGetConversationsByIds(response: Response): Promise<ConversationLight[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConversationLight[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationLight[]>(null as any);
    }

    /**
     * Récupère les conversations correspondant au patient et PS en paramètre pour envoyer les conversationsBase correspondantes
     * @param body (optional) Contient les données pour renvoyer les conversations correspondant au patient et PS spécifiés en paramètre
     * @return OK
     */
    getConversationByPSAndPatient(body?: GetConversationByPSAndPatientRequest | undefined): Promise<ConversationLight[]> {
        let url_ = this.baseUrl + "/api/Messagerie/GetConversationByPSAndPatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConversationByPSAndPatient(_response);
        });
    }

    protected processGetConversationByPSAndPatient(response: Response): Promise<ConversationLight[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConversationLight[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationLight[]>(null as any);
    }

    /**
     * Récupère les conversations ayant au moins pour destinataires le PS identifié, la liste de PS et le patient
     * @param idTechPsList Liste d'identifiants des PS destinataires
     * @param pageSize Limite d'affichage de conversations
     * @param idTechPsIdentifie (optional) Identifiant du PS identifié
     * @param idPatient (optional) Identifiant du patient
     * @return OK
     */
    getListeConversationsWithDestinatairesAndPatient(idTechPsList: string[], pageSize: number, idTechPsIdentifie?: string | undefined, idPatient?: string | undefined): Promise<ConversationLight[]> {
        let url_ = this.baseUrl + "/api/Messagerie/GetListeConversationsWithDestinatairesAndPatient?";
        if (idTechPsList === undefined || idTechPsList === null)
            throw new globalThis.Error("The parameter 'idTechPsList' must be defined and cannot be null.");
        else
            idTechPsList && idTechPsList.forEach(item => { url_ += "idTechPsList=" + encodeURIComponent("" + item) + "&"; });
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' cannot be null.");
        else if (idTechPsIdentifie !== undefined)
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (idPatient === null)
            throw new globalThis.Error("The parameter 'idPatient' cannot be null.");
        else if (idPatient !== undefined)
            url_ += "idPatient=" + encodeURIComponent("" + idPatient) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListeConversationsWithDestinatairesAndPatient(_response);
        });
    }

    protected processGetListeConversationsWithDestinatairesAndPatient(response: Response): Promise<ConversationLight[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConversationLight[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationLight[]>(null as any);
    }

    /**
     * Nouvelle méthode GetListeConversationsByIdTechPs pour les nouveaux acteurs ayant MSS
     * @param body (optional) Contient les données permettant de récupérer les conversations d'un acteur ayant MSS
     * @return OK
     * @deprecated
     */
    getListeConversationsByIdTechPs_v2_withMSS(body?: GetListeConversationsByIdTechPs_v2_withMSSRequest | undefined): Promise<ConversationLight[]> {
        let url_ = this.baseUrl + "/api/Messagerie/GetListeConversationsByIdTechPs_v2_withMSS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListeConversationsByIdTechPs_v2_withMSS(_response);
        });
    }

    protected processGetListeConversationsByIdTechPs_v2_withMSS(response: Response): Promise<ConversationLight[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConversationLight[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationLight[]>(null as any);
    }

    /**
     * Permet d'envoyer un message dans une conversation au nom de l'auteur spécifié en paramètre. Un fichier peut être envoyé avec le message dans la conversation.
     * @param body (optional) Données nécessaires à l'ajout d'un message dans une conversation
     * @return Identifiant du message créé.
     */
    addMessageToConversation(body?: AddMessageToConversationRequest | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Messagerie/AddMessageToConversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddMessageToConversation(_response);
        });
    }

    protected processAddMessageToConversation(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface INomenclatureClient {

    /**
     * Recupère les professions
     * @return OK
     * @deprecated
     */
    getAllProfessions( cancelToken?: CancelToken): Promise<Profession[]>;

    /**
     * Recupère les spécialités existantes
     * @return OK
     * @deprecated
     */
    getAllSpecialites( cancelToken?: CancelToken): Promise<Specialite[]>;

    /**
     * Recherche les villes avec le code postal et/ou avec le libellé exact ou qui commence par.
     * @param label Nom de la ville recherchée
     * @param cP Code postal de la ville recherchée
     * @param exact True, si le libellé est exact (SearchCitiesByExactLabelAndCP),
                                    False si le libelle commence par ou qu'on cherche par le CP (SearchCitiesSartWithLabelOrCP)
     * @return OK
     * @deprecated
     */
    getListeCitiesFromSearch(label: string, cP: string, exact: boolean,  cancelToken?: CancelToken): Promise<Ville[]>;

    /**
     * Calcule les coords GPS des PS grace à leur code postal et la table de liaison CP -> GPS
     * @param body (optional) Identifiant du PS pour lequel on veut les coordonnées GPS
     * @return OK
     * @deprecated
     */
    getListCoordonneesGPSByIdTechPs(body?: GetListCoordonneesGPSByIdTechPsRequest | undefined,  cancelToken?: CancelToken): Promise<CoordonneesGPS[]>;

    /**
     * Récupère tous les types existants de documents
     * @return OK
     */
    getAllCategoriesPiece(idTechPsIdentifie: string,  cancelToken?: CancelToken): Promise<CategoriePiece[]>;

    /**
     * Récupère tous les types existants de documents
     * @return OK
     */
    getAllTypesPiece(idTechPsIdentifie: string,  cancelToken?: CancelToken): Promise<TypePiece[]>;

    /**
     * Recupère les différentes appliquettes.
     * @return OK
     * @deprecated
     */
    getAllAppliquettes( cancelToken?: CancelToken): Promise<AppliquettePortail[]>;

    /**
     * Recupère le référentiel de Pays.
     * @return OK
     * @deprecated
     */
    getAllPays( cancelToken?: CancelToken): Promise<Pays[]>;

    /**
     * Récupère la liste des pays à partir du libelle passé en paramètre.
     * @return OK
     * @deprecated
     */
    getListeCountriesFromSearch(label: string, exact: boolean,  cancelToken?: CancelToken): Promise<Pays[]>;

    /**
     * Renvoie la liste des widgets
     * @param artefactId (optional) 
     * @return OK
     * @deprecated
     */
    getWidgetList(includeDynamic: boolean, artefactId?: string | undefined,  cancelToken?: CancelToken): Promise<WidgetList>;
}

export class NomenclatureClient extends AuthorizedApiBase implements INomenclatureClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Recupère les professions
     * @return OK
     * @deprecated
     */
    getAllProfessions(): Promise<Profession[]> {
        let url_ = this.baseUrl + "/api/Nomenclature/GetAllProfessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllProfessions(_response);
        });
    }

    protected processGetAllProfessions(response: Response): Promise<Profession[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Profession[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Profession[]>(null as any);
    }

    /**
     * Recupère les spécialités existantes
     * @return OK
     * @deprecated
     */
    getAllSpecialites(): Promise<Specialite[]> {
        let url_ = this.baseUrl + "/api/Nomenclature/GetAllSpecialites";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSpecialites(_response);
        });
    }

    protected processGetAllSpecialites(response: Response): Promise<Specialite[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Specialite[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Specialite[]>(null as any);
    }

    /**
     * Recherche les villes avec le code postal et/ou avec le libellé exact ou qui commence par.
     * @param label Nom de la ville recherchée
     * @param cP Code postal de la ville recherchée
     * @param exact True, si le libellé est exact (SearchCitiesByExactLabelAndCP),
                                    False si le libelle commence par ou qu'on cherche par le CP (SearchCitiesSartWithLabelOrCP)
     * @return OK
     * @deprecated
     */
    getListeCitiesFromSearch(label: string, cP: string, exact: boolean): Promise<Ville[]> {
        let url_ = this.baseUrl + "/api/Nomenclature/GetListeCitiesFromSearch?";
        if (label === undefined || label === null)
            throw new globalThis.Error("The parameter 'label' must be defined and cannot be null.");
        else
            url_ += "label=" + encodeURIComponent("" + label) + "&";
        if (cP === undefined || cP === null)
            throw new globalThis.Error("The parameter 'cP' must be defined and cannot be null.");
        else
            url_ += "cP=" + encodeURIComponent("" + cP) + "&";
        if (exact === undefined || exact === null)
            throw new globalThis.Error("The parameter 'exact' must be defined and cannot be null.");
        else
            url_ += "exact=" + encodeURIComponent("" + exact) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListeCitiesFromSearch(_response);
        });
    }

    protected processGetListeCitiesFromSearch(response: Response): Promise<Ville[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Ville[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ville[]>(null as any);
    }

    /**
     * Calcule les coords GPS des PS grace à leur code postal et la table de liaison CP -> GPS
     * @param body (optional) Identifiant du PS pour lequel on veut les coordonnées GPS
     * @return OK
     * @deprecated
     */
    getListCoordonneesGPSByIdTechPs(body?: GetListCoordonneesGPSByIdTechPsRequest | undefined): Promise<CoordonneesGPS[]> {
        let url_ = this.baseUrl + "/api/Nomenclature/GetListCoordonneesGPSByIdTechPs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListCoordonneesGPSByIdTechPs(_response);
        });
    }

    protected processGetListCoordonneesGPSByIdTechPs(response: Response): Promise<CoordonneesGPS[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CoordonneesGPS[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoordonneesGPS[]>(null as any);
    }

    /**
     * Récupère tous les types existants de documents
     * @return OK
     */
    getAllCategoriesPiece(idTechPsIdentifie: string): Promise<CategoriePiece[]> {
        let url_ = this.baseUrl + "/api/Nomenclature/GetAllCategoriesPiece?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllCategoriesPiece(_response);
        });
    }

    protected processGetAllCategoriesPiece(response: Response): Promise<CategoriePiece[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoriePiece[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoriePiece[]>(null as any);
    }

    /**
     * Récupère tous les types existants de documents
     * @return OK
     */
    getAllTypesPiece(idTechPsIdentifie: string): Promise<TypePiece[]> {
        let url_ = this.baseUrl + "/api/Nomenclature/GetAllTypesPiece?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllTypesPiece(_response);
        });
    }

    protected processGetAllTypesPiece(response: Response): Promise<TypePiece[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TypePiece[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TypePiece[]>(null as any);
    }

    /**
     * Recupère les différentes appliquettes.
     * @return OK
     * @deprecated
     */
    getAllAppliquettes(): Promise<AppliquettePortail[]> {
        let url_ = this.baseUrl + "/api/Nomenclature/GetAllAppliquettes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllAppliquettes(_response);
        });
    }

    protected processGetAllAppliquettes(response: Response): Promise<AppliquettePortail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppliquettePortail[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppliquettePortail[]>(null as any);
    }

    /**
     * Recupère le référentiel de Pays.
     * @return OK
     * @deprecated
     */
    getAllPays(): Promise<Pays[]> {
        let url_ = this.baseUrl + "/api/Nomenclature/GetAllPays";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllPays(_response);
        });
    }

    protected processGetAllPays(response: Response): Promise<Pays[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Pays[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Pays[]>(null as any);
    }

    /**
     * Récupère la liste des pays à partir du libelle passé en paramètre.
     * @return OK
     * @deprecated
     */
    getListeCountriesFromSearch(label: string, exact: boolean): Promise<Pays[]> {
        let url_ = this.baseUrl + "/api/Nomenclature/GetListeCountriesFromSearch?";
        if (label === undefined || label === null)
            throw new globalThis.Error("The parameter 'label' must be defined and cannot be null.");
        else
            url_ += "label=" + encodeURIComponent("" + label) + "&";
        if (exact === undefined || exact === null)
            throw new globalThis.Error("The parameter 'exact' must be defined and cannot be null.");
        else
            url_ += "exact=" + encodeURIComponent("" + exact) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListeCountriesFromSearch(_response);
        });
    }

    protected processGetListeCountriesFromSearch(response: Response): Promise<Pays[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Pays[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Pays[]>(null as any);
    }

    /**
     * Renvoie la liste des widgets
     * @param artefactId (optional) 
     * @return OK
     * @deprecated
     */
    getWidgetList(includeDynamic: boolean, artefactId?: string | undefined): Promise<WidgetList> {
        let url_ = this.baseUrl + "/api/Nomenclature/GetWidgetList?";
        if (includeDynamic === undefined || includeDynamic === null)
            throw new globalThis.Error("The parameter 'includeDynamic' must be defined and cannot be null.");
        else
            url_ += "includeDynamic=" + encodeURIComponent("" + includeDynamic) + "&";
        if (artefactId === null)
            throw new globalThis.Error("The parameter 'artefactId' cannot be null.");
        else if (artefactId !== undefined)
            url_ += "artefactId=" + encodeURIComponent("" + artefactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWidgetList(_response);
        });
    }

    protected processGetWidgetList(response: Response): Promise<WidgetList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WidgetList;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WidgetList>(null as any);
    }
}

export interface IOtpAccessClient {

    /**
     * Demande d'association mobile par Code OTP : retourne un identifiant mobilité à utilisé pour finaliser l'appairage
     * @param otpCode Code OTP
     * @param otpRequestId Identifiant de la demande de code OTP
     * @return OK
     * @deprecated
     */
    associateDeviceOtp(otpCode: string, otpRequestId: string,  cancelToken?: CancelToken): Promise<AssociateDeviceOTPResult>;

    /**
     * Authentifie un utilisateur à partir d’un code reçu suite à une demande OTP
     * @param otpCode Code OTP reçu et saisi par l’utilisateur
     * @param otpRequestId Identifiant de la demande OTP
     * @param targetUrl Url cible
     * @return OK
     * @deprecated
     */
    authenticate(otpCode: string, otpRequestId: string, targetUrl: string,  cancelToken?: CancelToken): Promise<OTPAccessData>;

    /**
     * Récupère les informations nécessaire au choix de connexion de l'utilisateur (connexion, appairage, choix de mdp)
     * @param login Identifiant de connexion du nouvel utilisateur
     * @return OK
     * @deprecated
     */
    getPsConnexionInfosMonSisra(login: string,  cancelToken?: CancelToken): Promise<PsConnexionInfosMonSisra>;

    /**
     * Initialise une demande d’accès OTP et envoie un mail contenant un code OTP à l’utilisateur
     * @param login Identifiant de connexion du nouvel utilisateur
     * @param password Mot de passe de connexion de l’utilisateur
     * @return OK
     * @deprecated
     */
    requestOTPMail(login: string, password: string,  cancelToken?: CancelToken): Promise<OTPRequestData>;

    /**
     * Initialise une demande d’accès OTP et envoie un sms contenant un code OTP à l’utilisateur
     * @param login Identifiant de connexion du nouvel utilisateur
     * @param password Mot de passe de connexion de l’utilisateur
     * @return OK
     * @deprecated
     */
    requestOTPSms(login: string, password: string,  cancelToken?: CancelToken): Promise<OTPRequestData>;
}

export class OtpAccessClient extends AuthorizedApiBase implements IOtpAccessClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Demande d'association mobile par Code OTP : retourne un identifiant mobilité à utilisé pour finaliser l'appairage
     * @param otpCode Code OTP
     * @param otpRequestId Identifiant de la demande de code OTP
     * @return OK
     * @deprecated
     */
    associateDeviceOtp(otpCode: string, otpRequestId: string): Promise<AssociateDeviceOTPResult> {
        let url_ = this.baseUrl + "/api/OtpAccess/AssociateDeviceOtp?";
        if (otpCode === undefined || otpCode === null)
            throw new globalThis.Error("The parameter 'otpCode' must be defined and cannot be null.");
        else
            url_ += "otpCode=" + encodeURIComponent("" + otpCode) + "&";
        if (otpRequestId === undefined || otpRequestId === null)
            throw new globalThis.Error("The parameter 'otpRequestId' must be defined and cannot be null.");
        else
            url_ += "otpRequestId=" + encodeURIComponent("" + otpRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssociateDeviceOtp(_response);
        });
    }

    protected processAssociateDeviceOtp(response: Response): Promise<AssociateDeviceOTPResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssociateDeviceOTPResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssociateDeviceOTPResult>(null as any);
    }

    /**
     * Authentifie un utilisateur à partir d’un code reçu suite à une demande OTP
     * @param otpCode Code OTP reçu et saisi par l’utilisateur
     * @param otpRequestId Identifiant de la demande OTP
     * @param targetUrl Url cible
     * @return OK
     * @deprecated
     */
    authenticate(otpCode: string, otpRequestId: string, targetUrl: string): Promise<OTPAccessData> {
        let url_ = this.baseUrl + "/api/OtpAccess/Authenticate?";
        if (otpCode === undefined || otpCode === null)
            throw new globalThis.Error("The parameter 'otpCode' must be defined and cannot be null.");
        else
            url_ += "otpCode=" + encodeURIComponent("" + otpCode) + "&";
        if (otpRequestId === undefined || otpRequestId === null)
            throw new globalThis.Error("The parameter 'otpRequestId' must be defined and cannot be null.");
        else
            url_ += "otpRequestId=" + encodeURIComponent("" + otpRequestId) + "&";
        if (targetUrl === undefined || targetUrl === null)
            throw new globalThis.Error("The parameter 'targetUrl' must be defined and cannot be null.");
        else
            url_ += "targetUrl=" + encodeURIComponent("" + targetUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: Response): Promise<OTPAccessData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OTPAccessData;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OTPAccessData>(null as any);
    }

    /**
     * Récupère les informations nécessaire au choix de connexion de l'utilisateur (connexion, appairage, choix de mdp)
     * @param login Identifiant de connexion du nouvel utilisateur
     * @return OK
     * @deprecated
     */
    getPsConnexionInfosMonSisra(login: string): Promise<PsConnexionInfosMonSisra> {
        let url_ = this.baseUrl + "/api/OtpAccess/GetPsConnexionInfosMonSisra?";
        if (login === undefined || login === null)
            throw new globalThis.Error("The parameter 'login' must be defined and cannot be null.");
        else
            url_ += "login=" + encodeURIComponent("" + login) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPsConnexionInfosMonSisra(_response);
        });
    }

    protected processGetPsConnexionInfosMonSisra(response: Response): Promise<PsConnexionInfosMonSisra> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PsConnexionInfosMonSisra;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PsConnexionInfosMonSisra>(null as any);
    }

    /**
     * Initialise une demande d’accès OTP et envoie un mail contenant un code OTP à l’utilisateur
     * @param login Identifiant de connexion du nouvel utilisateur
     * @param password Mot de passe de connexion de l’utilisateur
     * @return OK
     * @deprecated
     */
    requestOTPMail(login: string, password: string): Promise<OTPRequestData> {
        let url_ = this.baseUrl + "/api/OtpAccess/RequestOTPMail?";
        if (login === undefined || login === null)
            throw new globalThis.Error("The parameter 'login' must be defined and cannot be null.");
        else
            url_ += "login=" + encodeURIComponent("" + login) + "&";
        if (password === undefined || password === null)
            throw new globalThis.Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestOTPMail(_response);
        });
    }

    protected processRequestOTPMail(response: Response): Promise<OTPRequestData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OTPRequestData;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OTPRequestData>(null as any);
    }

    /**
     * Initialise une demande d’accès OTP et envoie un sms contenant un code OTP à l’utilisateur
     * @param login Identifiant de connexion du nouvel utilisateur
     * @param password Mot de passe de connexion de l’utilisateur
     * @return OK
     * @deprecated
     */
    requestOTPSms(login: string, password: string): Promise<OTPRequestData> {
        let url_ = this.baseUrl + "/api/OtpAccess/RequestOTPSms?";
        if (login === undefined || login === null)
            throw new globalThis.Error("The parameter 'login' must be defined and cannot be null.");
        else
            url_ += "login=" + encodeURIComponent("" + login) + "&";
        if (password === undefined || password === null)
            throw new globalThis.Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestOTPSms(_response);
        });
    }

    protected processRequestOTPSms(response: Response): Promise<OTPRequestData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OTPRequestData;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OTPRequestData>(null as any);
    }
}

export interface IPopupClient {

    /**
     * Récupère l'url d'une popup
     * @return OK
     */
    getPopupUrl(idPs: string, tags: string[],  cancelToken?: CancelToken): Promise<void>;
}

export class PopupClient extends AuthorizedApiBase implements IPopupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Récupère l'url d'une popup
     * @return OK
     */
    getPopupUrl(idPs: string, tags: string[]): Promise<void> {
        let url_ = this.baseUrl + "/api/Popup/GetPopupUrl?";
        if (idPs === undefined || idPs === null)
            throw new globalThis.Error("The parameter 'idPs' must be defined and cannot be null.");
        else
            url_ += "idPs=" + encodeURIComponent("" + idPs) + "&";
        if (tags === undefined || tags === null)
            throw new globalThis.Error("The parameter 'tags' must be defined and cannot be null.");
        else
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPopupUrl(_response);
        });
    }

    protected processGetPopupUrl(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IProfessionnelClient {

    /**
     * Retrouve les infos du PS connecté, ainsi que la liste de ses délégants afin qu'il puisse choisir son idTechPsIdentifie
     * @return OK
     */
    getInformationsPSConnecte( cancelToken?: CancelToken): Promise<UserInfo>;

    /**
     * Retourne l'information comme quoi le PS connecté est proscrit pour le patient passé en paramètre
     * @param ippr Identifiant du patient
     * @return OK
     */
    isPsProscrit(ippr: string,  cancelToken?: CancelToken): Promise<boolean>;

    /**
     * Retourne la liste des patients du PS identifié
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @return OK
     */
    getFileActiveMobile(idTechPsIdentifie: string, isMobile: boolean,  cancelToken?: CancelToken): Promise<FileActive>;

    /**
     * Récupère les infos complète d'un PS via son IdTechPS
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param idTechPSRecherche id du PS dont on veut les infos
     * @return OK
     */
    getInformationsUtilisateur(idTechPsIdentifie: string, idTechPSRecherche: string,  cancelToken?: CancelToken): Promise<Professionnel>;

    /**
     * Recupération des préférences MonSisra
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param idTechPsCible ID du PS pour lequel on veut récupérer les préférences
     * @return OK
     */
    getPreferencesMonSisra(idTechPsIdentifie: string, idTechPsCible: string,  cancelToken?: CancelToken): Promise<PreferencesMonSisra>;

    /**
     * Récupère les types de pièces les plus récemment utilisés par un PS.
     * @return OK
     */
    getListeTypesPiecesRecents( cancelToken?: CancelToken): Promise<TypePiece[]>;

    /**
     * Récupère les PS favoris pour un utilisateur identifié
     * @param teleExpertise Si true, charge les préférences d'expert
     * @param equipeRessource Si true, charge les préférences d'equipe ressource
     * @return OK
     */
    getListePsFavoris(teleExpertise: boolean, equipeRessource: boolean,  cancelToken?: CancelToken): Promise<ProfessionnelReduitSollicitation[]>;

    /**
     * Récupère les PS destinataires récents pour un utilisateur identifié
     * @param quantite Le nombre de PS les plus récents à retourner
     * @param idTechPsIdentifie Identifitant du PS identifié
     * @return OK
     */
    getListePsDestinatairesRecents(quantite: number, teleExpertise: boolean, equipeRessource: boolean, idTechPsIdentifie: string,  cancelToken?: CancelToken): Promise<ProfessionnelReduitSollicitation[]>;

    /**
     * Récupère les informations d'un PS Mss
     * @return OK
     */
    getInformationsUtilisateurMss(email: string, idTechPsIdentifie: string,  cancelToken?: CancelToken): Promise<Professionnel>;

    /**
     * Récupère les PS proscrits pour un patient
     * @return OK
     */
    getListePSProscritsPatientByIppr(ippr: string, idTechPsIdentifie: string, sansGestionDesDroits: boolean,  cancelToken?: CancelToken): Promise<ProfessionnelProscrit[]>;

    /**
     * Pour administration : ajout multiple de PS à un établissement
     * @param body (optional) 
     * @return OK
     */
    getListePsReduitsByRPPS(idTechPsIdentifie: string, body?: string[] | undefined,  cancelToken?: CancelToken): Promise<ProfessionnelReduit[]>;

    /**
     * Méthode permettant de renvoyer liste des pp et liste des pm en fonction des ids donnés en entrée
     * @param body (optional) 
     * @return OK
     */
    getPSFromAnnuaire(body?: GetPSFromAnnuaireRequest | undefined,  cancelToken?: CancelToken): Promise<PPAndServices>;

    /**
     * Récupère la config du module de recherche
     * @return OK
     */
    getModuleRecherchePSSettings( cancelToken?: CancelToken): Promise<ModuleRecherchePsSettings>;

    /**
     * Récupère les infos d'un patient suivi par le PS identifié
     * @return OK
     */
    getFileActive(idTechPsIdentifie: string,  cancelToken?: CancelToken): Promise<FileActive>;

    /**
     * @return OK
     */
    getListeProfessionnelsActifsByIppr(ippr: string, idTechPsIdentifie: string,  cancelToken?: CancelToken): Promise<Professionnel[]>;

    /**
     * Récupère la configuration des textes à afficher des les applications en fonction de la région
     * @return OK
     */
    getTextConfiguration(idTechPs: string,  cancelToken?: CancelToken): Promise<TextConfiguration>;

    /**
     * Récupère le patient himself
     * @return OK
     */
    getPatientHimself( cancelToken?: CancelToken): Promise<ProfessionnelReduit>;

    /**
     * Récupère le message d'alert global
     * @return OK
     */
    getGlobalAlertMessage( cancelToken?: CancelToken): Promise<AppGlobalAlertMessage>;

    /**
     * Récupére les UserInfo d'un PS à partir d'un IdNat
     * @return Identifiant Technique de PS a partir de l'Id National
     */
    getUserInfoFromIdNat(idNational: string,  cancelToken?: CancelToken): Promise<UserInfo>;

    /**
     * Renvoie la liste des délégants de l'utilisateur connecté (liste des PS ayant donné la délégation au PS connecté)
     * @return Liste des délégants du PS connecté
     */
    getDelegantsPSConnecte( cancelToken?: CancelToken): Promise<ProfessionnelReduitDelegant[]>;

    /**
     * Renvoie la liste des délégués de l'utilisateur donné en parametre (liste des PS ayant accès au compte du PS donné en paramètre)
     * @return Liste des délégants du PS donné en parametre
     */
    getDeleguesFromPs(idTechPsIdentifie: string,  cancelToken?: CancelToken): Promise<ProfessionnelReduitDelegant[]>;

    /**
     * Recherche un PS Mss par son nom/prénom, profession/spécialité, ville/CP
     * @param body (optional) 
     * @return OK
     */
    getListFindPsMssByCriteria(body?: GetListFindPsMssByCriteriaRequest | undefined,  cancelToken?: CancelToken): Promise<Professionnel[]>;

    /**
     * Recherche un PS par son nom/prénom, profession/spécialité, ville/CP
     * @param body (optional) 
     * @return OK
     */
    getListFindPsByCriteria(body?: GetListFindPsByCriteriaRequest | undefined,  cancelToken?: CancelToken): Promise<ProfessionnelSollicitation[]>;

    /**
     * Recherche un PS par son nom prénom
     * @param idTechPsIdentifie Identifiant de l'utilisateur (PS) connecté
     * @param nomPrenom Nom et Prenom recherché
     * @param maxResult Nombre de résultats maximum à retourner
     * @param teleExpertise Fitlre sur la pratique de la téléexpertise
     * @return OK
     */
    getListFindPsByNomPrenom(idTechPsIdentifie: string, nomPrenom: string, maxResult: number, teleExpertise: boolean,  cancelToken?: CancelToken): Promise<ProfessionnelSollicitation[]>;

    /**
     * Mise à jour des préférences MonSisra
     * @param body (optional) 
     * @return OK
     */
    setPreferencesMonSisra(body?: SetPreferencesMonSisraRequest | undefined,  cancelToken?: CancelToken): Promise<PreferencesMonSisra>;

    /**
     * Définit l'état favori d'un Ps pour l'utilisateur identifié
     * @param body (optional) 
     * @return OK
     */
    setPsFavori(body?: SetPsFavoriRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Service de validation des CGU pour l'utilisateur
     * @return OK
     */
    validateCGU( cancelToken?: CancelToken): Promise<void>;

    /**
     * Raccourci pour méthode liste et support des anciennes versions mobile
    Détermine si l'utilisateur connecté est gestionnaire d'habilitation sur le dossier patient donné.
     * @param body (optional) 
     * @return OK
     */
    isGestionnaireHabilitation(body?: IsGestionnaireHabilitationRequest | undefined,  cancelToken?: CancelToken): Promise<boolean>;

    /**
     * Modifie un professionnel dans l'annuaire sécurité avec synchronisation, puis en local.
     * @param body (optional) 
     * @return OK
     */
    updatePSEmailInDpprAndInAsWithSynchro(body?: UpdatePSEmailInDpprAndInAsWithSynchroRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Méthode permettant de renvoyer les suggestions pour l'auto-complétion d'un mot, à partir du nom d'un service ou une personne, sa profession, sa spécialité ou une de ses compétences
     * @param body (optional) 
     * @return OK
     */
    queryWho(body?: QueryWhoRequest | undefined,  cancelToken?: CancelToken): Promise<WhoSuggestions>;

    /**
     * Méthode permettant de renvoyer les suggestions pour l'auto-complétion d'un lieu (commune/ville, département, ou structure/établissement)
     * @param body (optional) 
     * @return OK
     */
    queryWhere(body?: QueryWhereRequest | undefined,  cancelToken?: CancelToken): Promise<Lieu[]>;

    /**
     * Méthode permettant de renvoyer les résultats d'une recherche multi-critère
     * @param body (optional) location : valeur du location_physical_type
    location_physical_type : fonctionne avec les mêmes code que criteriaType (cf. param searchCriterias)
    searchCriterias : Objet comprenant un criteriaValue (renseigner par l'user) et un criteriaType qui peut prendre plusieurs valeurs : "area" = departement, "si" = structure, "postalcode" = code postal ou code INSEE de la ville en fonction de la région (géré par le queryWhere) , "profession" = idProfession, "specialite" = idSpecialite, "nom", "prenom", "nomprenom" = recherche un seul champ pour nom et prénom, "locationlabel" = recherche sur nom de ville ou code postal non renseigné par autocomplete, "professionlabel" = recherche sur le label de profession ou de spécialité non renseigné par autocomplete
     * @return OK
     */
    searchPPAndServices(body?: SearchPPAndServicesRequest | undefined,  cancelToken?: CancelToken): Promise<PPAndServices>;

    /**
     * Passer le statut du PS à absent et enregistrer le nouveau message d'absence
     * @param body (optional) 
     * @return OK
     */
    setAbsence(body?: SetAbsenceRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Supprimer le statut absent du PS
     * @return OK
     */
    removeAbsence( cancelToken?: CancelToken): Promise<void>;

    /**
     * Vérification de si un professionnel a les droits sur un dossier
     * @param body (optional) 
     * @return OK
     */
    isHabilitedDossierByIppr(body?: IsHabilitedDossierByIpprRequest | undefined,  cancelToken?: CancelToken): Promise<boolean>;

    /**
     * Récupérer les statuts (absence, libelle absence, date derniere consult, date dernier mss, ...) d'une liste de ps
     * @param body (optional) 
     * @return OK
     */
    getInfosStatut(body?: GetInfosStatutRequest | undefined,  cancelToken?: CancelToken): Promise<Statut[]>;

    /**
     * Méthode permettant de renvoyer les favoris du ps connecté (liste des pp et liste des pm)
     * @param body (optional) 
     * @return OK
     */
    getFavorisFromAnnuaire(body?: GetFavorisFromAnnuaireRequest | undefined,  cancelToken?: CancelToken): Promise<PPAndServices>;

    /**
     * Méthode permettant de renvoyer les récents du ps connecté (liste des pp et liste des pm)
     * @param body (optional) 
     * @return OK
     */
    getRecentsFromAnnuaire(body?: GetRecentsFromAnnuaireRequest | undefined,  cancelToken?: CancelToken): Promise<PPAndServices>;

    /**
     * Crée un utilisateur issur de l'AR dans le DPPR et en synchro avec l'Annuaire Sécurité, avec seulement quelques données disponibles comme c'est le cas pour un destinataire ou auteur d'échange,
    SANS BLOQUER en cas d'erreur, en utilisant un verrou sur l'identifiant pour éviter les créations parallèles du PS.
     * @param body (optional) 
     * @return OK
     */
    createPsOnTheFly(body?: CreatePsOnTheFlyRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Méthode permettant de renvoyer les suggestions pour l'auto-complétion d'une profession ou spécialité
     * @param body (optional) 
     * @return OK
     */
    queryProfession(body?: QueryProfessionRequest | undefined,  cancelToken?: CancelToken): Promise<ProfessionSuggestion[]>;

    /**
     * @param body (optional) 
     * @return OK
     */
    createPSInDpprAndInAsWithSynchro(body?: CreatePSInDpprAndInAsWithSynchroRequest | undefined,  cancelToken?: CancelToken): Promise<string>;

    /**
     * @param body (optional) 
     * @return OK
     */
    updatePSInDpprAndInAsWithSynchro(body?: UpdatePSInDpprAndInAsWithSynchroRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * @param body (optional) 
     * @return OK
     */
    isDelegantDiscussion(body?: IsDelegantDiscussionRequest | undefined,  cancelToken?: CancelToken): Promise<boolean>;

    /**
     * Renvoie la liste des délégants de l'utilisateur donné en parametre
     * @return Liste des délégants du PS donné en parametre
     */
    getDelegantsFromPs(idTechPsIdentifie: string,  cancelToken?: CancelToken): Promise<ProfessionnelReduitDelegant[]>;
}

export class ProfessionnelClient extends AuthorizedApiBase implements IProfessionnelClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Retrouve les infos du PS connecté, ainsi que la liste de ses délégants afin qu'il puisse choisir son idTechPsIdentifie
     * @return OK
     */
    getInformationsPSConnecte(): Promise<UserInfo> {
        let url_ = this.baseUrl + "/api/Professionnel/GetInformationsPSConnecte";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInformationsPSConnecte(_response);
        });
    }

    protected processGetInformationsPSConnecte(response: Response): Promise<UserInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfo>(null as any);
    }

    /**
     * Retourne l'information comme quoi le PS connecté est proscrit pour le patient passé en paramètre
     * @param ippr Identifiant du patient
     * @return OK
     */
    isPsProscrit(ippr: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Professionnel/IsPsProscrit?";
        if (ippr === undefined || ippr === null)
            throw new globalThis.Error("The parameter 'ippr' must be defined and cannot be null.");
        else
            url_ += "ippr=" + encodeURIComponent("" + ippr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsPsProscrit(_response);
        });
    }

    protected processIsPsProscrit(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Retourne la liste des patients du PS identifié
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @return OK
     */
    getFileActiveMobile(idTechPsIdentifie: string, isMobile: boolean): Promise<FileActive> {
        let url_ = this.baseUrl + "/api/Professionnel/GetFileActiveMobile?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (isMobile === undefined || isMobile === null)
            throw new globalThis.Error("The parameter 'isMobile' must be defined and cannot be null.");
        else
            url_ += "isMobile=" + encodeURIComponent("" + isMobile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileActiveMobile(_response);
        });
    }

    protected processGetFileActiveMobile(response: Response): Promise<FileActive> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileActive;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileActive>(null as any);
    }

    /**
     * Récupère les infos complète d'un PS via son IdTechPS
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param idTechPSRecherche id du PS dont on veut les infos
     * @return OK
     */
    getInformationsUtilisateur(idTechPsIdentifie: string, idTechPSRecherche: string): Promise<Professionnel> {
        let url_ = this.baseUrl + "/api/Professionnel/GetInformationsUtilisateur?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (idTechPSRecherche === undefined || idTechPSRecherche === null)
            throw new globalThis.Error("The parameter 'idTechPSRecherche' must be defined and cannot be null.");
        else
            url_ += "idTechPSRecherche=" + encodeURIComponent("" + idTechPSRecherche) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInformationsUtilisateur(_response);
        });
    }

    protected processGetInformationsUtilisateur(response: Response): Promise<Professionnel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Professionnel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Professionnel>(null as any);
    }

    /**
     * Recupération des préférences MonSisra
     * @param idTechPsIdentifie Identifiant de l'utilisateur déléguant pour lequel l'utilisateur travaille
     * @param idTechPsCible ID du PS pour lequel on veut récupérer les préférences
     * @return OK
     */
    getPreferencesMonSisra(idTechPsIdentifie: string, idTechPsCible: string): Promise<PreferencesMonSisra> {
        let url_ = this.baseUrl + "/api/Professionnel/GetPreferencesMonSisra?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (idTechPsCible === undefined || idTechPsCible === null)
            throw new globalThis.Error("The parameter 'idTechPsCible' must be defined and cannot be null.");
        else
            url_ += "idTechPsCible=" + encodeURIComponent("" + idTechPsCible) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPreferencesMonSisra(_response);
        });
    }

    protected processGetPreferencesMonSisra(response: Response): Promise<PreferencesMonSisra> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreferencesMonSisra;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreferencesMonSisra>(null as any);
    }

    /**
     * Récupère les types de pièces les plus récemment utilisés par un PS.
     * @return OK
     */
    getListeTypesPiecesRecents(): Promise<TypePiece[]> {
        let url_ = this.baseUrl + "/api/Professionnel/GetListeTypesPiecesRecents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListeTypesPiecesRecents(_response);
        });
    }

    protected processGetListeTypesPiecesRecents(response: Response): Promise<TypePiece[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TypePiece[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TypePiece[]>(null as any);
    }

    /**
     * Récupère les PS favoris pour un utilisateur identifié
     * @param teleExpertise Si true, charge les préférences d'expert
     * @param equipeRessource Si true, charge les préférences d'equipe ressource
     * @return OK
     */
    getListePsFavoris(teleExpertise: boolean, equipeRessource: boolean): Promise<ProfessionnelReduitSollicitation[]> {
        let url_ = this.baseUrl + "/api/Professionnel/GetListePsFavoris?";
        if (teleExpertise === undefined || teleExpertise === null)
            throw new globalThis.Error("The parameter 'teleExpertise' must be defined and cannot be null.");
        else
            url_ += "teleExpertise=" + encodeURIComponent("" + teleExpertise) + "&";
        if (equipeRessource === undefined || equipeRessource === null)
            throw new globalThis.Error("The parameter 'equipeRessource' must be defined and cannot be null.");
        else
            url_ += "equipeRessource=" + encodeURIComponent("" + equipeRessource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListePsFavoris(_response);
        });
    }

    protected processGetListePsFavoris(response: Response): Promise<ProfessionnelReduitSollicitation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionnelReduitSollicitation[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionnelReduitSollicitation[]>(null as any);
    }

    /**
     * Récupère les PS destinataires récents pour un utilisateur identifié
     * @param quantite Le nombre de PS les plus récents à retourner
     * @param idTechPsIdentifie Identifitant du PS identifié
     * @return OK
     */
    getListePsDestinatairesRecents(quantite: number, teleExpertise: boolean, equipeRessource: boolean, idTechPsIdentifie: string): Promise<ProfessionnelReduitSollicitation[]> {
        let url_ = this.baseUrl + "/api/Professionnel/GetListePsDestinatairesRecents?";
        if (quantite === undefined || quantite === null)
            throw new globalThis.Error("The parameter 'quantite' must be defined and cannot be null.");
        else
            url_ += "quantite=" + encodeURIComponent("" + quantite) + "&";
        if (teleExpertise === undefined || teleExpertise === null)
            throw new globalThis.Error("The parameter 'teleExpertise' must be defined and cannot be null.");
        else
            url_ += "teleExpertise=" + encodeURIComponent("" + teleExpertise) + "&";
        if (equipeRessource === undefined || equipeRessource === null)
            throw new globalThis.Error("The parameter 'equipeRessource' must be defined and cannot be null.");
        else
            url_ += "equipeRessource=" + encodeURIComponent("" + equipeRessource) + "&";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListePsDestinatairesRecents(_response);
        });
    }

    protected processGetListePsDestinatairesRecents(response: Response): Promise<ProfessionnelReduitSollicitation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionnelReduitSollicitation[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionnelReduitSollicitation[]>(null as any);
    }

    /**
     * Récupère les informations d'un PS Mss
     * @return OK
     */
    getInformationsUtilisateurMss(email: string, idTechPsIdentifie: string): Promise<Professionnel> {
        let url_ = this.baseUrl + "/api/Professionnel/GetInformationsUtilisateurMss?";
        if (email === undefined || email === null)
            throw new globalThis.Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInformationsUtilisateurMss(_response);
        });
    }

    protected processGetInformationsUtilisateurMss(response: Response): Promise<Professionnel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Professionnel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Professionnel>(null as any);
    }

    /**
     * Récupère les PS proscrits pour un patient
     * @return OK
     */
    getListePSProscritsPatientByIppr(ippr: string, idTechPsIdentifie: string, sansGestionDesDroits: boolean): Promise<ProfessionnelProscrit[]> {
        let url_ = this.baseUrl + "/api/Professionnel/GetListePSProscritsPatientByIppr?";
        if (ippr === undefined || ippr === null)
            throw new globalThis.Error("The parameter 'ippr' must be defined and cannot be null.");
        else
            url_ += "ippr=" + encodeURIComponent("" + ippr) + "&";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (sansGestionDesDroits === undefined || sansGestionDesDroits === null)
            throw new globalThis.Error("The parameter 'sansGestionDesDroits' must be defined and cannot be null.");
        else
            url_ += "sansGestionDesDroits=" + encodeURIComponent("" + sansGestionDesDroits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListePSProscritsPatientByIppr(_response);
        });
    }

    protected processGetListePSProscritsPatientByIppr(response: Response): Promise<ProfessionnelProscrit[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionnelProscrit[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionnelProscrit[]>(null as any);
    }

    /**
     * Pour administration : ajout multiple de PS à un établissement
     * @param body (optional) 
     * @return OK
     */
    getListePsReduitsByRPPS(idTechPsIdentifie: string, body?: string[] | undefined): Promise<ProfessionnelReduit[]> {
        let url_ = this.baseUrl + "/api/Professionnel/GetListePsReduitsByRPPS?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListePsReduitsByRPPS(_response);
        });
    }

    protected processGetListePsReduitsByRPPS(response: Response): Promise<ProfessionnelReduit[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionnelReduit[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionnelReduit[]>(null as any);
    }

    /**
     * Méthode permettant de renvoyer liste des pp et liste des pm en fonction des ids donnés en entrée
     * @param body (optional) 
     * @return OK
     */
    getPSFromAnnuaire(body?: GetPSFromAnnuaireRequest | undefined): Promise<PPAndServices> {
        let url_ = this.baseUrl + "/api/Professionnel/GetPSFromAnnuaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPSFromAnnuaire(_response);
        });
    }

    protected processGetPSFromAnnuaire(response: Response): Promise<PPAndServices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PPAndServices;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PPAndServices>(null as any);
    }

    /**
     * Récupère la config du module de recherche
     * @return OK
     */
    getModuleRecherchePSSettings(): Promise<ModuleRecherchePsSettings> {
        let url_ = this.baseUrl + "/api/Professionnel/GetModuleRecherchePSSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetModuleRecherchePSSettings(_response);
        });
    }

    protected processGetModuleRecherchePSSettings(response: Response): Promise<ModuleRecherchePsSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ModuleRecherchePsSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleRecherchePsSettings>(null as any);
    }

    /**
     * Récupère les infos d'un patient suivi par le PS identifié
     * @return OK
     */
    getFileActive(idTechPsIdentifie: string): Promise<FileActive> {
        let url_ = this.baseUrl + "/api/Professionnel/GetFileActive?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileActive(_response);
        });
    }

    protected processGetFileActive(response: Response): Promise<FileActive> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileActive;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileActive>(null as any);
    }

    /**
     * @return OK
     */
    getListeProfessionnelsActifsByIppr(ippr: string, idTechPsIdentifie: string): Promise<Professionnel[]> {
        let url_ = this.baseUrl + "/api/Professionnel/GetListeProfessionnelsActifsByIppr?";
        if (ippr === undefined || ippr === null)
            throw new globalThis.Error("The parameter 'ippr' must be defined and cannot be null.");
        else
            url_ += "ippr=" + encodeURIComponent("" + ippr) + "&";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListeProfessionnelsActifsByIppr(_response);
        });
    }

    protected processGetListeProfessionnelsActifsByIppr(response: Response): Promise<Professionnel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Professionnel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Professionnel[]>(null as any);
    }

    /**
     * Récupère la configuration des textes à afficher des les applications en fonction de la région
     * @return OK
     */
    getTextConfiguration(idTechPs: string): Promise<TextConfiguration> {
        let url_ = this.baseUrl + "/api/Professionnel/GetTextConfiguration?";
        if (idTechPs === undefined || idTechPs === null)
            throw new globalThis.Error("The parameter 'idTechPs' must be defined and cannot be null.");
        else
            url_ += "idTechPs=" + encodeURIComponent("" + idTechPs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTextConfiguration(_response);
        });
    }

    protected processGetTextConfiguration(response: Response): Promise<TextConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TextConfiguration;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TextConfiguration>(null as any);
    }

    /**
     * Récupère le patient himself
     * @return OK
     */
    getPatientHimself(): Promise<ProfessionnelReduit> {
        let url_ = this.baseUrl + "/api/Professionnel/GetPatientHimself";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPatientHimself(_response);
        });
    }

    protected processGetPatientHimself(response: Response): Promise<ProfessionnelReduit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionnelReduit;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionnelReduit>(null as any);
    }

    /**
     * Récupère le message d'alert global
     * @return OK
     */
    getGlobalAlertMessage(): Promise<AppGlobalAlertMessage> {
        let url_ = this.baseUrl + "/api/Professionnel/GetGlobalAlertMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGlobalAlertMessage(_response);
        });
    }

    protected processGetGlobalAlertMessage(response: Response): Promise<AppGlobalAlertMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppGlobalAlertMessage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppGlobalAlertMessage>(null as any);
    }

    /**
     * Récupére les UserInfo d'un PS à partir d'un IdNat
     * @return Identifiant Technique de PS a partir de l'Id National
     */
    getUserInfoFromIdNat(idNational: string): Promise<UserInfo> {
        let url_ = this.baseUrl + "/api/Professionnel/idNational?";
        if (idNational === undefined || idNational === null)
            throw new globalThis.Error("The parameter 'idNational' must be defined and cannot be null.");
        else
            url_ += "idNational=" + encodeURIComponent("" + idNational) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserInfoFromIdNat(_response);
        });
    }

    protected processGetUserInfoFromIdNat(response: Response): Promise<UserInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserInfo;
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfo>(null as any);
    }

    /**
     * Renvoie la liste des délégants de l'utilisateur connecté (liste des PS ayant donné la délégation au PS connecté)
     * @return Liste des délégants du PS connecté
     */
    getDelegantsPSConnecte(): Promise<ProfessionnelReduitDelegant[]> {
        let url_ = this.baseUrl + "/api/Professionnel/delegants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDelegantsPSConnecte(_response);
        });
    }

    protected processGetDelegantsPSConnecte(response: Response): Promise<ProfessionnelReduitDelegant[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionnelReduitDelegant[];
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionnelReduitDelegant[]>(null as any);
    }

    /**
     * Renvoie la liste des délégués de l'utilisateur donné en parametre (liste des PS ayant accès au compte du PS donné en paramètre)
     * @return Liste des délégants du PS donné en parametre
     */
    getDeleguesFromPs(idTechPsIdentifie: string): Promise<ProfessionnelReduitDelegant[]> {
        let url_ = this.baseUrl + "/api/Professionnel/delegues/{idTechPsIdentifie}";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined.");
        url_ = url_.replace("{idTechPsIdentifie}", encodeURIComponent("" + idTechPsIdentifie));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeleguesFromPs(_response);
        });
    }

    protected processGetDeleguesFromPs(response: Response): Promise<ProfessionnelReduitDelegant[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionnelReduitDelegant[];
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionnelReduitDelegant[]>(null as any);
    }

    /**
     * Recherche un PS Mss par son nom/prénom, profession/spécialité, ville/CP
     * @param body (optional) 
     * @return OK
     */
    getListFindPsMssByCriteria(body?: GetListFindPsMssByCriteriaRequest | undefined): Promise<Professionnel[]> {
        let url_ = this.baseUrl + "/api/Professionnel/GetListFindPsMssByCriteria";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListFindPsMssByCriteria(_response);
        });
    }

    protected processGetListFindPsMssByCriteria(response: Response): Promise<Professionnel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Professionnel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Professionnel[]>(null as any);
    }

    /**
     * Recherche un PS par son nom/prénom, profession/spécialité, ville/CP
     * @param body (optional) 
     * @return OK
     */
    getListFindPsByCriteria(body?: GetListFindPsByCriteriaRequest | undefined): Promise<ProfessionnelSollicitation[]> {
        let url_ = this.baseUrl + "/api/Professionnel/GetListFindPsByCriteria";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListFindPsByCriteria(_response);
        });
    }

    protected processGetListFindPsByCriteria(response: Response): Promise<ProfessionnelSollicitation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionnelSollicitation[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionnelSollicitation[]>(null as any);
    }

    /**
     * Recherche un PS par son nom prénom
     * @param idTechPsIdentifie Identifiant de l'utilisateur (PS) connecté
     * @param nomPrenom Nom et Prenom recherché
     * @param maxResult Nombre de résultats maximum à retourner
     * @param teleExpertise Fitlre sur la pratique de la téléexpertise
     * @return OK
     */
    getListFindPsByNomPrenom(idTechPsIdentifie: string, nomPrenom: string, maxResult: number, teleExpertise: boolean): Promise<ProfessionnelSollicitation[]> {
        let url_ = this.baseUrl + "/api/Professionnel/GetListFindPsByNomPrenom?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (nomPrenom === undefined || nomPrenom === null)
            throw new globalThis.Error("The parameter 'nomPrenom' must be defined and cannot be null.");
        else
            url_ += "nomPrenom=" + encodeURIComponent("" + nomPrenom) + "&";
        if (maxResult === undefined || maxResult === null)
            throw new globalThis.Error("The parameter 'maxResult' must be defined and cannot be null.");
        else
            url_ += "maxResult=" + encodeURIComponent("" + maxResult) + "&";
        if (teleExpertise === undefined || teleExpertise === null)
            throw new globalThis.Error("The parameter 'teleExpertise' must be defined and cannot be null.");
        else
            url_ += "teleExpertise=" + encodeURIComponent("" + teleExpertise) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListFindPsByNomPrenom(_response);
        });
    }

    protected processGetListFindPsByNomPrenom(response: Response): Promise<ProfessionnelSollicitation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionnelSollicitation[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionnelSollicitation[]>(null as any);
    }

    /**
     * Mise à jour des préférences MonSisra
     * @param body (optional) 
     * @return OK
     */
    setPreferencesMonSisra(body?: SetPreferencesMonSisraRequest | undefined): Promise<PreferencesMonSisra> {
        let url_ = this.baseUrl + "/api/Professionnel/SetPreferencesMonSisra";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetPreferencesMonSisra(_response);
        });
    }

    protected processSetPreferencesMonSisra(response: Response): Promise<PreferencesMonSisra> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreferencesMonSisra;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreferencesMonSisra>(null as any);
    }

    /**
     * Définit l'état favori d'un Ps pour l'utilisateur identifié
     * @param body (optional) 
     * @return OK
     */
    setPsFavori(body?: SetPsFavoriRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Professionnel/SetPsFavori";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetPsFavori(_response);
        });
    }

    protected processSetPsFavori(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Service de validation des CGU pour l'utilisateur
     * @return OK
     */
    validateCGU(): Promise<void> {
        let url_ = this.baseUrl + "/api/Professionnel/validate-cgu";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateCGU(_response);
        });
    }

    protected processValidateCGU(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Raccourci pour méthode liste et support des anciennes versions mobile
    Détermine si l'utilisateur connecté est gestionnaire d'habilitation sur le dossier patient donné.
     * @param body (optional) 
     * @return OK
     */
    isGestionnaireHabilitation(body?: IsGestionnaireHabilitationRequest | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Professionnel/IsGestionnaireHabilitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsGestionnaireHabilitation(_response);
        });
    }

    protected processIsGestionnaireHabilitation(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Modifie un professionnel dans l'annuaire sécurité avec synchronisation, puis en local.
     * @param body (optional) 
     * @return OK
     */
    updatePSEmailInDpprAndInAsWithSynchro(body?: UpdatePSEmailInDpprAndInAsWithSynchroRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Professionnel/UpdatePSEmailInDpprAndInAsWithSynchro";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePSEmailInDpprAndInAsWithSynchro(_response);
        });
    }

    protected processUpdatePSEmailInDpprAndInAsWithSynchro(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Méthode permettant de renvoyer les suggestions pour l'auto-complétion d'un mot, à partir du nom d'un service ou une personne, sa profession, sa spécialité ou une de ses compétences
     * @param body (optional) 
     * @return OK
     */
    queryWho(body?: QueryWhoRequest | undefined): Promise<WhoSuggestions> {
        let url_ = this.baseUrl + "/api/Professionnel/QueryWho";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueryWho(_response);
        });
    }

    protected processQueryWho(response: Response): Promise<WhoSuggestions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WhoSuggestions;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhoSuggestions>(null as any);
    }

    /**
     * Méthode permettant de renvoyer les suggestions pour l'auto-complétion d'un lieu (commune/ville, département, ou structure/établissement)
     * @param body (optional) 
     * @return OK
     */
    queryWhere(body?: QueryWhereRequest | undefined): Promise<Lieu[]> {
        let url_ = this.baseUrl + "/api/Professionnel/QueryWhere";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueryWhere(_response);
        });
    }

    protected processQueryWhere(response: Response): Promise<Lieu[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Lieu[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Lieu[]>(null as any);
    }

    /**
     * Méthode permettant de renvoyer les résultats d'une recherche multi-critère
     * @param body (optional) location : valeur du location_physical_type
    location_physical_type : fonctionne avec les mêmes code que criteriaType (cf. param searchCriterias)
    searchCriterias : Objet comprenant un criteriaValue (renseigner par l'user) et un criteriaType qui peut prendre plusieurs valeurs : "area" = departement, "si" = structure, "postalcode" = code postal ou code INSEE de la ville en fonction de la région (géré par le queryWhere) , "profession" = idProfession, "specialite" = idSpecialite, "nom", "prenom", "nomprenom" = recherche un seul champ pour nom et prénom, "locationlabel" = recherche sur nom de ville ou code postal non renseigné par autocomplete, "professionlabel" = recherche sur le label de profession ou de spécialité non renseigné par autocomplete
     * @return OK
     */
    searchPPAndServices(body?: SearchPPAndServicesRequest | undefined): Promise<PPAndServices> {
        let url_ = this.baseUrl + "/api/Professionnel/SearchPPAndServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchPPAndServices(_response);
        });
    }

    protected processSearchPPAndServices(response: Response): Promise<PPAndServices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PPAndServices;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PPAndServices>(null as any);
    }

    /**
     * Passer le statut du PS à absent et enregistrer le nouveau message d'absence
     * @param body (optional) 
     * @return OK
     */
    setAbsence(body?: SetAbsenceRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Professionnel/SetAbsence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetAbsence(_response);
        });
    }

    protected processSetAbsence(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Supprimer le statut absent du PS
     * @return OK
     */
    removeAbsence(): Promise<void> {
        let url_ = this.baseUrl + "/api/Professionnel/RemoveAbsence";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveAbsence(_response);
        });
    }

    protected processRemoveAbsence(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Vérification de si un professionnel a les droits sur un dossier
     * @param body (optional) 
     * @return OK
     */
    isHabilitedDossierByIppr(body?: IsHabilitedDossierByIpprRequest | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Professionnel/IsHabilitedDossierByIppr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsHabilitedDossierByIppr(_response);
        });
    }

    protected processIsHabilitedDossierByIppr(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Récupérer les statuts (absence, libelle absence, date derniere consult, date dernier mss, ...) d'une liste de ps
     * @param body (optional) 
     * @return OK
     */
    getInfosStatut(body?: GetInfosStatutRequest | undefined): Promise<Statut[]> {
        let url_ = this.baseUrl + "/api/Professionnel/GetInfosStatut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInfosStatut(_response);
        });
    }

    protected processGetInfosStatut(response: Response): Promise<Statut[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Statut[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Statut[]>(null as any);
    }

    /**
     * Méthode permettant de renvoyer les favoris du ps connecté (liste des pp et liste des pm)
     * @param body (optional) 
     * @return OK
     */
    getFavorisFromAnnuaire(body?: GetFavorisFromAnnuaireRequest | undefined): Promise<PPAndServices> {
        let url_ = this.baseUrl + "/api/Professionnel/GetFavorisFromAnnuaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFavorisFromAnnuaire(_response);
        });
    }

    protected processGetFavorisFromAnnuaire(response: Response): Promise<PPAndServices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PPAndServices;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PPAndServices>(null as any);
    }

    /**
     * Méthode permettant de renvoyer les récents du ps connecté (liste des pp et liste des pm)
     * @param body (optional) 
     * @return OK
     */
    getRecentsFromAnnuaire(body?: GetRecentsFromAnnuaireRequest | undefined): Promise<PPAndServices> {
        let url_ = this.baseUrl + "/api/Professionnel/GetRecentsFromAnnuaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecentsFromAnnuaire(_response);
        });
    }

    protected processGetRecentsFromAnnuaire(response: Response): Promise<PPAndServices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PPAndServices;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PPAndServices>(null as any);
    }

    /**
     * Crée un utilisateur issur de l'AR dans le DPPR et en synchro avec l'Annuaire Sécurité, avec seulement quelques données disponibles comme c'est le cas pour un destinataire ou auteur d'échange,
    SANS BLOQUER en cas d'erreur, en utilisant un verrou sur l'identifiant pour éviter les créations parallèles du PS.
     * @param body (optional) 
     * @return OK
     */
    createPsOnTheFly(body?: CreatePsOnTheFlyRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Professionnel/CreatePsOnTheFly";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePsOnTheFly(_response);
        });
    }

    protected processCreatePsOnTheFly(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Méthode permettant de renvoyer les suggestions pour l'auto-complétion d'une profession ou spécialité
     * @param body (optional) 
     * @return OK
     */
    queryProfession(body?: QueryProfessionRequest | undefined): Promise<ProfessionSuggestion[]> {
        let url_ = this.baseUrl + "/api/Professionnel/QueryProfession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueryProfession(_response);
        });
    }

    protected processQueryProfession(response: Response): Promise<ProfessionSuggestion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionSuggestion[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionSuggestion[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPSInDpprAndInAsWithSynchro(body?: CreatePSInDpprAndInAsWithSynchroRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Professionnel/CreatePSInDpprAndInAsWithSynchro";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePSInDpprAndInAsWithSynchro(_response);
        });
    }

    protected processCreatePSInDpprAndInAsWithSynchro(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updatePSInDpprAndInAsWithSynchro(body?: UpdatePSInDpprAndInAsWithSynchroRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Professionnel/UpdatePSInDpprAndInAsWithSynchro";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePSInDpprAndInAsWithSynchro(_response);
        });
    }

    protected processUpdatePSInDpprAndInAsWithSynchro(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    isDelegantDiscussion(body?: IsDelegantDiscussionRequest | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Professionnel/IsDelegantDiscussion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsDelegantDiscussion(_response);
        });
    }

    protected processIsDelegantDiscussion(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Renvoie la liste des délégants de l'utilisateur donné en parametre
     * @return Liste des délégants du PS donné en parametre
     */
    getDelegantsFromPs(idTechPsIdentifie: string): Promise<ProfessionnelReduitDelegant[]> {
        let url_ = this.baseUrl + "/api/Professionnel/delegants/{idTechPsIdentifie}";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined.");
        url_ = url_.replace("{idTechPsIdentifie}", encodeURIComponent("" + idTechPsIdentifie));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDelegantsFromPs(_response);
        });
    }

    protected processGetDelegantsFromPs(response: Response): Promise<ProfessionnelReduitDelegant[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessionnelReduitDelegant[];
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionnelReduitDelegant[]>(null as any);
    }
}

export interface ISollicitationClient {

    /**
     * Permet de récupérer les préférences de téléexpertise d'un expert ou d'une équipe ressource
     * @return Les données de préférences de sollicitation
     */
    getPreferencesSollicitation(idTechPsReceveur: string, typeUtilisateurSollicitation: TypeUtilisateurSollicitation,  cancelToken?: CancelToken): Promise<PreferencesSollicitation>;

    /**
     * Permet de récupérer l'URL de création d'un formulaire Dominho
     * @param numeroSecuriteSocialePatient (optional) numéro de sécurité sociale du patient
     * @return OK
     */
    getUrlToCreateDominhoForm(idTechPsIdentifie: string, idTechPsReceveur: string, ippr: string, idConversation: string, idFicheDominho: string, numeroSecuriteSocialePatient?: string | undefined,  cancelToken?: CancelToken): Promise<string>;

    /**
     * Permet de récupérer l'URL d'ouverture d'un formulaire Dominho existant
     * @return OK
     */
    getUrlToOpenDominhoForm(idTechPsIdentifie: string, idTechPsReceveur: string, idConversation: string, idFormulaire: string, dominhoFormAccessMode: DominhoFormAccessMode,  cancelToken?: CancelToken): Promise<string>;

    /**
     * Permet d'ajouter les données de sollicitation dans la table dédiée
     * @param idConversation Identifiant de la conversation à laquelle sont liées les données de sollicitation
     * @param body (optional) 
     * @return Created
     */
    createSollicitation(idConversation: string, body?: CreateSollicitationRequest | undefined,  cancelToken?: CancelToken): Promise<Sollicitation>;

    /**
     * Permet de passer le statut d'une TLE de "Initialisee" à "En cours" ou de "En cours" à "Clôturée", puis de sauvegarder son niveau de facturation
    Permet également de passer le statut d'une demande d'appui de "Initialisee" à "En cours"
     * @param idConversation Identifiant de la conversation
     * @param body (optional) Données nécessaires pour changer le statut de la sollicitation
     * @return OK
     */
    setStatutEtatSollicitation(idConversation: string, body?: SetStatutEtatSollicitationRequest | undefined,  cancelToken?: CancelToken): Promise<EtatSollicitation>;

    /**
     * Permet de finaliser un téléexpertise en passant la cotisation (niveau de facturation ainsi que
    les numéros de facturation du requerant et de l'expert
     * @param idConversation Identifiant de la conversation
     * @param body (optional) Données nécessaires sauvegarder les numéros de facturations
     * @return OK
     */
    setFacturationTeleexpertise(idConversation: string, body?: SetFacturationTeleExpertiseRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Permet de récupérer les niveaux de facturation pour les sollicitations
     * @return OK
     */
    getNiveauxFacturationSollicitation( cancelToken?: CancelToken): Promise<string[]>;

    /**
     * Permet de sauvegarder un numéro de facturation
     * @param body (optional) 
     * @return Le numéro de facturation sauvegardé.
     */
    saveNumeroFacturationSollicitation(idTechPsIdentifie: string, body?: string | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Permet de récupérer une liste de numéros de facturation
     * @return OK
     */
    getNumerosFacturationSollicitation(listeIdTechPsCible: string[],  cancelToken?: CancelToken): Promise<{ [key: string]: string; }>;

    /**
     * Permet de sauvegarder la déclaration d'expert/d'équipe ressource
     * @param body (optional) Données de préférences de sollicitation à sauvegarder
     * @return Les préférences de sollicitation sauvegardées
     */
    savePreferencesSollicitation(idTechPsIdentifie: string, body?: SavePreferencesSollicitationRequest | undefined,  cancelToken?: CancelToken): Promise<PreferencesSollicitation>;

    /**
     * Permet de récupérer la configuration nécessaire à la page de préférences de sollicitation
     * @param typeUtilisateur Type de receveur sollicité : expert, équipe ressource
     * @return Configurations de la page de préférences de sollicitation
     */
    getConfigurationPreferencesSollicitation(typeUtilisateur: TypeUtilisateurSollicitation,  cancelToken?: CancelToken): Promise<ConfigurationPreferencesSollicitation>;

    /**
     * Renvoie un fichier de prérequis de sollicitation avec son contenu
     * @param idFichierSollicitation Identifiant du fichier recherché
     * @param typeUtilisateurSollicitation Type d'utilisateur de sollicitation : Expert ou EquipeRessource
     * @return Download a file.
     */
    getDocumentPrerequisSollicitation(idFichierSollicitation: string, typeUtilisateurSollicitation: TypeUtilisateurSollicitation,  cancelToken?: CancelToken): Promise<FileResponse>;

    /**
     * Renvoie le formulaire dominho rempli sous forme de fichier pdf
     * @param idDocument Id Document Dominho
     * @return Download a file.
     */
    getFichierFormulaireDominhoFromIdDoc(idDocument: string,  cancelToken?: CancelToken): Promise<FileBase64Encoded>;

    /**
     * Envoie le rapport pdf d'un formulaire dans la conversation
     * @param idTechPsIdentifie Id Tech Ps Identifie
     * @param idFormulaire Id Formulaire
     * @return Generate Report.
     */
    getReportForm(idTechPsIdentifie: string, idFormulaire: string,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Renvoie un booléen pour savoir si l'application de télé-expertise peut être ouverte en iframe
     * @param idTechPsCible Identifiant du ps cible
     * @param parentUrl Url de l'application parente de l'iframe
     * @return OK
     */
    getDroitOuvrirIframeTleModeAdmin(idTechPsCible: string, parentUrl: string,  cancelToken?: CancelToken): Promise<boolean>;
}

export class SollicitationClient extends AuthorizedApiBase implements ISollicitationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Permet de récupérer les préférences de téléexpertise d'un expert ou d'une équipe ressource
     * @return Les données de préférences de sollicitation
     */
    getPreferencesSollicitation(idTechPsReceveur: string, typeUtilisateurSollicitation: TypeUtilisateurSollicitation): Promise<PreferencesSollicitation> {
        let url_ = this.baseUrl + "/api/sollicitation/preferences-sollicitation?";
        if (idTechPsReceveur === undefined || idTechPsReceveur === null)
            throw new globalThis.Error("The parameter 'idTechPsReceveur' must be defined and cannot be null.");
        else
            url_ += "idTechPsReceveur=" + encodeURIComponent("" + idTechPsReceveur) + "&";
        if (typeUtilisateurSollicitation === undefined || typeUtilisateurSollicitation === null)
            throw new globalThis.Error("The parameter 'typeUtilisateurSollicitation' must be defined and cannot be null.");
        else
            url_ += "typeUtilisateurSollicitation=" + encodeURIComponent("" + typeUtilisateurSollicitation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPreferencesSollicitation(_response);
        });
    }

    protected processGetPreferencesSollicitation(response: Response): Promise<PreferencesSollicitation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreferencesSollicitation;
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("S\'il n\'y a pas de donn\u00e9es de pr\u00e9f\u00e9rences de sollicitation", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreferencesSollicitation>(null as any);
    }

    /**
     * Permet de récupérer l'URL de création d'un formulaire Dominho
     * @param numeroSecuriteSocialePatient (optional) numéro de sécurité sociale du patient
     * @return OK
     */
    getUrlToCreateDominhoForm(idTechPsIdentifie: string, idTechPsReceveur: string, ippr: string, idConversation: string, idFicheDominho: string, numeroSecuriteSocialePatient?: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/sollicitation/conversation/{idConversation}/url-create-dominho-form?";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (idTechPsReceveur === undefined || idTechPsReceveur === null)
            throw new globalThis.Error("The parameter 'idTechPsReceveur' must be defined and cannot be null.");
        else
            url_ += "idTechPsReceveur=" + encodeURIComponent("" + idTechPsReceveur) + "&";
        if (ippr === undefined || ippr === null)
            throw new globalThis.Error("The parameter 'ippr' must be defined and cannot be null.");
        else
            url_ += "ippr=" + encodeURIComponent("" + ippr) + "&";
        if (idFicheDominho === undefined || idFicheDominho === null)
            throw new globalThis.Error("The parameter 'idFicheDominho' must be defined and cannot be null.");
        else
            url_ += "idFicheDominho=" + encodeURIComponent("" + idFicheDominho) + "&";
        if (numeroSecuriteSocialePatient === null)
            throw new globalThis.Error("The parameter 'numeroSecuriteSocialePatient' cannot be null.");
        else if (numeroSecuriteSocialePatient !== undefined)
            url_ += "numeroSecuriteSocialePatient=" + encodeURIComponent("" + numeroSecuriteSocialePatient) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUrlToCreateDominhoForm(_response);
        });
    }

    protected processGetUrlToCreateDominhoForm(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : _responseText as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Permet de récupérer l'URL d'ouverture d'un formulaire Dominho existant
     * @return OK
     */
    getUrlToOpenDominhoForm(idTechPsIdentifie: string, idTechPsReceveur: string, idConversation: string, idFormulaire: string, dominhoFormAccessMode: DominhoFormAccessMode): Promise<string> {
        let url_ = this.baseUrl + "/api/sollicitation/conversation/{idConversation}/url-open-dominho-form?";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (idTechPsReceveur === undefined || idTechPsReceveur === null)
            throw new globalThis.Error("The parameter 'idTechPsReceveur' must be defined and cannot be null.");
        else
            url_ += "idTechPsReceveur=" + encodeURIComponent("" + idTechPsReceveur) + "&";
        if (idFormulaire === undefined || idFormulaire === null)
            throw new globalThis.Error("The parameter 'idFormulaire' must be defined and cannot be null.");
        else
            url_ += "idFormulaire=" + encodeURIComponent("" + idFormulaire) + "&";
        if (dominhoFormAccessMode === undefined || dominhoFormAccessMode === null)
            throw new globalThis.Error("The parameter 'dominhoFormAccessMode' must be defined and cannot be null.");
        else
            url_ += "dominhoFormAccessMode=" + encodeURIComponent("" + dominhoFormAccessMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUrlToOpenDominhoForm(_response);
        });
    }

    protected processGetUrlToOpenDominhoForm(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : _responseText as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Permet d'ajouter les données de sollicitation dans la table dédiée
     * @param idConversation Identifiant de la conversation à laquelle sont liées les données de sollicitation
     * @param body (optional) 
     * @return Created
     */
    createSollicitation(idConversation: string, body?: CreateSollicitationRequest | undefined): Promise<Sollicitation> {
        let url_ = this.baseUrl + "/api/sollicitation/conversation/{idConversation}";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSollicitation(_response);
        });
    }

    protected processCreateSollicitation(response: Response): Promise<Sollicitation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Sollicitation;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Sollicitation>(null as any);
    }

    /**
     * Permet de passer le statut d'une TLE de "Initialisee" à "En cours" ou de "En cours" à "Clôturée", puis de sauvegarder son niveau de facturation
    Permet également de passer le statut d'une demande d'appui de "Initialisee" à "En cours"
     * @param idConversation Identifiant de la conversation
     * @param body (optional) Données nécessaires pour changer le statut de la sollicitation
     * @return OK
     */
    setStatutEtatSollicitation(idConversation: string, body?: SetStatutEtatSollicitationRequest | undefined): Promise<EtatSollicitation> {
        let url_ = this.baseUrl + "/api/sollicitation/conversation/{idConversation}/statut/etatSollicitation";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetStatutEtatSollicitation(_response);
        });
    }

    protected processSetStatutEtatSollicitation(response: Response): Promise<EtatSollicitation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EtatSollicitation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EtatSollicitation>(null as any);
    }

    /**
     * Permet de finaliser un téléexpertise en passant la cotisation (niveau de facturation ainsi que
    les numéros de facturation du requerant et de l'expert
     * @param idConversation Identifiant de la conversation
     * @param body (optional) Données nécessaires sauvegarder les numéros de facturations
     * @return OK
     */
    setFacturationTeleexpertise(idConversation: string, body?: SetFacturationTeleExpertiseRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sollicitation/teleexpertise/{idConversation}/facturation";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetFacturationTeleexpertise(_response);
        });
    }

    protected processSetFacturationTeleexpertise(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Permet de récupérer les niveaux de facturation pour les sollicitations
     * @return OK
     */
    getNiveauxFacturationSollicitation(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/sollicitation/niveaux-facturation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNiveauxFacturationSollicitation(_response);
        });
    }

    protected processGetNiveauxFacturationSollicitation(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Permet de sauvegarder un numéro de facturation
     * @param body (optional) 
     * @return Le numéro de facturation sauvegardé.
     */
    saveNumeroFacturationSollicitation(idTechPsIdentifie: string, body?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/sollicitation/{idTechPsIdentifie}/numero-facturation";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined.");
        url_ = url_.replace("{idTechPsIdentifie}", encodeURIComponent("" + idTechPsIdentifie));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveNumeroFacturationSollicitation(_response);
        });
    }

    protected processSaveNumeroFacturationSollicitation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Permet de récupérer une liste de numéros de facturation
     * @return OK
     */
    getNumerosFacturationSollicitation(listeIdTechPsCible: string[]): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/sollicitation/numeros-facturation?";
        if (listeIdTechPsCible === undefined || listeIdTechPsCible === null)
            throw new globalThis.Error("The parameter 'listeIdTechPsCible' must be defined and cannot be null.");
        else
            listeIdTechPsCible && listeIdTechPsCible.forEach(item => { url_ += "listeIdTechPsCible=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNumerosFacturationSollicitation(_response);
        });
    }

    protected processGetNumerosFacturationSollicitation(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * Permet de sauvegarder la déclaration d'expert/d'équipe ressource
     * @param body (optional) Données de préférences de sollicitation à sauvegarder
     * @return Les préférences de sollicitation sauvegardées
     */
    savePreferencesSollicitation(idTechPsIdentifie: string, body?: SavePreferencesSollicitationRequest | undefined): Promise<PreferencesSollicitation> {
        let url_ = this.baseUrl + "/api/sollicitation/{idTechPsIdentifie}";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined.");
        url_ = url_.replace("{idTechPsIdentifie}", encodeURIComponent("" + idTechPsIdentifie));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSavePreferencesSollicitation(_response);
        });
    }

    protected processSavePreferencesSollicitation(response: Response): Promise<PreferencesSollicitation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreferencesSollicitation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreferencesSollicitation>(null as any);
    }

    /**
     * Permet de récupérer la configuration nécessaire à la page de préférences de sollicitation
     * @param typeUtilisateur Type de receveur sollicité : expert, équipe ressource
     * @return Configurations de la page de préférences de sollicitation
     */
    getConfigurationPreferencesSollicitation(typeUtilisateur: TypeUtilisateurSollicitation): Promise<ConfigurationPreferencesSollicitation> {
        let url_ = this.baseUrl + "/api/sollicitation/configuration?";
        if (typeUtilisateur === undefined || typeUtilisateur === null)
            throw new globalThis.Error("The parameter 'typeUtilisateur' must be defined and cannot be null.");
        else
            url_ += "typeUtilisateur=" + encodeURIComponent("" + typeUtilisateur) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfigurationPreferencesSollicitation(_response);
        });
    }

    protected processGetConfigurationPreferencesSollicitation(response: Response): Promise<ConfigurationPreferencesSollicitation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConfigurationPreferencesSollicitation;
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigurationPreferencesSollicitation>(null as any);
    }

    /**
     * Renvoie un fichier de prérequis de sollicitation avec son contenu
     * @param idFichierSollicitation Identifiant du fichier recherché
     * @param typeUtilisateurSollicitation Type d'utilisateur de sollicitation : Expert ou EquipeRessource
     * @return Download a file.
     */
    getDocumentPrerequisSollicitation(idFichierSollicitation: string, typeUtilisateurSollicitation: TypeUtilisateurSollicitation): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/sollicitation/fichier/{idFichierSollicitation}?";
        if (idFichierSollicitation === undefined || idFichierSollicitation === null)
            throw new globalThis.Error("The parameter 'idFichierSollicitation' must be defined.");
        url_ = url_.replace("{idFichierSollicitation}", encodeURIComponent("" + idFichierSollicitation));
        if (typeUtilisateurSollicitation === undefined || typeUtilisateurSollicitation === null)
            throw new globalThis.Error("The parameter 'typeUtilisateurSollicitation' must be defined and cannot be null.");
        else
            url_ += "typeUtilisateurSollicitation=" + encodeURIComponent("" + typeUtilisateurSollicitation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentPrerequisSollicitation(_response);
        });
    }

    protected processGetDocumentPrerequisSollicitation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Renvoie le formulaire dominho rempli sous forme de fichier pdf
     * @param idDocument Id Document Dominho
     * @return Download a file.
     */
    getFichierFormulaireDominhoFromIdDoc(idDocument: string): Promise<FileBase64Encoded> {
        let url_ = this.baseUrl + "/api/sollicitation/fichier-formulaire/{idDocument}";
        if (idDocument === undefined || idDocument === null)
            throw new globalThis.Error("The parameter 'idDocument' must be defined.");
        url_ = url_.replace("{idDocument}", encodeURIComponent("" + idDocument));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFichierFormulaireDominhoFromIdDoc(_response);
        });
    }

    protected processGetFichierFormulaireDominhoFromIdDoc(response: Response): Promise<FileBase64Encoded> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileBase64Encoded;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileBase64Encoded>(null as any);
    }

    /**
     * Envoie le rapport pdf d'un formulaire dans la conversation
     * @param idTechPsIdentifie Id Tech Ps Identifie
     * @param idFormulaire Id Formulaire
     * @return Generate Report.
     */
    getReportForm(idTechPsIdentifie: string, idFormulaire: string): Promise<void> {
        let url_ = this.baseUrl + "/api/sollicitation/{idFormulaire}/generate-report?";
        if (idFormulaire === undefined || idFormulaire === null)
            throw new globalThis.Error("The parameter 'idFormulaire' must be defined.");
        url_ = url_.replace("{idFormulaire}", encodeURIComponent("" + idFormulaire));
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportForm(_response);
        });
    }

    protected processGetReportForm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Renvoie un booléen pour savoir si l'application de télé-expertise peut être ouverte en iframe
     * @param idTechPsCible Identifiant du ps cible
     * @param parentUrl Url de l'application parente de l'iframe
     * @return OK
     */
    getDroitOuvrirIframeTleModeAdmin(idTechPsCible: string, parentUrl: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/sollicitation/iframe-app-tle/{idTechPsCible}/is-authorized?";
        if (idTechPsCible === undefined || idTechPsCible === null)
            throw new globalThis.Error("The parameter 'idTechPsCible' must be defined.");
        url_ = url_.replace("{idTechPsCible}", encodeURIComponent("" + idTechPsCible));
        if (parentUrl === undefined || parentUrl === null)
            throw new globalThis.Error("The parameter 'parentUrl' must be defined and cannot be null.");
        else
            url_ += "parentUrl=" + encodeURIComponent("" + parentUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDroitOuvrirIframeTleModeAdmin(_response);
        });
    }

    protected processGetDroitOuvrirIframeTleModeAdmin(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface ISSOClient {

    /**
     * Crée un ProtectedCertificate à partir d'un artefact
     * @return OK
     * @deprecated
     */
    createProtectedCertificateFromArtefact(senderId: string, artefactId: string, password: string, prefix: string,  cancelToken?: CancelToken): Promise<CreateCertificateResponse>;

    /**
     * Génère un Token pour une application donnée
     * @param body (optional) Données nécessaires à la génération du token
     * @return OK
     */
    generateWebToken(body?: GenerateWebTokenRequest | undefined,  cancelToken?: CancelToken): Promise<TokenAccessData>;
}

export class SSOClient extends AuthorizedApiBase implements ISSOClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Crée un ProtectedCertificate à partir d'un artefact
     * @return OK
     * @deprecated
     */
    createProtectedCertificateFromArtefact(senderId: string, artefactId: string, password: string, prefix: string): Promise<CreateCertificateResponse> {
        let url_ = this.baseUrl + "/api/SSO/CreateProtectedCertificateFromArtefact?";
        if (senderId === undefined || senderId === null)
            throw new globalThis.Error("The parameter 'senderId' must be defined and cannot be null.");
        else
            url_ += "senderId=" + encodeURIComponent("" + senderId) + "&";
        if (artefactId === undefined || artefactId === null)
            throw new globalThis.Error("The parameter 'artefactId' must be defined and cannot be null.");
        else
            url_ += "artefactId=" + encodeURIComponent("" + artefactId) + "&";
        if (password === undefined || password === null)
            throw new globalThis.Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (prefix === undefined || prefix === null)
            throw new globalThis.Error("The parameter 'prefix' must be defined and cannot be null.");
        else
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateProtectedCertificateFromArtefact(_response);
        });
    }

    protected processCreateProtectedCertificateFromArtefact(response: Response): Promise<CreateCertificateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCertificateResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCertificateResponse>(null as any);
    }

    /**
     * Génère un Token pour une application donnée
     * @param body (optional) Données nécessaires à la génération du token
     * @return OK
     */
    generateWebToken(body?: GenerateWebTokenRequest | undefined): Promise<TokenAccessData> {
        let url_ = this.baseUrl + "/api/SSO/GenerateWebToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateWebToken(_response);
        });
    }

    protected processGenerateWebToken(response: Response): Promise<TokenAccessData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenAccessData;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenAccessData>(null as any);
    }
}

export interface ISticClient {

    /**
     * Renvoie les infos détaillées du patient via son IPPR
     * @param idTechPsIdentifie Identifiant de l'utilisateur pour lequel on travaille. Voir la notion de délégué-déléguant
     * @param ippr Identifiant du patient concerné
     * @return OK
     */
    getPatient(idTechPsIdentifie: string, ippr: string,  cancelToken?: CancelToken): Promise<PatientDetail>;

    /**
     * Renvoie une liste de patients correspondant à des mots-clefs
     * @param motsClefs Liste des mots-clés de recherche
     * @param maxResult Nombre de résultats retournés
     * @param idTechPsIdentifie Identifiant de l'utilisateur pour lequel on travaille. Voir la notion de délégué-déléguant
     * @return OK
     */
    getListePatientsParMotsClefs(motsClefs: string, maxResult: number, idTechPsIdentifie: string,  cancelToken?: CancelToken): Promise<PatientHabilitation[]>;

    /**
     * Pour mobile, renvoie une liste de DistancePatient par rapport aux coordonnées GPS envoyées
     * @return OK
     */
    getListeDistancePatients(listeIpprs: string, latitude: number, longitude: number,  cancelToken?: CancelToken): Promise<DistancePatient[]>;

    /**
     * @param body (optional) 
     * @return OK
     */
    createPatient(idTechPsIdentifie: string, body?: CreatePatientRequest | undefined,  cancelToken?: CancelToken): Promise<PatientDetail>;

    /**
     * Inscrit un nouveau patient dans STIC et DPPR.
     * @param body (optional) 
     * @return OK
     */
    inscrirePatient(idTechPsIdentifie: string, body?: InscrirePatientRequest | undefined,  cancelToken?: CancelToken): Promise<string>;

    /**
     * Construit la chaine cryptée avec les params du patient sélectionné et du PS connecté
     * @param body (optional) 
     * @return OK
     */
    getEncryptedParams(body?: GetEncryptedParamsRequest | undefined,  cancelToken?: CancelToken): Promise<string>;

    /**
     * @param body (optional) 
     * @return OK
     */
    createPatient_v2(idTechPsIdentifie: string, body?: CreatePatientRequest_v2 | undefined,  cancelToken?: CancelToken): Promise<PatientDetail>;

    /**
     * Recherche de patients selon les critères utiles à l'identito vigilance.
     * @param body (optional) 
     * @return OK
     */
    searchPatientsForVigilance(body?: SearchPatientsForVigilanceRequest | undefined,  cancelToken?: CancelToken): Promise<AppPatientVigilance[]>;

    /**
     * Création d'une auto-habilitation sur un patient pour l'utilisateur connecté après vérification d'une pièce d'identité
     * @param body (optional) 
     * @return OK
     */
    createAutoHabilitation(body?: CreateAutoHabilitationRequest | undefined,  cancelToken?: CancelToken): Promise<AppPatientHabilitation>;

    /**
     * Création d'une habilitation en mode bris de glace sur un patient pour l'utilisateur connecté.
     * @param body (optional) 
     * @return OK
     */
    createAccesBrisDeGlace(body?: CreateAccesBrisDeGlaceRequest | undefined,  cancelToken?: CancelToken): Promise<AppPatientHabilitation>;

    /**
     * @param body (optional) 
     * @return OK
     */
    getListePatients(idTechPsIdentifie: string, body?: GetListePatientsRequest | undefined,  cancelToken?: CancelToken): Promise<PatientHabilitation[]>;
}

export class SticClient extends AuthorizedApiBase implements ISticClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Renvoie les infos détaillées du patient via son IPPR
     * @param idTechPsIdentifie Identifiant de l'utilisateur pour lequel on travaille. Voir la notion de délégué-déléguant
     * @param ippr Identifiant du patient concerné
     * @return OK
     */
    getPatient(idTechPsIdentifie: string, ippr: string): Promise<PatientDetail> {
        let url_ = this.baseUrl + "/api/Stic/GetPatient?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (ippr === undefined || ippr === null)
            throw new globalThis.Error("The parameter 'ippr' must be defined and cannot be null.");
        else
            url_ += "ippr=" + encodeURIComponent("" + ippr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPatient(_response);
        });
    }

    protected processGetPatient(response: Response): Promise<PatientDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatientDetail;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientDetail>(null as any);
    }

    /**
     * Renvoie une liste de patients correspondant à des mots-clefs
     * @param motsClefs Liste des mots-clés de recherche
     * @param maxResult Nombre de résultats retournés
     * @param idTechPsIdentifie Identifiant de l'utilisateur pour lequel on travaille. Voir la notion de délégué-déléguant
     * @return OK
     */
    getListePatientsParMotsClefs(motsClefs: string, maxResult: number, idTechPsIdentifie: string): Promise<PatientHabilitation[]> {
        let url_ = this.baseUrl + "/api/Stic/GetListePatientsParMotsClefs?";
        if (motsClefs === undefined || motsClefs === null)
            throw new globalThis.Error("The parameter 'motsClefs' must be defined and cannot be null.");
        else
            url_ += "motsClefs=" + encodeURIComponent("" + motsClefs) + "&";
        if (maxResult === undefined || maxResult === null)
            throw new globalThis.Error("The parameter 'maxResult' must be defined and cannot be null.");
        else
            url_ += "maxResult=" + encodeURIComponent("" + maxResult) + "&";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListePatientsParMotsClefs(_response);
        });
    }

    protected processGetListePatientsParMotsClefs(response: Response): Promise<PatientHabilitation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatientHabilitation[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientHabilitation[]>(null as any);
    }

    /**
     * Pour mobile, renvoie une liste de DistancePatient par rapport aux coordonnées GPS envoyées
     * @return OK
     */
    getListeDistancePatients(listeIpprs: string, latitude: number, longitude: number): Promise<DistancePatient[]> {
        let url_ = this.baseUrl + "/api/Stic/GetListeDistancePatients?";
        if (listeIpprs === undefined || listeIpprs === null)
            throw new globalThis.Error("The parameter 'listeIpprs' must be defined and cannot be null.");
        else
            url_ += "listeIpprs=" + encodeURIComponent("" + listeIpprs) + "&";
        if (latitude === undefined || latitude === null)
            throw new globalThis.Error("The parameter 'latitude' must be defined and cannot be null.");
        else
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === undefined || longitude === null)
            throw new globalThis.Error("The parameter 'longitude' must be defined and cannot be null.");
        else
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListeDistancePatients(_response);
        });
    }

    protected processGetListeDistancePatients(response: Response): Promise<DistancePatient[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DistancePatient[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DistancePatient[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPatient(idTechPsIdentifie: string, body?: CreatePatientRequest | undefined): Promise<PatientDetail> {
        let url_ = this.baseUrl + "/api/Stic/CreatePatient?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePatient(_response);
        });
    }

    protected processCreatePatient(response: Response): Promise<PatientDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatientDetail;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientDetail>(null as any);
    }

    /**
     * Inscrit un nouveau patient dans STIC et DPPR.
     * @param body (optional) 
     * @return OK
     */
    inscrirePatient(idTechPsIdentifie: string, body?: InscrirePatientRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Stic/InscrirePatient?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInscrirePatient(_response);
        });
    }

    protected processInscrirePatient(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Construit la chaine cryptée avec les params du patient sélectionné et du PS connecté
     * @param body (optional) 
     * @return OK
     */
    getEncryptedParams(body?: GetEncryptedParamsRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Stic/GetEncryptedParams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEncryptedParams(_response);
        });
    }

    protected processGetEncryptedParams(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : _responseText as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPatient_v2(idTechPsIdentifie: string, body?: CreatePatientRequest_v2 | undefined): Promise<PatientDetail> {
        let url_ = this.baseUrl + "/api/Stic/CreatePatient_v2?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePatient_v2(_response);
        });
    }

    protected processCreatePatient_v2(response: Response): Promise<PatientDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatientDetail;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientDetail>(null as any);
    }

    /**
     * Recherche de patients selon les critères utiles à l'identito vigilance.
     * @param body (optional) 
     * @return OK
     */
    searchPatientsForVigilance(body?: SearchPatientsForVigilanceRequest | undefined): Promise<AppPatientVigilance[]> {
        let url_ = this.baseUrl + "/api/Stic/SearchPatientsForVigilance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchPatientsForVigilance(_response);
        });
    }

    protected processSearchPatientsForVigilance(response: Response): Promise<AppPatientVigilance[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPatientVigilance[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppPatientVigilance[]>(null as any);
    }

    /**
     * Création d'une auto-habilitation sur un patient pour l'utilisateur connecté après vérification d'une pièce d'identité
     * @param body (optional) 
     * @return OK
     */
    createAutoHabilitation(body?: CreateAutoHabilitationRequest | undefined): Promise<AppPatientHabilitation> {
        let url_ = this.baseUrl + "/api/Stic/CreateAutoHabilitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAutoHabilitation(_response);
        });
    }

    protected processCreateAutoHabilitation(response: Response): Promise<AppPatientHabilitation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPatientHabilitation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppPatientHabilitation>(null as any);
    }

    /**
     * Création d'une habilitation en mode bris de glace sur un patient pour l'utilisateur connecté.
     * @param body (optional) 
     * @return OK
     */
    createAccesBrisDeGlace(body?: CreateAccesBrisDeGlaceRequest | undefined): Promise<AppPatientHabilitation> {
        let url_ = this.baseUrl + "/api/Stic/CreateAccesBrisDeGlace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAccesBrisDeGlace(_response);
        });
    }

    protected processCreateAccesBrisDeGlace(response: Response): Promise<AppPatientHabilitation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppPatientHabilitation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppPatientHabilitation>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getListePatients(idTechPsIdentifie: string, body?: GetListePatientsRequest | undefined): Promise<PatientHabilitation[]> {
        let url_ = this.baseUrl + "/api/Stic/GetListePatients?";
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListePatients(_response);
        });
    }

    protected processGetListePatients(response: Response): Promise<PatientHabilitation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatientHabilitation[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientHabilitation[]>(null as any);
    }
}

export interface IUserManagementClient {

    /**
     * Demande de réinitialisation de mot de passe en mode simple
     * @param login login paramétrable ou idTechPs (nouvelle version AnnuaireSécu)
     * @param mode Simple (lien activation par mail + code SMS) ou MobileFactor (code activation par SMS)
     * @return OK
     */
    requestPasswordChange(login: string, mode: string,  cancelToken?: CancelToken): Promise<RequestPasswordPasswordChangeResult>;

    /**
     * Permet de savoir si l'utilisateur a défini un mot de passe protail
     * @param userLogin idTechPS !!!
     * @return OK
     */
    activeDirectoryAccountExist(userLogin: string,  cancelToken?: CancelToken): Promise<boolean>;

    /**
     * Mise à jour du mot de passe de l'utilisateur
     * @param codeActivation Code d'activation / réinitialisation de compte (obtenu par requestChangePassword)
     * @param login Identifiant paramétrable de l'utilisateur
     * @param password Nouveau mot de passe de l'utilisateur
     * @return OK
     */
    changePassword(codeActivation: string, login: string, password: string,  cancelToken?: CancelToken): Promise<void>;
}

export class UserManagementClient extends AuthorizedApiBase implements IUserManagementClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Demande de réinitialisation de mot de passe en mode simple
     * @param login login paramétrable ou idTechPs (nouvelle version AnnuaireSécu)
     * @param mode Simple (lien activation par mail + code SMS) ou MobileFactor (code activation par SMS)
     * @return OK
     */
    requestPasswordChange(login: string, mode: string): Promise<RequestPasswordPasswordChangeResult> {
        let url_ = this.baseUrl + "/api/UserManagement/RequestPasswordChange?";
        if (login === undefined || login === null)
            throw new globalThis.Error("The parameter 'login' must be defined and cannot be null.");
        else
            url_ += "login=" + encodeURIComponent("" + login) + "&";
        if (mode === undefined || mode === null)
            throw new globalThis.Error("The parameter 'mode' must be defined and cannot be null.");
        else
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestPasswordChange(_response);
        });
    }

    protected processRequestPasswordChange(response: Response): Promise<RequestPasswordPasswordChangeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestPasswordPasswordChangeResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestPasswordPasswordChangeResult>(null as any);
    }

    /**
     * Permet de savoir si l'utilisateur a défini un mot de passe protail
     * @param userLogin idTechPS !!!
     * @return OK
     */
    activeDirectoryAccountExist(userLogin: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/UserManagement/ActiveDirectoryAccountExist?";
        if (userLogin === undefined || userLogin === null)
            throw new globalThis.Error("The parameter 'userLogin' must be defined and cannot be null.");
        else
            url_ += "userLogin=" + encodeURIComponent("" + userLogin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processActiveDirectoryAccountExist(_response);
        });
    }

    protected processActiveDirectoryAccountExist(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Mise à jour du mot de passe de l'utilisateur
     * @param codeActivation Code d'activation / réinitialisation de compte (obtenu par requestChangePassword)
     * @param login Identifiant paramétrable de l'utilisateur
     * @param password Nouveau mot de passe de l'utilisateur
     * @return OK
     */
    changePassword(codeActivation: string, login: string, password: string): Promise<void> {
        let url_ = this.baseUrl + "/api/UserManagement/ChangePassword?";
        if (codeActivation === undefined || codeActivation === null)
            throw new globalThis.Error("The parameter 'codeActivation' must be defined and cannot be null.");
        else
            url_ += "codeActivation=" + encodeURIComponent("" + codeActivation) + "&";
        if (login === undefined || login === null)
            throw new globalThis.Error("The parameter 'login' must be defined and cannot be null.");
        else
            url_ += "login=" + encodeURIComponent("" + login) + "&";
        if (password === undefined || password === null)
            throw new globalThis.Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ActeurPatient {
    /** Adresse de résidence du PS. */
    adresse: string;
    /** Civilité du PS. */
    civilite: string;
    /** Code postal de résidence du PS. */
    codePostal: string;
    /** Commentaire personnel de l'acteur concernant le dossier patient. */
    commentairePatient: string;
    /** Date de création de l'acteur patient. */
    dateCreation: Date;
    /** Date du dernier suivi du patient par le PS. */
    dateDernierSuivi?: Date | undefined;
    /** Récurrence des rappels de suivi du patient par le PS. */
    delaiRecurrenceJour: number;
    /** Adresse e-mail du PS. */
    email: string;
    /** Statut d'habilitation du PS sur le patient. */
    habilitationDossier: HabilitationDossier;
    /** Identifiant technique de l'acteur patient. */
    id: number;
    /** Identifiant national de l'acteur */
    idNat: string;
    /** Identifiant du statut de l'acteur patient. */
    idStatutActeur: number;
    /** Identifiant technique du PS associé à l'acteur patient. */
    idTechPs: string;
    /** Identifiant technique du dossier patient associé à l'acteur patient. */
    ippr: string;
    /** Libellé du statut de l'acteur patient. */
    libelleStatutActeur: string;
    /** Nom usuel du patient. */
    nomUsuel: string;
    /** Note personnelle du PS. */
    notePersonnellePS: string;
    /** Prénom du PS. */
    prenom: string;
    /** Profession du PS. */
    profession: string;
    /** Spécialité du PS. */
    specialite: Specialite;
    /** Structure du PS. */
    structure: string;
    /** Numéro de téléphone mobile du PS. */
    telephoneMobile: string;
    /** Ville de résidence du PS. */
    ville: string;
    /** Indique si le PS a choisi de recevoir son courrier de manière dématérialisée. */
    zeroPapier: boolean;
    /** Indique si le PS a un email, meme s'il n'est pas partagé */
    hasEmail: boolean;
    telephoneSecretariat: string;
    telephoneFixe: string;
    /** Prénom Nom des délégants de type personne morale de l'acteur, concaténés par des ", " */
    libelleDelegantsPersonneMorale: string;
    /** Permet de connaitre si un acteur est modifiable ou non */
    estModifiable: boolean;
}

export interface AddMessageToConversationRequest {
    /** Identifiant de la conversation dans laquelle le message sera ajouté */
    idConversation: string;
    /** Fichier à transmettre en base64 */
    fileToSend: FileBase64Encoded;
    /** Message de l'échange */
    message: string;
    /** Décrit si le message est un message d'enregistrement (false) du formulaire ou de validation (true) du formulaire */
    finalized: boolean;
    /** Identifiant technique de l'auteur de l'échange */
    idTechPsAuteur: string;
}

export interface Adresse {
    idActivity: string;
    nomSite: string;
    voie: string;
    codePostal: string;
    codeInsee: string;
    ville: string;
    pays: string;
    isAdressePrincipale: boolean;
}

export interface AjouterActeurPatientPSRequest {
    idTechPsIdentifie: string;
    ippr: string;
    idStatutActeur: number;
    commentairePatient: string;
    dateDernierSuivi?: Date | undefined;
    delaiRecurrenceJour: number;
    habiliter?: boolean | undefined;
    dateFinHabilitation?: Date | undefined;
    passeDroit: string;
}

export interface AppGlobalAlertMessage {
    alertTitle: string;
    alertDescription: string;
    alertDateStart?: Date | undefined;
    alertDateEnd?: Date | undefined;
}

export interface AppPatientHabilitation {
    /** Identifiant technique de l'habilitation */
    id: number;
    /** Nom de l'habilitation */
    name: string;
    /** Identifiant technique du patient */
    patientId: number;
    /** Identifiant technique de l'organisation si l'habilitation est de ce type */
    organizationId?: number | undefined;
    /** Identifiant technique du professionnel si l'habilitation est de ce type */
    userId?: number | undefined;
    /** Date de création de l'habilitation */
    creationDate: Date;
}

export interface AppPatientVigilance {
    /** Identifiant technique du patient dans notre base interne */
    id?: number | undefined;
    /** Identifiant du patient dans l'annuaire régional : identifiant local. */
    regionalId: string;
    /** Identifiant du patient dans l'annuaire régional : identifiant global unique du patient. */
    regionalCentralId: string;
    /** Prénom du patient */
    firstName: string;
    /** Nom du patient */
    lastName: string;
    /** Prénom de naissance du patient */
    birthFirstName: string;
    /** Nom de naissance du patient */
    birthLastName: string;
    /** Code Insee de la ville de naissance du patient */
    birthCountry: string;
    /** Nom complet du patient */
    fullName: string;
    /** Lieu de naissance complet du patient */
    birthPlace: string;
    /** Sexe du patient */
    sex: string;
    /** Date de naissance du patient */
    birthDate: Date;
    /** Provenance de notre base de donnée interne. */
    isFromInternalBase: boolean;
    /** Provenance d'un annuaire distant régional. */
    isFromExternalBase: boolean;
    /** Staut de l'identité du patient */
    identityStatus: string;
    /** Numéro de mobile du patient */
    firstMobilePhone: string;
    /** Email du patient */
    email: string;
    /** Habilitation ou non de l'utilisateur connecté sur le patient trouvé */
    isUserHabilitedOnPatient: boolean;
}

export interface AppliquettePortail {
    libelle: string;
    logoUrl: string;
    index: number;
    liens: LienAppliquettePortail[];
}

/** Résultat de la demande d'association mobile par code OTP */
export interface AssociateDeviceOTPResult {
    associationNeeded: boolean;
    associationSuccess: boolean;
    idMobilite: string;
    message: string;
    otpSuccess: boolean;
    remainingAttempts?: number | undefined;
}

/** Regroupe les statuts d'authentification possible */
export enum AuthenticationStatus {
    None = "None",
    AuthenticationSuccess = "AuthenticationSuccess",
    AuthenticationFailure = "AuthenticationFailure",
    RedirectionSuccess = "RedirectionSuccess",
    TargetApplicationNotFound = "TargetApplicationNotFound",
    UnsufficientAuthenticationLevel = "UnsufficientAuthenticationLevel",
    AuthenticationRequired = "AuthenticationRequired",
    SpecificAuthenticationFailure = "SpecificAuthenticationFailure",
    ChartCheckedRequired = "ChartCheckedRequired",
    TechnicalError = "TechnicalError",
}

/** Transport object for an authorized profession/specialite combination */
export interface AutorizedSpecialite {
    /** Identifiant de la profession autorisée */
    idProfession: number;
    /** Identifiant de la spécialité autorisée */
    idSpecialite: number;
}

export interface CategoriePiece {
    id: number;
    libelle: string;
    listeTypes: TypePiece[];
}

export enum CertificateContentType {
    Unknown = "Unknown",
    Cert = "Cert",
    SerializedCert = "SerializedCert",
    Pkcs12 = "Pkcs12",
    SerializedStore = "SerializedStore",
    Pkcs7 = "Pkcs7",
    Authenticode = "Authenticode",
}

/** Structure de la configuration de l'application Front */
export interface ConfigurationFront {
    /** Nom du client */
    client: string;
    clientColorBgMessagerie: string;
    displayRecentPatients: boolean;
    downloadDocumentUseDocumentHandler: boolean;
    typeConversationResultat: boolean;
    isSupprimerEchange: boolean;
    timerSupprimerEchange: number;
    typeConversationRendezVous: boolean;
    affichageDesBrouillons: boolean;
    copieAuPatient: boolean;
    moduleChoixDestinatairesMSS: boolean;
    autoPartageCopieDossierPatient: boolean;
    autoPartageTransfertDocument: boolean;
    partagePatientNouvelleConversation: boolean;
    partageDefaultValueNouvelleConversation: boolean;
    visio: boolean;
    boutonTeleExpertise: boolean;
    teleExpertise: boolean;
    boutonSolliciterEquipeRessource: boolean;
    telechargementOnClick: boolean;
    ouvertureDossierPatient: boolean;
    transmissionCourrier: boolean;
    showVignette: boolean;
    telechargerAuFormatPDF: boolean;
    menuActionsPatient: boolean;
    gestionAbsences: boolean;
    deconnexion: boolean;
    useAnnuaireMSSOnly: boolean;
    nouveauMessageImportant: boolean;
    shareDocumentToPatientFolder: boolean;
    favorisPSDestinataire: boolean;
    typeConversationMSS: boolean;
    boutonDemarrerConversationMSS: boolean;
    moduleRechercheIDEOPrefixeIdTechPS: boolean;
    moduleRechercheFiltrePPOnly: boolean;
    geolocation: boolean;
    manageCourrierAsMss: boolean;
    moduleRechercheIgnoreEmail: boolean;
    moduleRechercheUsesAutocompleteWho: boolean;
    redirectionLogo: boolean;
    isPatientCenteredConversation: boolean;
    isProfessionFieldAvailable: boolean;
    isSearchWithoutSelectionAvailable: boolean;
    isSelectAllWithoutMailAvailable: boolean;
    showProfessionInSelectedPsList: boolean;
    moduleRechercheInvitationConfrere: boolean;
    isFolderForConvPatientCentered: boolean;
    rechercheAnnuairePatient: boolean;
    ouvrirGalerie: boolean;
    retirerImportantQuestion: boolean;
    typeConversationEchangePatient: boolean;
    typeConversationMSSPatient: boolean;
    typeConversationCourrierPatient: boolean;
    typeConversationDemandeAppui: boolean;
    typeConversationTeleExpertise: boolean;
    sujetConversationObligatoire: boolean;
    ajoutCommentaireParDefautEnvoiPJ: boolean;
    preferenceMessagerieButton: boolean;
    connexionPAS: boolean;
    wsRenvoieMajuscules: boolean;
    patientIdentityStatus: boolean;
    openConfigurationLGConFirstConnection: boolean;
    setPsIdentifieInLienDoc: boolean;
    typeConversationDGSUrgent: boolean;
    txtAvertissementRechercheMesssages: string;
    moduleRechercheModeLessResults: boolean;
    codePinOublie: boolean;
    sectionMenuNouveauMessage: boolean;
    ajoutPatientFileActive: boolean;
    associationMSSExternal: boolean;
    hideFavorisMss: boolean;
    hideRecentsMss: boolean;
    useWebSocketIO: boolean;
    typeConversationCourriers: boolean;
    dateDebutFinPopupAbsence: boolean;
    hideStatutEquipeRessources: boolean;
    suggestionsConversationsExistantesAvantCreation: boolean;
    envoiMSSPatient: boolean;
    separerEnvoyesRecusBoites: string[];
    repondreAEchange: boolean;
    useBgColorNonLu: boolean;
    mssTextColor: string;
    accesFormulaire: boolean;
    /** Permet de choisir le type de formulaire utilisé */
    formulaireType: EFormulaireType;
    typesConversationsGestionChat: ConversationType[];
    typesConversationsGestionMSS: ConversationType[];
    isMuteAvailable: boolean;
    enableGroupe: boolean;
    isDGSUrgent: boolean;
    isMentionAvailable: boolean;
    /** Décrit si l'affichage des vignettes se base sur le type MIME */
    vignetteConditionIsTypeMime: boolean;
    showChatSollicitationDesactiveText: boolean;
    moduleRechercheExpertRessource: boolean;
}

export interface ConfigurationMobile {
    isVisio: boolean;
    isCourrier: boolean;
    isBrouillon: boolean;
    isMSS: boolean;
    isMSSMessages: boolean;
    isMSSPatient: boolean;
    isEchangePatient: boolean;
    isDGSUrgent: boolean;
    isDisplayPreferenceResultat: boolean;
    isDisplayPreferenceRDV: boolean;
    isTeleExpertise: boolean;
    isDemandeAppui: boolean;
    isFormulaireAvailable: boolean;
    isSollicitationEquipe: boolean;
    isSollicitationExpert: boolean;
    isCGUStepValidation: boolean;
    isGlobalAlertMessage: boolean;
    isWebSocketIO: boolean;
    isSousBoitesMSS: boolean;
    isSendMSSPatient: boolean;
    isMailUserToComplete: boolean;
    isStatut: boolean;
    isAppearWithAbsentStatut: boolean;
    isAppearAbsentWithDates: boolean;
    isAfficherTypePieceDansBoiteReception: boolean;
    isDocumentsJuridiques: boolean;
    isSearchPatientFromPortail: boolean;
    isMyProfileMenu: boolean;
    isDisplayProfessionPS: boolean;
    isEnableRemoveImportantQuestion: boolean;
    isTypeMimeVignetteCondition: boolean;
    isRepondreA: boolean;
    isSupprimerEchange: boolean;
    pageSizeEchange: number;
    isAccessPatientFolder: boolean;
    isFileActiveDistancePatientTab: boolean;
    isFileActiveDernierDossiersConsultesTab: boolean;
    isCreationPatientScreen: boolean;
    isShareDocumentToPatientFolder: boolean;
    isShareDocumentToPatientFolderForCourrierOnly: boolean;
    isShareDocumentDefaultValueNouvelleConversation: boolean;
    isTagStatutPatient: boolean;
    isFolderForConvPatientCentered: boolean;
    isChangePatientHabilitationAvailable: boolean;
    isInvitationInactiveColleagueEnable: boolean;
    isInvitationColleagueAbsentAnnuaireEnable: boolean;
    isInvitationFromBackend: boolean;
    isInvitationSMS: boolean;
    isAutocompleteRecherchePS: boolean;
    isSearchWithoutSelectionAvailable: boolean;
    isSortedByLastName: boolean;
    isShowAnnuairePPDetail: boolean;
    isLongLabelsDestinataires: boolean;
    isProfessionFieldAvailable: boolean;
    isFiltrePS: boolean;
    typesConversationsGestionMSS: ConversationType[];
    typesConversationsGestionChat: ConversationType[];
    isShowGroupSection: boolean;
    /** Timer qui indique le temps jusqu'auquel on peut supprimer le message en partant de l'heure d'envoi de celui-ci (en minutes) */
    timerSupprimerEchange: number;
    isMuteAvailable: boolean;
    isMentionAvailable: boolean;
    showChatSollicitationDesactiveText: boolean;
    moduleRechercheExpertRessource: boolean;
}

/** Structure de la configuration nécessaire à la page de préférences de sollicitation */
export interface ConfigurationPreferencesSollicitation {
    /** Liste des types de formulaires utilisables par les receveurs de sollicitation */
    typesFormulaireSollicitation: TypeFormulaireSollicitation[];
    /** Ensemble des liens utilisés dans la page de préférences de sollicitation */
    linksPreferencesSollicitation: LinksPreferencesSollicitation;
}

/** Contact OTP */
export interface Contact {
    /** Type de contact */
    type: OTPContactType;
    /** Valeur */
    value: string;
}

export interface ConversationDetail {
    idConversation: string;
    patient?: PatientConv | undefined;
    patientIppr?: string | undefined;
    sujet: string;
    listeEchanges: Echange[];
    listeEchangesCount: number;
    listeDestinataires: DestinataireReduit[];
    favorite: boolean;
    archivee: boolean;
    aTraiter: boolean;
    /** Délégant concerné */
    idTechPsDelegant: string;
    dateLecture?: Date | undefined;
    estLue: boolean;
    estPartagee: boolean;
    listeEvenements: Evenement[];
    montrerToutDestinataireOuNon?: boolean | undefined;
    /** Si le patient a le droit de répondre à la conversation (uniquement pour les conversations EchangePatient) */
    patientPeutRepondre?: boolean | undefined;
    /** l'adresse MSS du patient dans le cas d'un MSSPatient */
    adresseMSSPatient: string;
    type: ConversationType;
    areMembersInactive?: boolean | undefined;
    areMembersAbsent?: boolean | undefined;
    /** Données de la conversation de sollicitation - Utilisé pour les TeleExpertise et les DemandeAppui */
    donneesSollicitation?: Sollicitation | undefined;
    /** Id de l'échange qui correspond à la recherche faite par l'utilisateur */
    idEchangeSearched?: string | undefined;
    /** Index de la page dans laquelle l'échange recherché se trouve */
    pageIndexSearched?: number | undefined;
    mutee: boolean;
    source: ConversationSource;
    /** Si une visio existe et n'est pas clôturée pour cette conversation */
    isVisioStarted?: boolean | undefined;
}

export interface ConversationLight {
    /** Cas conversation */
    idConversation: string;
    /** Cas brouillon */
    idBrouillon?: string | undefined;
    /** Nombre de destinataires si plusieurs.
Initiales du destinataire sinon */
    vignetteValeur: string;
    /** Couleur et opacité au format CSS rgba */
    vignetteCouleur: string;
    /** Premiere ligne de l'apercu des conversation */
    titre: string;
    /** Commentaire du dernier message de la conversation ou description PJ */
    sousTitre: string;
    /** Etat des indicateurs avec leur nom suivi de leur valeur :
ex: HasNoteImportante: null, HasImage: true */
    indicateursNonLu: Indicateurs;
    nombreNonLu: number;
    /** IPPR du patient concerné si applicable */
    patientIppr: string;
    /** ID du domaine du patient concerné si applicable */
    idPatientDomaine?: string | undefined;
    /** Prenom NOM du patient concerné si applicable */
    patientLibelle: string;
    /** Id du délégant à qui est adressée la conversation */
    idTechPsDelegant: string;
    /** Date du message le plus récent de la conversation */
    date: Date;
    estLue: boolean;
    aTraiter: boolean;
    archivee: boolean;
    favorite: boolean;
    /** Type de la conversation */
    type: ConversationType;
    dateLecture?: Date | undefined;
    isDestinataire: boolean;
    dernierMessage: string;
    dernierMessageId: string;
    dernierAuteur: ProfessionnelReduit;
    /** Statut de l'identité du patient */
    patientIdentityStatus: string;
    areMembersInactive?: boolean | undefined;
    areMembersAbsent?: boolean | undefined;
    /** Source de la conversation (Mss, MssSaraV2, Chat) */
    source: ConversationSource;
    /** Liste des documents uniquement pour les conversations MssSaraV2 */
    webmailDocs: WebmailMessageDocument[];
    mutee: boolean;
    destinataires: DestinataireReduit[];
    formulaires: FormulaireLight[];
}

export enum ConversationSource {
    Chat = "Chat",
    MSSSaraV2 = "MSSSaraV2",
    MSS = "MSS",
}

export enum ConversationType {
    BoiteReception = "BoiteReception",
    Brouillon = "Brouillon",
    NonLus = "nonLus",
    Tous = "tous",
    Conversation = "Conversation",
    Courrier = "Courrier",
    Resultat = "Resultat",
    RendezVous = "RendezVous",
    Favoris = "favoris",
    ATraiter = "aTraiter",
    MSS = "MSS",
    EchangePatient = "EchangePatient",
    DGS = "DGS",
    MSSPatient = "MSSPatient",
    CourrierPatient = "CourrierPatient",
    AucunType = "AucunType",
    TeleExpertise = "TeleExpertise",
    DemandeAppui = "DemandeAppui",
}

export interface CoordonneesGPS {
    idTechPs: string;
    /** Latitude */
    latitude: number;
    /** Latitude */
    longitude: number;
}

export interface CountConversationsNonLu {
    /** Menus boites de réception dispo : 
    aTraiter
    favoris
    tous
    Conversation
    Courrier
    Resultat
    RendezVous */
    menuReception: TypeMenuBoite;
    /** Nombre de conversation non lu de type typeConversation */
    nombreNonLu: number;
}

export interface CountEchangesNonLu {
    nbrNonLu: number;
    needRefresh: boolean;
    dateReponse: Date;
}

export interface CreateAccesBrisDeGlaceRequest {
    /** Identifiant technique du patient */
    patientId: number;
    idTechPsIdentifie: string;
}

export interface CreateAutoHabilitationRequest {
    patientId: number;
    idCardDocumentId: string;
    idCardType: string;
    idTechPsIdentifie: string;
}

export interface CreateCertificateResponse {
    certificateContentType: CertificateContentType;
    certificateData: string;
    certificateKey: string;
    firstName: string;
    lastName: string;
    nationalId: string;
    technicalId: string;
}

export interface CreateCompteViaPatientRequest {
    idTechPsIdentifie: string;
    /** La classe PatientUtilisateur est une classe composite dont l’objectif est de faciliter les appels aux services. */
    patientUtilisateur: MyHopPatientUtilisateur;
}

export interface CreateDeviceRequest {
    idTechPsIdentifie: string;
    registrationId: string;
    deviceModel: string;
    devicePlatform: string;
    deviceUuid: string;
    applicationId: string;
    firebaseRegistrationId: string;
}

export interface CreateDocumentTravailRequest {
    documentTravail: DocumentTravail;
    idTechPsIdentifie: string;
    /** Type du workflow en cour tchat instantané ou mail */
    typeMessagerie?: MessagerieType | undefined;
}

/** Données d'entrée nécessaires pour créer un document de travail de sollicitation */
export interface CreateDocumentTravailSollicitationRequest {
    /** Données de document de travail */
    documentTravail: DocumentTravail;
    /** Identifiant technique du PS identifié */
    idTechPsIdentifie: string;
}

export interface CreateFichierTravailFromUrlRequest {
    fichierTravail: FichierTravail;
    url: string;
    idTechPsIdentifie: string;
    ippr: string;
    typeMessagerie?: MessagerieType | undefined;
}

export interface CreateFichierTravailRequest {
    fichierTravail: FichierTravail;
    idTechPsIdentifie: string;
    typeMessagerie?: MessagerieType | undefined;
}

export interface CreatePSInDpprAndInAsWithSynchroRequest {
    idTechPsIdentifie: string;
    professionnel: ProfessionnelAdministration;
}

export interface CreatePatientRequest {
    firstName: string;
    lastName: string;
    birthName: string;
    sex: string;
    birthDate: Date;
    birthCityCodeInsee: string;
    birthCountryCodeInsee: string;
    consent: boolean;
}

export interface CreatePatientRequest_v2 {
    firstName: string;
    lastName: string;
    birthLastName: string;
    sex: string;
    birthDate: Date;
    birthCityCodeInsee: string;
    birthCountryCodeInsee: string;
    consent: boolean;
    birthFirstName: string;
    birthFirstNameList: string;
    isIDCardValidated: boolean;
    isDoubtful: boolean;
    isHomonym: boolean;
    idCardType: string;
    email: string;
    mobile: string;
    birthCityName: string;
    consentRepresentative: string;
    isFictive: boolean;
}

export interface CreatePsOnTheFlyRequest {
    identifiantGipCps: string;
    nom: string;
    prenom: string;
    email: string;
    estMoral: boolean;
    idTechPs: string;
}

export interface CreateSollicitationRequest {
    /** Identifiant du formulaire lié à la sollicitation */
    idFormulaire?: string | undefined;
    /** Identifiant technique de l'expert/équipe ressource sollicité */
    idTechPsReceveur: string;
    /** Identifiant technique du PS identifié */
    idTechPsIdentifie: string;
    /** Numéro de sécurité sociale du patient */
    numeroSecuriteSocialePatient?: string | undefined;
    /** Mode de préférence de l'expert : actif ou non */
    modeChatActif: boolean;
    /** Code du type de sollicitation */
    typeSollicitation: TypeSollicitation;
}

export interface DeleteDocumentTravailRequest {
    idDocumentTravail: string;
    idTechPsIdentifie: string;
    /** Type du workflow en cour tchat instantané ou mail */
    typeMessagerie?: MessagerieType | undefined;
}

/** Contient les données pour supprimer un échange sur une conversation donnée */
export interface DeleteEchangeRequest {
    idTechPsIdentifie: string;
    idConversation: string;
    idEchange: string;
}

export interface DeleteFichierTravailRequest {
    IdFichierTravail: any;
    idTechPsIdentifie: string;
    typeMessagerie?: MessagerieType | undefined;
}

export interface DesactivateDeviceRequest {
    uuid: string;
}

export interface DestinataireReduit {
    /** Libellé du PS : Prenom NOM */
    libelle: string;
    /** Nom du destinataire */
    nom: string;
    /** Prénom du destinataire */
    prenom: string;
    initiales: string;
    /** Identifiant technique du PS */
    idTechPs: string;
    /** Identifiant technique du PS */
    couleur: string;
    /** Identifiant technique du PS */
    email: string;
    /** Date de leture du dernier message */
    dateDerniereLecture?: Date | undefined;
    profession: Profession;
    specialite: Specialite;
    /** Définit si le destinataire est une personne morale ou non */
    estMorale: boolean;
    statut?: EStatutDestinataire | undefined;
    /** Message de statut du destinataire */
    messageStatut?: string | undefined;
}

export interface DistancePatient {
    ippr: string;
    distance?: number | undefined;
}

export interface DocumentId {
    /** Id local du document, renseigné lors du partage du document */
    idLocalDocument: string;
    /** Id du lieux */
    idEtablissement: number;
}

export interface DocumentTravail {
    Id: any;
    idDossierPatient?: string | undefined;
    idLocalDocument?: string | undefined;
    idEtablissement?: number | undefined;
    createurReduit?: ProfessionnelReduit | undefined;
    createurConnecteReduit?: ProfessionnelReduit | undefined;
    expediteurReduit?: ProfessionnelReduit | undefined;
    dernierModificateurReduit?: ProfessionnelReduit | undefined;
    auteurReduit: ProfessionnelReduit;
    idPathologie?: number | undefined;
    libelle?: string | undefined;
    contenu?: string | undefined;
    date?: Date | undefined;
    commentaire?: string | undefined;
    isDocumentFavori?: boolean | undefined;
    isDocumentSynthese?: boolean | undefined;
    idModeleDocument?: string | undefined;
    statut: EStatutDocumentTravail;
    isCommentaireOnly: boolean;
    dateCreation: Date;
    dateModification?: Date | undefined;
    datePartage?: Date | undefined;
    destinataires?: string[] | undefined;
    idConversation?: string | undefined;
    importance: string;
    sujetConversation: string;
    estPartage: boolean;
    destinatairesMSS?: string[] | undefined;
    fichiersTravail?: FichierTravail[] | undefined;
    idTypeFormulaireHybrid?: number | undefined;
    idFicheHybrid?: number | undefined;
    idAction?: number | undefined;
    libelleDossierPatient?: string | undefined;
    idFichierTravail?: string | undefined;
    nomFichierTravail?: string | undefined;
    isPatientEnCopie: boolean;
    idTypePiece?: number | undefined;
    isFormulaire?: boolean | undefined;
    typeConversation?: string | undefined;
    /** Un échange peut contenir cette objet qui référence un autre échange auquel on répond */
    replyToEchange?: ReplyToEchange | undefined;
    /** Liste des mentions dans le commentaire */
    mentions?: Mention[] | undefined;
}

export interface DocumentTravailSendResult {
    /** Identifiant échangé créé */
    idEchange?: string | undefined;
    /** Identifiant conversation créé ou rapprochée */
    idConversation: string;
    idFormulaires: number[];
    succes: boolean;
    source: ConversationSource;
    typeConversation?: string | undefined;
}

export interface DocumentTravailWithSource extends DocumentTravail {
    /** Région aura uniquement : Si le document provient d'un workflow mail (ApiSanté) ou instantanée (Snacs.Messagerie) */
    source?: MessagerieType | undefined;
}

/** Codes des modes d'accès au formulaire Dominho */
export enum DominhoFormAccessMode {
    R = "R",
    W = "W",
}

export enum EFormatDocEnum {
    ORIGINAL = "ORIGINAL",
    PDF = "PDF",
    HTML = "HTML",
    IMAGES = "IMAGES",
    TEXT = "TEXT",
    VIGNETTE = "VIGNETTE",
}

/** Types de formulaire disponible dans l'application */
export enum EFormulaireType {
    Snacs = "snacs",
    Dominho = "dominho",
}

export enum EHabilitationPS {
    Habilite = "Habilite",
    Intervenant = "Intervenant",
    Autre = "Autre",
}

export enum EImportanceDocument {
    Basse = "Basse",
    Normale = "Normale",
    Importante = "Importante",
    Vitale = "Vitale",
}

export enum ESex {
    F = "F",
    M = "M",
    I = "I",
}

export enum EStatutDestinataire {
    STATUT_USER_INACTIF = "STATUT_USER_INACTIF",
    STATUT_ABSENT = "STATUT_ABSENT",
    STATUT_EN_LIGNE = "STATUT_EN_LIGNE",
    STATUT_USER_ACTIF_MonSisra = "STATUT_USER_ACTIF_MonSisra",
    STATUT_USER_ACTIF_MSSante = "STATUT_USER_ACTIF_MSSante",
    STATUT_IGNORE = "STATUT_IGNORE",
}

export enum EStatutDocumentTravail {
    Brouillon = "Brouillon",
    PreparationEnvoi = "PreparationEnvoi",
    EnvoiEnCours = "EnvoiEnCours",
    EnvoiEchoue = "EnvoiEchoue",
}

export enum EStatutHabilitationDossier {
    Oui = "Oui",
    Non = "Non",
    Proscrit = "Proscrit",
    NonApplicable = "NonApplicable",
    OuiTemporaire = "OuiTemporaire",
}

/** Prise en compte de la doctrine V2 */
export enum EStatutHabilitationDossierV2 {
    HabiliteComplet = "HabiliteComplet",
    HabiliteLimite = "HabiliteLimite",
    HabiliteSynthese = "HabiliteSynthese",
    NonHabilitable = "NonHabilitable",
    Desactivee = "Desactivee",
    Proscrit = "Proscrit",
    NonHabilite = "NonHabilite",
}

export enum EStatutPieceDossier {
    IN = "IN",
    VA = "VA",
    TP = "TP",
}

export enum ETypeUtilisateur {
    PS = "PS",
    US = "US",
}

export interface Echange {
    idEchange: string;
    /** Type de l'échange (Important / Question / Suivi / ...) */
    importance: string;
    dateHeure: Date;
    commentaire: string;
    commentaireHtml: string;
    auteur: DestinataireReduit;
    expediteur: DestinataireReduit;
    listeDocuments: WebmailMessageDocument[];
    premierNonLu: boolean;
    destinataireLu: DestinataireReduit[];
    formulaires: Formulaire[];
    /** Un échange peut contenir cette objet qui référence un autre échange auquel on répond */
    replyToEchange: ReplyToEchange;
    isDeleted: boolean;
    mentions: Mention[];
    /** Dictionnaire d'un idEmoji vers une liste l'idTechPS l'ayant utilisé */
    reactions: { [key: string]: string[]; };
}

/** Liste des différents modes d'envoi de la synthèse de téléexpertise en MSS */
export enum EnvoiSyntheseTleMode {
    NE_PAS_ENVOYER = "NE_PAS_ENVOYER",
    TO_EXPERT_SOLLICITE = "TO_EXPERT_SOLLICITE",
    TO_EXPERT_FINAL = "TO_EXPERT_FINAL",
    TO_TIERCE = "TO_TIERCE",
}

export interface Etablissement {
}

/** Regroupe les codes d'états courant d'une sollicitation */
export enum EtatSollicitation {
    Initialisee = "Initialisee",
    EnCours = "EnCours",
    Cloturee = "Cloturee",
}

export interface Etiquette {
    id: number;
    libelle: string;
    isRegionale: boolean;
}

export interface Evenement {
    /** Type de l'échange (Important / Question / Suivi / ...) */
    importance: string;
    dateHeure: Date;
    commentaire: string;
    idEvenement: string;
}

export interface FichierBase64 {
    base64: string;
    fileName: string;
    mimeType: string;
}

export interface FileMetadata {
    /** MimeType du fichier */
    mimeType: string;
    /** Nom du fichier */
    fileName: string;
}

export interface FichierPrerequisSollicitation extends FileMetadata {
    /** URL de téléchargement du document */
    downloadUrl?: string | undefined;
    /** Identifiant du fichier */
    idFichier?: string;
    /** Libellé du fichier. Peut être différent du nom du fichier */
    libelle?: string;
}

/** Données d'un fichier de prérequis de sollicitation avec son contenu */
export interface FichierPrerequisSollicitationWithBytesContent extends FichierPrerequisSollicitation {
    /** Contenu du fichier non encodé */
    content?: string | undefined;
}

/** Contient les métadonnées et le contenu d'un fichier encodé en Base 64 */
export interface FileBase64Encoded {
    /** Contenu du fichier en base64
Attention il n'est pas logué */
    content?: string | undefined;
    /** MimeType du fichier */
    mimeType: string;
    /** Nom du fichier */
    fileName: string;
}

/** Données d'un fichier de prérequis d'une déclaration d'expert/d'équipe ressource */
export interface FichierPrerequisSollicitationWithContent extends FileBase64Encoded {
    /** URL de téléchargement du document */
    downloadUrl?: string | undefined;
    /** Identifiant du fichier */
    idFichier?: string | undefined;
    /** Libellé du fichier. Peut être différent du nom du fichier */
    libelle?: string;
}

export interface FichierTravail {
    /** Identifiant du fichier de travail */
    id: string;
    /** Contenu binaire */
    contenuFichierTravail: string;
    /** MimeType du fichier de travail */
    mimeType: string;
    /** Id du document de travail */
    idDocumentTravail: string;
    /** Nom physique du fichier uploadé */
    nomFichierTravail: string;
    /** Id local document */
    idLocalDocument: string;
    /** Identifiant du type piece */
    idTypePiece?: number | undefined;
    /** Nom du type piece */
    libelleTypePiece: string;
    date?: Date | undefined;
    typeMessagerie?: MessagerieType | undefined;
}

export interface FieldOfBoolean {
    value: boolean;
}

export interface FieldOfString {
    value: string;
}

export interface FileActive {
    listePatients: PatientSuivi[];
    listeEtiquettes: Etiquette[];
}

export interface Formulaire {
    idInstanceFormulaire: string;
    libelleFormulaire: string;
    statutFormulaire: string;
}

export interface FormulaireLight {
    idInstanceFormulaire?: string | undefined;
    statutFormulaire: string;
}

/** Transport object of Form */
export interface FormulaireType {
    /** Technical identifier of form */
    formId: string;
    /** Label of form */
    formLabel: string;
    /** Type of form */
    type: string;
}

export interface FullMetadataDoc {
    auteur: MetadonneesDocumentUtilisateur;
    commentaire: string;
    dateActe?: Date | undefined;
    dateCreation: Date;
    destinataireAdeli: string;
    destinataireIdCarte: string;
    destinataireIdTechPs: string;
    destinataireNom: string;
    destinatairePrenom: string;
    destinataireRpps: string;
    etablissement: MetadonneesDocumentEtablissement;
    expediteur: MetadonneesDocumentUtilisateur;
    hash: string;
    idLocalDoc: string;
    idPieceTechnique?: number | undefined;
    idTypePiece: number;
    imagerieIds: ImagerieIds;
    importance: EImportanceDocument;
    invalidateur: InfoPS;
    invalidationCommentaire: string;
    invalidationDate?: Date | undefined;
    libelle: string;
    libelleTypePiece: string;
    libelleCourtTypePiece: string;
    patient: MetadataPatient;
    piecesLiees: PieceLiee[];
    statut: EStatutPieceDossier;
    typeConversation: ConversationType;
}

/** Regroupe les informations nécessaires à la génération d'un token pour une application */
export interface GenerateWebTokenRequest {
    /** URL de l'application */
    targetApplicationUrl: string;
    /** Identifiant technique de l'utilisateur identifié */
    idTechPsIdentifie: string;
    /** Données supplémentaires à intégrer dans le token */
    extraData: TokenExtraData[];
}

export interface GetArtefactIdByUUIDAndPasswordResult {
    artefactId: string;
    description: string;
    status: string;
}

/** Contient les données permettant de récupérer les conversations correspondant au patient et PS spécifiés */
export interface GetConversationByPSAndPatientRequest {
    /** IPPR */
    ippr: string;
    /** Identifiant du PS */
    idTechPsIdentifie: string;
}

/** Contient les données nécessaires à la récupération du détail de plusieurs conversations */
export interface GetConversationsByIdsRequest {
    /** Liste des identifiants des conversations à récupérer */
    idsConversation: string[];
    /** Identifiant du PS */
    idTechPsIdentifie: string;
}

export interface GetDocumentEquipeRessourceBase64Request {
    idTechPsEquipeRessource: string;
    idDocumentEquipeRessource: string;
}

export interface GetDocumentExpertBase64Request {
    idTechPsExpert: string;
    idDocumentExpert: string;
}

export interface GetEncryptedParamsRequest {
    patientDetail: PatientDetail;
    appName: string;
    codeFonction?: number | undefined;
    idTechPsIdentifie: string;
    paramsEnClair: boolean;
}

/** Object de requête pour récupérer des profesionnels favoris depuis l'annuaire */
export interface GetFavorisFromAnnuaireRequest {
    /** Identifiant technique de l'utilisateur identifié */
    idTechPsIdentifie: string;
    /** Filtre pour rechercher parmi une population de professionnel précise */
    filter?: TypeUtilisateurSollicitation | undefined;
}

/** Données de la requête de la méthode GetInfosDocInitial */
export interface GetInfosDocInitialRequest {
    /** Permet de filter sur la date des documents à synchroniser */
    fromDate?: Date | undefined;
}

export interface GetInfosStatutRequest {
    idsTechPS: string[];
}

export interface GetListCoordonneesGPSByIdTechPsRequest {
    idTechPsIdentifie: string;
    idsTechPs: string[];
}

export interface GetListFindPsByCriteriaRequest {
    idTechPsIdentifie: string;
    nomPrenom: string;
    professionsIds: number[];
    specialitesIds: number[];
    ville: string;
    cp: string;
    maxResult: number;
    filterMorales?: boolean | undefined;
    teleExpertise: boolean;
    equipeRessource: boolean;
    sansGestionDesDroits: boolean;
}

export interface GetListFindPsMssByCriteriaRequest {
    idTechPsIdentifie: string;
    nomPrenom: string;
    professionsIds: number[];
    specialitesIds: number[];
    ville: string;
    cp: string;
    maxResult: number;
    filterMorales?: boolean | undefined;
}

/** Contient les données permettant de récupérer les conversations d'un PS */
export interface GetListeConversationsByIdTechPsRequest {
    /** Identifiant du PS déléguant pour lequel l'utilisateur travaille */
    idTechPsIdentifie: string;
    /** IPPR */
    ippr?: string | undefined;
    /** Nombre de résultats par page */
    pageSize: number;
    /** Filtre de recherche de texte dans les conversations */
    recherche?: string | undefined;
    /** Filtre de recherche sur les conversations archivées */
    archives?: boolean | undefined;
    /** Filtre de recherche sur les conversations contenant des échanges non lus */
    estNonLu?: boolean | undefined;
    /** Filtre de recherche sur les conversations contenant des échanges à traiter */
    estATraiter?: boolean | undefined;
    /** Filtre de recherche sur les conversations marquées en favori */
    estFavori?: boolean | undefined;
    /** Filtre de recherche sur les conversations centrées patient */
    estCentrePatient?: boolean | undefined;
    /** Identifiant du PS dont les conversations sont à récupérer */
    idTechPsCible: string;
    /** Filtre de recherche sur le type de conversation */
    type: string;
}

/** Contient les données permettant de récupérer les conversations de PS */
export interface GetListeConversationsByIdTechPsV2Request {
    /** IPPR */
    ippr?: string | undefined;
    /** Nombre de résultats par page */
    pageSize: number;
    /** Filtre de recherche de texte contenu dans les conversations */
    recherche?: string | undefined;
    /** Filtre de recherche sur les conversations archivées */
    archives?: boolean | undefined;
    /** Filtre de recherche sur les conversations contenant des échanges non lus */
    estNonLu?: boolean | undefined;
    /** Filtre de recherche sur les conversations contenant des échanges à traiter */
    estATraiter?: boolean | undefined;
    /** Filtre de recherche sur les conversations marquées comme favorites */
    estFavori?: boolean | undefined;
    /** Filtre de recherche sur les conversations contenant des échanges centrés patient */
    estCentrePatient?: boolean | undefined;
    /** Identifiant du PS dont les conversations sont à récupérer */
    idTechPsCible?: string | undefined;
    /** Identifiant du PS déléguant pour lequel l'utilisateur travaille */
    idTechPsIdentifie?: string | undefined;
    /** Filtre de recherche sur le type de conversation */
    type: ConversationType[];
    /** Indique si la requête vient de MonSisra ou non */
    fromMS?: boolean | undefined;
    /** Liste des identifiants des déléguants de l'utilisateur */
    idsTechPsDelegants?: string[] | undefined;
}

/** Contient les données permettant de récupérer les conversations des acteurs ayant MSS */
export interface GetListeConversationsByIdTechPs_v2_withMSSRequest {
    /** IPPR */
    ippr?: string | undefined;
    /** Nombre de résultats par page */
    pageSize: number;
    /** Filtre de recherche de texte contenu dans les conversations */
    recherche?: string | undefined;
    /** Filtre de recherche sur les conversations archivées */
    archives?: boolean | undefined;
    /** Filtre de recherche sur les conversations contenant des échanges non lus */
    estNonLu?: boolean | undefined;
    /** Filtre de recherche sur les conversations contenant des échanges à traiter */
    estATraiter?: boolean | undefined;
    /** Filtre de recherche sur les conversations marquées comme favorites */
    estFavori?: boolean | undefined;
    /** Filtre de recherche sur les conversations contenant des échanges centrés patient */
    estCentrePatient?: boolean | undefined;
    recuOnly?: boolean | undefined;
    /** Identifiant du PS dont les conversations sont à récupérer */
    idTechPsCible?: string | undefined;
    /** Identifiant du PS déléguant pour lequel l'utilisateur travaille */
    idTechPsIdentifie?: string | undefined;
    /** Filtre de recherche sur le type de conversation */
    type?: string | undefined;
    /** Indique si la requête vient de MonSisra ou non */
    fromMS: boolean;
    /** Liste des identifiants des déléguants de l'utilisateur */
    idsTechPsDelegants?: string[] | undefined;
    /** Filtre de recherche sur les conversations/mails envoyés uniquement */
    envoyeOnly?: boolean | undefined;
}

/** Objet contenant les données nécessaires à la récupération de la liste de traits stricts correspondants à une liste de token MonSisraBureau */
export interface GetListePatientsRequest {
    /** Liste de tokens MonSisraBureau */
    tokenList: string[];
}

export interface GetMultiDocFormatAsStringRequest {
    idLocalDoc: string;
    idEtablissementDoc: number;
    listeFormats: string[];
    typeConversation?: ConversationType | undefined;
    idTechPsIdentifie: string;
}

export interface GetMultiDocRequest {
    idTechPsIdentifie: string;
    emailMssPsIdentifie?: string | undefined;
    idLocalDoc: string;
    idEtablissement: number;
    format: EFormatDocEnum[];
    typeConversation: ConversationType;
}

/** Données de la requête GetNextDocConvTypesWithLastReadRequest */
export interface GetNextDocConvTypesWithLastReadRequest {
    /** IdEchange du doc précédent. Vaut 0 dans la plupart des cas, mais est gardé pour des soucis de rétrocompatibilité */
    idEchangePrecedent: string;
    /** Id de l'échange précédent, ou index du doc précédent si 1er appel de mon sisra à l'API Synchro Doc */
    indexDocPrecedent: number;
    /** Les types de conversation auxquelles peuvent appartenir le document */
    typesConversation: TypeConvSynchroDoc[];
    /** Le format auquel le document est demandé */
    format: EFormatDocEnum;
}

export interface GetPSFromAnnuaireRequest {
    idsTechPs: string[];
}

/** Objet de requête afin de récupérer les professionnels utilisés récemment */
export interface GetRecentsFromAnnuaireRequest {
    /** Identifiant technique de l'utilisateur identifié */
    idTechPsIdentifie: string;
    /** Filtre pour récupérer un nombre limité de profesionnel */
    quantite: number;
    /** Filtre pour rechercher parmi une population de profesionnel précise */
    filter?: TypeUtilisateurSollicitation | undefined;
}

export interface Groupe {
    identifiant: string;
    nom: string;
    description: string;
    membresPP: PersonnePhysique[];
    membresPM: Service[];
}

export interface HabilitationDossier {
    dateDebutHabilitation?: Date | undefined;
    /** Date d'expiration du niveau d'habilitation. */
    dateFinHabilitation?: Date | undefined;
    /** Indique si l'habilitation donne également un droit de gestion des habilitations. */
    isGestionnaireHabilitations: boolean;
    /** Niveau d'habilitation accordé. */
    statutHabilitationDossier: EStatutHabilitationDossier;
}

/** Prise en compte de la doctrine V2 */
export interface HabilitationDossierV2 {
    dateDebutHabilitation?: Date | undefined;
    /** Date d'expiration du niveau d'habilitation. */
    dateFinHabilitation?: Date | undefined;
    /** Indique si l'habilitation donne également un droit de gestion des habilitations. */
    isGestionnaireHabilitations: boolean;
    /** Niveau d'habilitation accordé. */
    statutHabilitationDossierV2: EStatutHabilitationDossierV2;
}

export interface ImagerieIds {
    accessionNumber: string;
    idproducteur: string;
    studyUid: string;
}

export interface Indicateurs {
    important?: boolean | undefined;
    question?: boolean | undefined;
}

export interface InfoPS {
    adeli: string;
    idCarte: string;
    idTechnique: string;
    nom: string;
    prenom: string;
    rpps: string;
}

export interface InfoPsIdentifie {
    idTechPs: string;
    emailMSS?: string | undefined;
}

export interface InfosDoc {
    dateCreationEchange?: Date | undefined;
    idEchange: string;
    indexDocEchange: number;
    nbDocsRestant: number;
}

/** Objet de retour d'un appel à GetInfosVisio ATTENTION : les objets de retours DOIVENT rester en camelCase */
export interface InfosVisioResult {
    /** Jeton */
    jwtToken: string;
    /** Serveur */
    server: string;
    /** Temps en secondes entre chaque appel au keepAlive / SetDateFinTraceParticipant */
    keepAliveRate: number;
}

/** Objet contenant les données nécessaires à l'inscription d'un patient dans Stic */
export interface InscrirePatientRequest {
    /** Nom de naissance du patient */
    nomNaissance: string;
    /** Prénom du patient */
    prenom: string;
    /** Sexe du patient */
    sexe: string;
    /** Date de naissance du patient */
    dateDeNaissance: Date;
    /** Code postal du lieu de naissance du patient */
    codePostalNaissance: string;
    /** Ville de naissance du patient */
    villeNaissance: string;
    /** Nom usuel du patient */
    nomUsuel: string;
    /** Adresse du patient */
    adresse: string;
    /** Ville du lieu de résidence du patient */
    ville: string;
    /** Code postal du lieu de résidence du patient */
    codePostal: string;
    /** Numéro de téléphone du patient */
    telephone: string;
    /** Numéro du téléphone portable du patient */
    mobile: string;
    /** Adresse mail du patient */
    email: string;
    /** Pays de résidence du patient (Code à 3 chiffres) */
    paysResidence: string;
    /** Indique si l'inscription du patient est forcée ou non */
    inscriptionForcee: boolean;
}

export interface InvitationConfrereRequest {
    idTechPsIdentifie: string;
    idTechPsCible: string;
    nomComplet: string;
    mail: string;
    phone: string;
}

export interface IsDelegantDiscussionRequest {
    idTechPsIdentifie: string;
}

export interface IsGestionnaireHabilitationRequest {
    idTechPsIdentifie: string;
    ippr: string;
}

export interface IsHabilitedDossierByIpprRequest {
    idTechPsIdentifie: string;
    ippr: string;
    accesBrisDeGlace: boolean;
}

/** Contient les données nécessaires pour qu'un PS puisse quitter une conversation */
export interface LeaveConversationRequest {
    /** Identifiant du PS déléguant pour lequel l'utilisateur travaille */
    idTechPsIdentifie: string;
    /** Identifiant de la conversation que le ps veut quitter */
    idConversation: string;
    /** Identifiant du PS qui quitte la conversation */
    idTechPsCible: string;
    /** Type de la conversation (utilisé pour le routage entre Snacs.Messagerie et l'ApiSanté) */
    typeConversation?: ConversationType | undefined;
}

export interface LienAppliquettePortail {
    libelle: string;
    url: string;
    index: number;
}

export interface Lieu {
    id: string;
    nom: string;
    latitude?: number | undefined;
    longitude?: number | undefined;
    type: string;
}

/** Structure des liens utilisés dans la page de configuration des préférences de sollicitation */
export interface LinksPreferencesSollicitation {
    /** Lien vers la page d'information concernant les informations de facturation. */
    infosFacturation: string;
    /** Lien vers la page d'information concernant les formulaires de sollicitation. */
    formulairesSollicitation: string;
    /** Lien vers le guide de la téléexpertise. */
    guideTeleexpertise: string;
    /** Lien vers le numero de facturation du requérant. */
    numeroFacturation: string;
    /** Lien vers page d'information sur numero de facturation. */
    demanderNumeroFacturation: string;
    /** Lien présent dans la page de création d'une sollicitation. */
    creationSollicitation: string;
    /** Lien présent dans la page de finalisation de téléexpertise. */
    finalisationTeleexpertise: string;
}

export interface MAJPreferencesPSMonSisraRequest {
    dematerialisation?: boolean | undefined;
    notifsMail?: boolean | undefined;
    monSisra?: boolean | undefined;
    numTel?: FieldOfString | undefined;
    charteValidee?: FieldOfBoolean | undefined;
}

export interface Mention {
    /** Identifiant du PS mentionné */
    idTechPs: string;
    /** Nom du PS mentionné */
    nom: string;
}

export enum MessagerieType {
    Mail = "Mail",
    Tchat = "Tchat",
    MailToTchat = "MailToTchat",
    TchatToMail = "TchatToMail",
}

export interface MetadataMultiDoc {
    fullMetadataDoc: FullMetadataDoc;
    infosDoc: InfosDoc;
    multiDocs: MultiDoc[];
}

export interface MetadataPatient {
    codePaysNaissance: string;
    codePostalNaissance: string;
    dateNaissance?: Date | undefined;
    ippr: string;
    libellePaysNaissance: string;
    nomNaissance: string;
    nomUsuel: string;
    prenom: string;
    sexe: ESex;
    villeNaissance: string;
}

export interface MetadonneesDocumentEtablissement {
    finess: string;
    idEtablissement: number;
    nom: string;
    nomCourt: string;
    oid: string;
}

export interface MetadonneesDocumentUtilisateur {
    /** Adeli */
    adeli: string;
    /** IdCarte */
    idCarte: string;
    /** IdProfession */
    idProfession: number;
    /** IdSpecialite */
    idSpecialite: number;
    /** IdTechnique */
    idTechnique: string;
    /** LibelleProfession */
    libelleProfession: string;
    /** LibelleSpecialite */
    libelleSpecialite: string;
    /** Mail */
    mail: string;
    /** Nom */
    nom: string;
    /** Prenom */
    prenom: string;
    /** RPPS */
    rpps: string;
}

export interface ModuleRecherchePsSettings {
    limiteSuggestionsMobile: number;
    limiteSuggestionsBureau: number;
    limiteSuggestionsWeb: number;
    limiteResultatsMobile: number;
    limiteResultatsBureau: number;
    limiteResultatsWeb: number;
    batchSizeAddToTabList: number;
    delayBetweenBatchAddToTabList: number;
    queryDebounceTimer: number;
}

export interface MultiDoc {
    contenu: string;
    /** Libelle du document. 
Cas du service GetNextDoc pour MonSisra : construction d'un libellé spécifique pour être utilisé en nom de fichier. */
    libelle: string;
    idLocalDoc: string;
    idStic: number;
    mimeType: string;
    extension: string;
    format: EFormatDocEnum;
    /** Ordre de l'image car ce format génère 1 image / page. */
    numeroImage?: number | undefined;
    /** Nombre total d'images car ce format génère 1 image / page. */
    totalImages?: number | undefined;
}

export interface MultiDocBase64 {
    contenu: string;
    /** Libelle du document. 
Cas du service GetNextDoc pour MonSisra : construction d'un libellé spécifique pour être utilisé en nom de fichier. */
    libelle: string;
    idLocalDoc: string;
    idStic: number;
    mimeType: string;
    extension: string;
    format: EFormatDocEnum;
    /** Ordre de l'image car ce format génère 1 image / page. */
    numeroImage?: number | undefined;
    /** Nombre total d'images car ce format génère 1 image / page. */
    totalImages?: number | undefined;
}

export enum MyHopLienPatientUtilisateur {
    PersonneConcernee = "PersonneConcernee",
    Pere = "Pere",
    Mere = "Mere",
    ResponsableLegal = "ResponsableLegal",
    PersonneDeConfiance = "PersonneDeConfiance",
}

/** La classe Patient assure l’unicité des données par son identifiant. Un patient peut avoir une même identité pour plusieurs site */
export interface MyHopPatient {
    /** Code postal de naissance du patient, obligatoire si Pays de naissance = France */
    codePostalDeNaissance: string;
    /** Date de naissance du patient */
    dateDeNaissance: Date;
    /** Adresse e-mail du patient */
    email: string;
    /** Identifiant régional du patient */
    ippr: string;
    /** Nom usuel du patient */
    nom: string;
    /** Nom de naissance du patient */
    nomDeNaissance: string;
    /** Libellé du pays de naissance du patient */
    paysDeNaissance: string;
    /** Prénom du patient */
    prenom: string;
    /** Sexe du patient */
    sexe: string;
    /** Numéro de téléphone mobile du patient */
    telephoneMobile: string;
    /** Ville de naissance du patient */
    villeDeNaissance: string;
}

/** La classe PatientUtilisateur est une classe composite dont l’objectif est de faciliter les appels aux services. */
export interface MyHopPatientUtilisateur {
    patient: MyHopPatient;
    utilisateur: MyHopUtilisateur;
    /** Relation entre le patient et l'utilisateur */
    lienPatientUtilisateur: MyHopLienPatientUtilisateur;
}

/** La classe PatientUtilisateur est une classe composite dont l’objectif est de faciliter les appels aux services. */
export interface MyHopUtilisateur {
    /** Email de l'utilisateur : identifiant utilisé par l'utilisateur */
    email: string;
    /** Nom de l'utilsateur */
    nom: string;
    /** Prénom de l'utilsateur */
    prenom: string;
    /** Numéro de téléphone mobile de l'utilsateur */
    mobile: string;
}

/** Résultat de l'authentification d'un utilisateur à partir d'une demande OTP */
export interface OTPAccessData {
    /** Identifiant de l'artefact */
    artefactId: string;
    /** Url d'authentification */
    authenticationUrl: string;
    /** Description */
    description: string;
    /** Statut de la demande d'authentification */
    status: AuthenticationStatus;
    /** Nombre de tentatives d'authentification restantes */
    remainingAttempts: number;
}

/** Statuts possibles de la demande d'accès OTP */
export enum OTPAccessStatus {
    None = "None",
    AuthenticationSuccess = "AuthenticationSuccess",
    OTPNotActive = "OTPNotActive",
    EmailNotValid = "EmailNotValid",
    PhoneNumberNotValid = "PhoneNumberNotValid",
    AuthenticationFailure = "AuthenticationFailure",
    OTPRequestSuccess = "OTPRequestSuccess",
    TooManyRequests = "TooManyRequests",
    PasswordPolicyError = "PasswordPolicyError",
    TechnicalError = "TechnicalError",
}

/** Regroupe les différents types de contact OTP */
export enum OTPContactType {
    None = "None",
    Email = "Email",
    MobilePhone = "MobilePhone",
}

/** Données résultantes de la demande d'accès OTP par mail */
export interface OTPRequestData {
    /** Identifiant de la demande d'accès OTP */
    otpRequestId: string;
    /** Liste de contacts auxquels sera envoyé la réponse de la demande OTP */
    sentTo: Contact[];
    /** Status de la demande d'accès OTP */
    status: OTPAccessStatus;
}

export interface PPAndServices {
    personnePhysiqueSuggestions: PersonnePhysique[];
    serviceSuggestions: Service[];
    groupeSuggestions: Groupe[];
}

export interface Patient {
    /** Gets or Sets patient ippr. */
    ippr: string;
    /** NomUsuel
Gets or Sets patient lastname. */
    lastName: string;
    /** Gets or Sets patient birthname. */
    birthName: string;
    /** Prenoms
Gets or Sets patient firstnames.
OBSOLETE Laissé pour rétro-compatibilité mobile, préférer FirstName
Attention, ne pas mettre la balise[Obsolete], sinon le champ n'est plus envoyé */
    listFirstNames: string[];
    /** Prenoms
Gets or Sets patient firstname. */
    firstName: string;
    /** Sewe
Gets or Sets patient sex. */
    sex: ESex;
    /** DateDeNaissance
Gets or Sets patient date of birth. */
    dateOfBirth: Date;
    /** CodePostalNaissance
Gets or Sets birth zip code. */
    birthZipCode: string;
    /** VilleNaissance
Gets or Sets birth city name. */
    birthCity: string;
    /** Gets or Sets birth country name. */
    birthCountry: string;
    /** Gets or Sets patient scoring field.
Pourcentage de similitude du doublon */
    scoringField: number;
    /** Gets or Sets a boolean value indicating if date of birth is sure. */
    isDateOfBirthSure: boolean;
    birthFirstName: string;
    identityStatus: string;
    /** Numéro de sécurité sociale du patient */
    nir?: string | undefined;
}

export interface PatientCarteVitale {
    /** Nom */
    lastName: string;
    /** Prénom */
    firstName: string;
    /** Nom de naissance = patronyme. */
    birthName: string;
    /** Date de naissance. */
    birthDate?: Date | undefined;
    /** IPPR récupéré à partir de STIC. */
    ippr: string;
}

export interface PatientConv {
    idPatient: string;
    /** ID du domaine du patient concerné si applicable */
    idPatientDomaine?: string | undefined;
    nomNaissance: string;
    nomUsuel: string;
    prenom: string;
    dateNaissance?: Date | undefined;
    sexe: ESex;
    codePaysNaissance: string;
    codeInseeNaissance: string;
    libellePaysNaissance: string;
    codePostalNaissance: string;
    villeNaissance: string;
    prenomNaissance: string;
    identityStatus: string;
    prenomsNaissanceList: string;
    isDeleted: boolean;
}

export interface PatientDetail extends Patient {
    phone?: string;
    mobilePhone?: string;
    email?: string;
    adresse?: string;
    city?: string;
    zipCode?: string;
    isDeleted?: boolean;
    listLocalData?: PatientLocal[];
}

export interface PatientHabilitation extends Patient {
    psHabiliteIntervenant?: EHabilitationPS;
}

export interface PatientLocal {
    /** Gets or sets SI Name. */
    siName: string;
    /** Gets or sets patient usal name. */
    usualName: string;
    /** Gets or sets patient usal name. */
    phone: string;
    /** Gets or sets residence country. */
    country: string;
    /** Gets or sets address. */
    address: string;
    /** Gets or sets zip code. */
    zipCode: string;
    /** Gets or sets city. */
    city: string;
    /** Gets or sets email */
    email: string;
}

export interface PatientSuivi {
    /** IPPR du patient suivi */
    ippr: string;
    /** Nom de naissance du patient suivi */
    nomNaissance: string;
    /** Nom usuel du patient suivi */
    nomUsuel: string;
    /** Prénom du patient suivi */
    prenom: string;
    /** Sexe du patient suivi */
    codeSexe: string;
    /** Date de naissance du patient suivi */
    dateNaissance?: Date | undefined;
    /** Id de l'acteur professionnel qui suit le patient */
    idActeurPatient: number;
    /** Identifiant du statut de l'acteur */
    idStatutActeur: number;
    /** Date du dernier suivi, pour les acteurs ayant un statut spécifique qui indique qu'il suit le patient à intervalle régulier */
    dateDernierSuivi?: Date | undefined;
    /** Délai de récurrence du suivi, en jours, pour les acteurs ayant un statut spécifique qui indique qu'il suit le patient à intervalle régulier */
    delaiRecurrenceJour: number;
    /** Date de création du suivi de ce patient par l'acteur */
    dateCreation: Date;
    /** Habilitation de l'acteur professionnel sur le dossier du patient suivi */
    habilitationDossier: HabilitationDossier;
    /** Prise en compte de la doctrine V2 */
    habilitationDossierV2: HabilitationDossierV2;
    /** Commentaire patient récupéré */
    commentairePatient: string;
    /** Date de la dernière activité */
    dateDerniereActivite?: Date | undefined;
    /** Date du prochain rendez-vous */
    dateProchainRendezVous?: Date | undefined;
    /** Indique sue le patient possède une note importante */
    hasNoteImportante: boolean;
    /** Indique si une question concerne ce patient */
    hasQuestion: boolean;
    /** Indique si ce patient est sujet à un rappel de suivi */
    hasRappelDeSuivi: boolean;
    /** Indique si un document de ce patient a été marqué comme "à traiter"
par l'utilisateur en court */
    hasDocumentATraiter: boolean;
    /** Liste des IDs des étiquettes associées à ce patient */
    listeIdEtiquettes: number[];
    /** Indique si ce patient a un rappel de RDV */
    hasRappelDeRdv: boolean;
    /** Indique si ce patient est supprimer logiquement */
    supprime: boolean;
    prenomNaissance: string;
    identityStatus: string;
    lieuNaissance: string;
    /** Numéro de sécurité sociale du patient */
    nir?: string | undefined;
}

export interface PatientSuiviFileActive {
    codeSexe: string;
    commentairePatient: string;
    dateCreation: Date;
    dateDernierEchangeImportant?: Date | undefined;
    dateDernierEchangeQuestion?: Date | undefined;
    dateDernierSuivi?: Date | undefined;
    dateDerniereActivite?: Date | undefined;
    dateNaissance?: Date | undefined;
    delaiRecurrenceJour: number;
    /** Prise en compte de la doctrine V2 */
    habilitationDossier: HabilitationDossierV2;
    idActeurPatient: number;
    idSpecialiteActeur: number;
    idStatutActeur: number;
    ippr: string;
    libelleStatutActeur: string;
    nomNaissance: string;
    nomUsuel: string;
    prenom: string;
    supprime: boolean;
}

export interface Pays {
    /** Identifiant du pays */
    id: number;
    /** Nom du pays */
    libelle: string;
    /** Code INSEE du pays */
    codeInsee: string;
    /** Code ISO Alpha2 du pays */
    codeIsoAlpha2: string;
    /** Code ISO Alpha3 du pays */
    codeIsoAlpha3: string;
}

export interface PersonnePhysique {
    idTechPS: string;
    idNatList: string[];
    idExercice: string;
    titre: string;
    nom: string;
    prenom: string;
    specialite: string;
    structure: string;
    villeCP: string;
    adressePostale: string;
    adresseMSS: string;
    email: string;
    telephoneFixe: string;
    telephoneMobile: string;
    telephoneSecretariat: string;
    teleExpert?: boolean | undefined;
    detailTeleExpertise: string;
    echangeBullePrerequisTeleExpertise: string;
    urlOutilTeleExpertise: string;
    centragePatientTeleExpertise: boolean;
    formulairesTeleExpertise: FormulaireType[];
    dematerialisation?: boolean | undefined;
    messageAbsence: string;
    msContactTeleExpertiseOnly?: boolean | undefined;
    isFavoris: boolean;
    statut: string;
    searchScore?: number | undefined;
    isAbsent?: boolean | undefined;
    libelleAbsence: string;
    dateDebutAbsence?: Date | undefined;
    dateFinAbsence?: Date | undefined;
    derniereConsultationMessagerie?: Date | undefined;
    dernierMailMss?: Date | undefined;
    activityAdresses: Adresse[];
}

export interface PieceJointeLight {
    nomDocument: string;
    typeMime: string;
}

export interface PieceLiee {
    dateCreation: Date;
    idEts: number;
    idLocalDoc: string;
    idPiece: number;
    libellePiece: string;
}

export interface PreferencePSMonSisra {
    dematerialisationActivated: boolean;
    mailNotificationActivated: boolean;
    monSisraActivated: boolean;
    monSisraDateActivation?: Date | undefined;
    telephone: string;
    charteValidee: boolean;
}

/** Transport object for preferences of cloture automatique */
export interface PreferencesClotureAuto {
    /** Définit si l'expert a activé ou non la clôture automatique de ses télé-expertises */
    clotureAuto: boolean;
    /** Définit le nombre de jours après lesquels la clôture automatique de ses télé-expertises est effectuée */
    clotureAfter?: number | undefined;
}

/** Objet de transport des préférences d'envoi de TLE à l'expert */
export interface PreferencesEnvoiSyntheseTleExpert {
    /** Indique le mode d'envoi par MSS des TLE finalisées */
    modeEnvoiMss: EnvoiSyntheseTleMode;
    /** Indique l'email utilisé pour l'envoi de la synthèse de téléexpertise en MSS à une MSS tierce si le mode d'envoi MSS est défini sur "TIERCE" */
    mssTierce?: string | undefined;
}

export interface PreferencesExpert {
    /** Gets or sets IdTechPs */
    idTechPs: string;
    /** Gets or sets Description */
    description: string;
    /** Gets or sets UrlOutil */
    urlOutil: string;
    /** Gets or sets CentragePatient */
    centragePatient: boolean;
    /** Echange fictif à afficher dans la conversation pour présenter les */
    echangeBullePrerequis: string;
    formulaires: FormulaireType[];
}

/** Transport object for preferences of facturation */
export interface PreferencesFacturationExpert {
    /** True if the NumeroDemandeur is required */
    numeroDemandeurRequis: boolean;
    /** NIR Enum */
    nir: SaisieInfosFacturationSollicitation;
}

export interface PreferencesMonSisra {
    /** Login de l'utilisateur associé à la préférence */
    login: string;
    /** Receptionner ou non (directement archiver) les conversations */
    receptionConversation?: boolean | undefined;
    /** Receptionner ou non (directement archiver) les courriers */
    receptionCourrier?: boolean | undefined;
    /** Receptionner ou non (directement archiver) les rendez-vous */
    receptionRendezVous?: boolean | undefined;
    /** Receptionner ou non (directement archiver) les résultats */
    receptionResultat?: boolean | undefined;
    /** Receptionner ou non (directement archiver) les échanges patients */
    receptionEchangePatient?: boolean | undefined;
    /** Receptionner ou non (directement archiver) les conversations venant de MSS */
    receptionMSS?: boolean | undefined;
    /** Reception ou non (directement archiver) les conversations MSS de type DGS Urgent */
    receptionDGS?: boolean | undefined;
    /** Receptionner ou non (directement archiver) les conversations typée DemandeAppui */
    receptionDemandeAppui?: boolean | undefined;
    /** Receptionner ou non (directement archiver) les conversations typée TeleExpertise */
    receptionTeleExpertise?: boolean | undefined;
}

/** Transport object for preferences of restriction */
export interface PreferencesRestriction {
    /** Définit si l'expert a activé ou non la restriction des télé-expertises qu'il peut recevoir */
    dailyTeleExpertiseLimitEnabled: boolean;
    /** Définit le nombre de télé-expertises maximum que l'expert peut recevoir par jour */
    maxTlePerDay?: number | undefined;
    /** Définit si l'expert a activé ou non la restriction des télé-expertises en fonction des professions et spécialités autorisées */
    limitToAutorizedProfessionsAndSpecialites: boolean;
    /** Liste des identifiants de professions autorisées à solliciter l'expert */
    autorizedProfessionIds: number[];
    /** Liste des spécialités autorisées à solliciter l'expert */
    autorizedSpecialites: AutorizedSpecialite[];
}

/** Champs minimals requis pour le transfert des données de préférences de sollicitation en lecture et écriture */
export interface PreferencesSollicitationBasicFields {
    /** Identifiant technique de l'expert/équipe ressource */
    idTechPsExpert: string;
    /** URL de l'outil tiers si l'expert/équipe ressource utilise un outil différent de MonSisra */
    urlOutil?: string | undefined;
    /** Définit si les demandes de sollicitation de l'expert/équipe ressource soient centrées patient ou non
true = obligatoire, false = optionnel, null = invisible */
    centragePatient: boolean;
    /** Définit si le statut d'expert/équipe ressource de l'utilisateur concerné est déjà dans l'Annuaire Régionnal ou non */
    statutDansAnnuaire: boolean;
    /** Identifiant du type de formulaire Dominho à utiliser si l'utilisateur souhaite en utiliser */
    idTypeFormulaire?: string | undefined;
    /** Mode de preference du chat : actif ou non */
    modeChatActif: boolean;
    /** Définit si l'expert veut imposer le mode TeleExpertise pour le contact via MonSisra */
    msContactTeleExpertiseOnly: boolean;
    /** Définit si la PM veut imposer le mode Demande d'appui pour le contact via MonSisra */
    msContactDAOnly: boolean;
    /** Saisie des informations de facturation par le requérant */
    preferencesFacturationExpert?: PreferencesFacturationExpert | undefined;
    /** Numéro de facturation de la préférence */
    numeroFacturation?: string | undefined;
    /** Type d'utilisateur déclaré : Expert ou Equipe ressource */
    typeUtilisateurSollicitation: TypeUtilisateurSollicitation;
}

export interface PreferencesSollicitation extends PreferencesSollicitationBasicFields {
    /** Prérequis nécessaires pour solliciter l'expert/équipe resssource */
    prerequis: PrerequisSollicitation;
    /** Description de l'activité de l'expert/équipe ressource */
    description?: string;
    /** Préférences de clôture automatique de l'expert */
    preferencesClotureAuto?: PreferencesClotureAuto | undefined;
    /** Saisie des préférences d'envoi de TLE à l'expert par le requérant */
    preferencesEnvoiSyntheseTleExpert?: PreferencesEnvoiSyntheseTleExpert | undefined;
    /** Préférences de restriction de l'expert */
    preferencesRestriction?: PreferencesRestriction | undefined;
}

/** Champs requis pour la lecture/écriture sur les données de prérequis de sollicitation */
export interface PrerequisSollicitationBasicFields {
    /** Texte affiché dans la page de préférences de téléexpertise */
    message: string;
    /** Texte affiché dans le message notifiant les prérequis au requérant lors de la sollicitation */
    echangeBullePrerequis?: string | undefined;
}

export interface PrerequisSollicitation extends PrerequisSollicitationBasicFields {
    /** Liste de fichiers ajoutés dans les prérequis de l'expert/équipe ressource */
    files: FichierPrerequisSollicitation[];
}

/** Données de prérequis avec contenu des fichiers pour sauvegarder la déclaration d'un expert/d'une équipe ressource */
export interface PrerequisSollicitationWithFilesContent extends PrerequisSollicitationBasicFields {
    /** Liste de fichiers ajoutés dans les prérequis de l'expert/équipe ressource */
    files?: FichierPrerequisSollicitationWithContent[];
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface Profession {
    idProfession: number;
    nom: string;
    ordre?: number | undefined;
    estMorale: boolean;
}

export interface ProfessionSuggestion {
    id: string;
    nom: string;
    type: string;
}

export interface Professionnel {
    accesBrisGlace?: boolean | undefined;
    adeli: string;
    adresse: string;
    civilite: string;
    codePostal: string;
    email?: string | undefined;
    emailMSS?: string | undefined;
    hasEmail: boolean;
    gestionnaireHabilitation: boolean;
    idCarte: string;
    idTechPs: string;
    listeEtablissements: Etablissement[];
    nomNaissance: string;
    nomUsuel: string;
    prenom: string;
    profession: Profession;
    rpps: string;
    specialite: Specialite;
    telephoneMobile: string;
    telephoneFixe: string;
    telephoneSecretariat: string;
    ville: string;
    zeroPapier: boolean;
    estAdministrateur?: boolean | undefined;
    estGestionnaireEquipe?: boolean | undefined;
    estHotliner?: boolean | undefined;
    /** Si l'utilisateur est une personne morale */
    estMorale: boolean;
    /** Si l'utilisateur a validé les CGU */
    validatedCGU: boolean;
    /** Date de la dernière activité de l'utilisateur dans monsisra */
    dateDerniereActivite?: Date | undefined;
}

export interface ProfessionnelAdministration extends Professionnel {
    typeUtilisateur?: ETypeUtilisateur;
    envoiMailInactif?: boolean;
    administrateurFonctionnelAlias?: boolean;
    administrateurTechniqueAlias?: boolean;
    typeEcranDossier?: string;
    actif?: boolean;
    accesSmsValide?: boolean | undefined;
    adressePostalePartage?: boolean | undefined;
    telephoneMobilePartage?: boolean | undefined;
    telephoneFixePartage?: boolean | undefined;
    telephoneSecretariatPartage?: boolean | undefined;
    emailValide?: boolean;
    emailPartage?: boolean | undefined;
    loginParametrable?: string;
    dateCreation?: Date;
    dateModification?: Date | undefined;
    emailMSS?: string;
    dateDerniereConnexion?: Date | undefined;
    partageMss?: boolean | undefined;
    partageTelephoneMss?: boolean | undefined;
    emailNotification?: string;
    codeSMS?: string;
    codeValidation?: string;
    monSisraActivated?: boolean;
}

/** Transport class for profesionnal and its billing number */
export interface ProfessionnelFacturation {
    /** Technical identifier of user */
    idTechPs: string;
    /** Billing number of the expert */
    numeroFacturation?: string | undefined;
}

export interface ProfessionnelProscrit extends Professionnel {
    dateProscription?: Date;
}

export interface ProfessionnelReduit {
    /** Libellé du PS : Civilite Prenom NOM - NomSpecialite */
    libelle: string;
    mail: string;
    /** Adresse MSS du professionnel */
    emailMSS: string;
    /** Libellé du PS : Civilite Prenom NOM - NomSpecialite */
    hasEmail: boolean;
    zeroPapier: boolean;
    /** Identifiant technique du PS */
    idTechPs: string;
    /** Identifiant de carte RPPS ou ADELI du PS */
    rppsOrIdCarteOrAdeli: string;
}

export interface ProfessionnelReduitWithSpecialite extends ProfessionnelReduit {
    specialite?: Specialite;
}

export interface ProfessionnelReduitDelegant extends ProfessionnelReduitWithSpecialite {
    estMorale?: boolean;
    /** Indique si l'utilisateur est habilité à acceder a l'écran "MesParcours" */
    habilitedMesParcoursMocas?: boolean;
    /** Indique si l'utilisateur est habilité à acceder a l'écran de création d'un parcours */
    habilitedCreationParcoursMocas?: boolean;
    /** Indique si le délégué de ce PS est gestionnaire de ces préférences */
    delegueEstGestionnairePreference?: boolean;
    /** Gets or sets the delegation state for discussion. */
    estDelegueDiscussion?: boolean;
    /** Gets or sets the delegation state for dossier. */
    estDelegueDossier?: boolean;
}

export interface ProfessionnelReduitDelegantWithStatus extends ProfessionnelReduitDelegant {
    statut?: Statut;
}

export interface ProfessionnelReduitSollicitation extends ProfessionnelReduitWithSpecialite {
    preferencesExpert?: PreferencesExpert;
    equipeRessource?: TEquipeRessource;
}

export interface ProfessionnelSollicitation extends Professionnel {
    preferencesExpert?: PreferencesExpert;
    equipeRessource?: TEquipeRessource;
}

/** Informations de connexion du PS dans MonSisra */
export interface PsConnexionInfosMonSisra {
    /** Indique si le PS a un code d'activation ou non */
    hasCodeActivation: boolean;
    /** Indique si le PS a un email renseigné ou non */
    hasEmail: boolean;
    /** Indique si le PS a un mot de passe enregistré dans le portail ou non */
    hasMdpPortail: boolean;
    /** Indique si le PS a configuré une vérification par SMS ou non */
    hasSms: boolean;
}

export interface QueryProfessionRequest {
    professionFilter: string;
    count?: number | undefined;
}

export interface QueryWhereRequest {
    whereFilter: string;
    count?: number | undefined;
}

export interface QueryWhoRequest {
    whoFilter: string;
    isExpert?: boolean | undefined;
    isResourceTeam?: boolean | undefined;
    start?: number | undefined;
    count?: number | undefined;
    typeFilter: string;
    idTechPsIdentifie: string;
}

/** Un échange peut contenir cette objet qui référence un autre échange auquel on répond */
export interface ReplyToEchange {
    id: string;
    auteur: string;
    commentaire: string;
    date: Date;
    pieceJointes: PieceJointeLight[];
    isDeleted: boolean;
    mentions: Mention[];
}

export interface ReponseInfos {
    /** IdTechPs de l'auteur du document auquel on répond */
    idTechPsAuteur: string;
    /** Id Local doc du document auquel on répond */
    idLocalDoc: string;
    /** Id Ets doc du document auquel on répond */
    idEts?: number | undefined;
    /** Id Piece du document auquel on répond */
    idPiece?: number | undefined;
    /** Nom du document auquel on répond */
    libelleDoc: string;
    /** Date du document */
    dateDoc: Date;
    /** IPPR du patient */
    ippr?: number | undefined;
    /** Prenom Nom du patient */
    patientLibelle: string;
    /** Id document travail relatif au second echange */
    idDocumentTravail: string;
}

export interface ReponseInfosRequest {
    reponseInfos: ReponseInfos;
    idTechPsIdentifie: string;
    /** Type du workflow en cour tchat instantané ou mail */
    typeMessagerie?: MessagerieType | undefined;
}

export interface RequestPasswordPasswordChangeResult {
    /** Code */
    code: string;
    /** Description */
    description: string;
}

export enum ResourceTypeFilter {
    None = "None",
    PP = "PP",
    UO = "UO",
}

/** Code de saisie des informations de facturation de Téléexpertise */
export enum SaisieInfosFacturationSollicitation {
    Invisibles = "Invisibles",
    Optionnelles = "Optionnelles",
    Obligatoires = "Obligatoires",
}

/** Données nécessaires pour sauvegarder la déclaration d'expert/d'équipe ressource */
export interface SavePreferencesSollicitationRequest extends PreferencesSollicitationBasicFields {
    /** Prérequis nécessaires pour solliciter l'expert/l'équipe ressource */
    prerequis?: PrerequisSollicitationWithFilesContent;
    /** Description de l'activité de l'expert/équipe ressource */
    description?: string;
    /** Préférences de clôture automatique de l'expert */
    preferencesClotureAuto?: PreferencesClotureAuto | undefined;
    /** Saisie des préférences d'envoi de TLE à l'expert par le requérant */
    preferencesEnvoiSyntheseTleExpert?: PreferencesEnvoiSyntheseTleExpert | undefined;
    /** Préférences de restriction de l'expert */
    preferencesRestriction?: PreferencesRestriction | undefined;
}

export interface SearchCriteria {
    criteriaValue: string;
    criteriaType: string;
}

export interface SearchPPAndServicesRequest {
    location: string;
    locationPhysicalType: string;
    locationNear: string;
    whoFilter: string;
    psRecent: string;
    isExpert: boolean;
    isEquipeResource: boolean;
    count?: number | undefined;
    searchIdNat: boolean;
    searchIdTech: boolean;
    filter: ResourceTypeFilter;
    idTechPsIdentifie: string;
    searchCriterias: SearchCriteria[];
}

export interface SearchPatientsForVigilanceRequest {
    birthFirstName: string;
    birthLastName: string;
    birthDate: Date;
    sex: string;
    birthCity: string;
    idTechPsIdentifie: string;
}

export interface SendDocumentToConversationRequest {
    idDocumentTravail: string;
    idTechPsIdentifie: string;
    idConv: string;
    /** Type de messagerie en cours tchat instantané ou mail */
    typeMessagerie?: MessagerieType | undefined;
}

export interface Service {
    id: string;
    idTechPS: string;
    idNat: string;
    nom: string;
    villeCP: string;
    adressePostale: string;
    adresseMSS: string;
    email: string;
    specialite: string;
    structure: string;
    equipeResource?: boolean | undefined;
    detailEquipeResource: string;
    echangeBullePrerequisEquipeResource: string;
    urlOutilEquipeResource: string;
    centragePatientEquipeResource: boolean;
    formulairesEquipeResource: FormulaireType[];
    teleExpert?: boolean | undefined;
    detailTeleExpertise: string;
    echangeBullePrerequisTeleExpertise: string;
    urlOutilTeleExpertise: string;
    centragePatientTeleExpertise: boolean;
    formulairesTeleExpertise: FormulaireType[];
    statut: string;
    isFavoris: boolean;
    searchScore?: number | undefined;
    isAbsent?: boolean | undefined;
    libelleAbsence: string;
    dateDebutAbsence?: Date | undefined;
    dateFinAbsence?: Date | undefined;
    derniereConsultationMessagerie?: Date | undefined;
    dernierMailMss?: Date | undefined;
    msContactTeleExpertiseOnly?: boolean | undefined;
}

/** Objet de transport de la requête SetAbsence */
export interface SetAbsenceRequest {
    /** Message d'absence */
    messageAbsence: string;
    /** Date de début de l'absence de l'utilisateur. */
    dateDebutAbsence?: Date | undefined;
    /** Date de fin de l'absence de l'utilisateur. */
    dateFinAbsence?: Date | undefined;
    /** Défini si l'utilisateur veut recevoir des notifications pour cette absence. */
    notificationOff?: boolean | undefined;
}

/** Objet de requête pour une définir une facturation de teleexpertise */
export interface SetFacturationTeleExpertiseRequest {
    /** Identifiant technique de l'utilisateur identifié */
    idTechPsIdentifie: string;
    /** Niveau de facturation de la téléexpertise */
    cotation: string;
    /** Requêrant de la demande d'expertise */
    requerant: ProfessionnelFacturation;
    /** Expert mandaté pour la téléexpertise
/// */
    expert: ProfessionnelFacturation;
}

/** Contient les données permettant de mettre à jour la propriété PatientPeutRepondre d'une conversation */
export interface SetPatientPeutRepondreRequest {
    /** Identifiant de la conversation */
    idConversation: string;
    /** Si le patient peut répondre à la conversation */
    patientPeutRepondre: boolean;
    /** Identifiant du PS identifié (le délégué (ou soi même) pour qui on agit) */
    idTechPsIdentifie: string;
}

export interface SetPreferencesMonSisraRequest {
    idTechPsIdentifie: string;
    idTechPsCible: string;
    preferences: PreferencesMonSisra;
}

export interface SetPsFavoriRequest {
    idTechPsIdentifie: string;
    idTechPsDestinataire: string;
    isFavori: boolean;
}

export interface SetStatutEtatSollicitationRequest {
    /** Identifiant technique du PS identifié */
    idTechPsIdentifie: string;
    /** Niveau de facturation de la téléexpertise */
    niveauFacturation: string;
}

/** Contient les données d'une sollicitation */
export interface Sollicitation {
    /** Identifiant de la conversation liée à la sollicitation */
    idConversation: string;
    /** Identifiant du formulaire utilisé */
    idFormulaire: string;
    /** Ippr du patient lié à la sollicitation */
    ippr: string;
    /** Identifiant technique du PS requérant */
    idTechPsRequerant: string;
    /** Identifiant technique du PS expert/équipe ressource */
    idTechPsReceveur: string;
    /** Identifiant technique de l'expert en charge */
    idTechPsExpertEnCharge?: string | undefined;
    /** Etat courant de la sollicitation */
    etatSollicitation: EtatSollicitation;
    /** Date du dernier échange de la conversation de sollicitation */
    dateDernierEchange: Date;
    /** Mode de préférence du chat : actif ou non */
    modeChatActif: boolean;
    /** Type de la sollicitation : Demande d'appui ou téléexpertise
Null dans le cadre de Snacs */
    typeSollicitation?: TypeSollicitation | undefined;
}

/** extension de la classe Sollicitation afin d'avoir les information de facturation */
export interface SollicitationWithFactu extends Sollicitation {
    /** Numéro de facturation du requérent */
    numeroFacturationRequerant?: string | undefined;
    /** Numéro de facturation du receveur */
    numeroFacturationReceveur?: string | undefined;
}

export interface Specialite {
    /** Code technique de la spécialité. */
    codeSpecialite: number;
    /** Identifiant technique du groupe dont la spécialité fait partie. */
    idGroupeSpecialite?: number | undefined;
    /** Identifiant de la profession à laquelle la spécialité se rattache. */
    idProfession: number;
    /** Identifiant technique de la spécialité. */
    idSpecialite: number;
    /** Libellé de la spécialité */
    nom: string;
    /** Couleur hexadécimale attribuée à la spécialité. */
    couleur: string;
    /** Ordre d'affichage de la spécialité. */
    ordre: number;
    /** Acteur premier recours */
    estPremierRecours: boolean;
}

/** Contient les données nécessaires au démarrage d'une visio */
export interface StartVisioRequest {
    /** Identifiant de la conversation dans laquelle démarre la visio
Gestion du cas ou l'idConversation est un string */
    IdConversation: any;
    /** Identifiant du PS déléguant pour lequel l'utilisateur travaille */
    idTechPsIdentifie: string;
}

export interface Statut {
    idTechPS: string;
    derniereConsultationMessagerie?: Date | undefined;
    dernierMailMss?: Date | undefined;
    isAbsent: boolean;
    libelleAbsence: string;
    dateDebutAbsence?: Date | undefined;
    dateFinAbsence?: Date | undefined;
    /** Pour les personnes qui ne peuvent pas avoir de statut (ex: equipe ressources regions snacs) */
    isIgnore?: boolean | undefined;
    /** Détermine si le PS veut recevoir des notifications pendant de son absence */
    notificationsOff: boolean;
}

export interface SupprimerActeurPatientPSRequest {
    idTechPsIdentifie: string;
    idActeur: number;
    passeDroit: string;
}

/** Contient les données nécessaires à la synthèse d'une conversation */
export interface SyntheseConversationRequest {
    /** Identifiant de la conversation à mettre à jour */
    idConversation: string;
    /** Liste des id des échanges à inclure dans la synthèse */
    echangesIds: any;
    /** Identifiant du PS déléguant pour lequel l'utilisateur travaille */
    idTechPsIdentifie: string;
    /** Optionnel : indique si la synthèse TLE est finalisée */
    isFinalisationTle?: boolean | undefined;
}

/** Contient les données nécessaires à la synthèse d'une conversation avec un fichier */
export interface SyntheseConversationTLERequest extends SyntheseConversationRequest {
    /** Fichier du formulaire */
    fichierFormulaireFinalisation?: FileBase64Encoded | undefined;
}

/** Contient les données nécessaires à la synthèse d'une conversation avec un IdFormulaire */
export interface SyntheseConversationTLEWithIdDocRequest extends SyntheseConversationRequest {
    /** Id d'un formulaire de sollicitation */
    idFormulaire?: string | undefined;
}

export interface TEquipeRessource {
    /** Identifiant technique de l'utilisateur */
    idTechPs: string;
    /** Description de l'activité de l'équipe ressoure */
    description: string;
    /** Url de l'outil utilisée pour demander l'avis de l'équipe ressoure */
    urlOutil: string;
    /** Centrer ou non une nouvelle de sollicitation autour d'un patient . */
    centragePatient: boolean;
    /** Echange fictif à afficher dans la conversation pour présenter les */
    echangeBullePrerequis: string;
    formulaires: FormulaireType[];
}

export interface TextConfiguration {
    invitationInactiveColleagueTitle: string;
    invitationInactiveColleague: string;
    invitationColleagueAbsentFromAnnuaireTitle: string;
    invitationColleagueAbsentFromAnnuaire: string;
}

export interface TokenAccessData {
    artefactId: string;
    authenticationUrl?: string | undefined;
    description: string;
    status: TokenAccessStatus;
}

export enum TokenAccessStatus {
    None = "None",
    AuthenticationSuccess = "AuthenticationSuccess",
    UserNotFound = "UserNotFound",
    TechnicalError = "TechnicalError",
    InvalidVitaleData = "InvalidVitaleData",
}

export interface TokenAttributes {
    authenticationMode: string;
    ssoUserLastName: string;
    ssoUserFirstName: string;
    ssoAuthenticationLevel: number;
    ssoUserTechId: string;
    subjectNameId: string;
}

export interface TokenExtraData {
    key: string;
    value: string;
    type: TokenExtraDataType;
}

export enum TokenExtraDataType {
    Text = "Text",
    Xml = "Xml",
}

export interface TraceConnection {
    application: string;
    platform: string;
    osVersion: string;
    clientId: string;
    clientVersion: string;
}

export interface TransfererDocumentRequest {
    idTechPsIdentifie: string;
    idDocumentTravail: string;
    idLocalDoc: string;
    idEts: number;
    /** Type du workflow en cours tchat instantané ou mail */
    typeMessagerie?: MessagerieType | undefined;
}

export interface TransfererDocumentsRequest {
    listDocuments: DocumentId[];
    idDocumentTravail: string;
    idTechPsIdentifie: string;
    /** Type du workflow en cours tchat instantané ou mail */
    typeMessagerie?: MessagerieType | undefined;
}

/** Type passé de msb (depuis  la 1.12) à MonSisra.API (puis vers Snacs.SynchroDoc) */
export enum TypeConvSynchroDoc {
    Aucune = "Aucune",
    Conversation = "Conversation",
    Resultat = "Resultat",
    RendezVous = "RendezVous",
    Courrier = "Courrier",
    MSS = "MSS",
    DGS = "DGS",
    EchangePatient = "EchangePatient",
    MSSPatient = "MSSPatient",
    CourrierPatient = "CourrierPatient",
    TeleExpertise = "TeleExpertise",
    DemandeAppui = "DemandeAppui",
}

/** Données des types de formulaires de sollicitation */
export interface TypeFormulaireSollicitation {
    /** Identifiant du type de formulaire */
    idTypeFormulaire: string;
    /** Nom du formulaire */
    nomFormulaire: string;
    /** Booléen d'indication de formulaire sélectionnable uniquement par un Admin */
    adminOnly?: boolean | undefined;
}

export enum TypeMenuBoite {
    BoiteReception = "BoiteReception",
    Conversation = "Conversation",
    Courrier = "Courrier",
    CourrierPatient = "CourrierPatient",
    DGS = "DGS",
    DemandeAppui = "DemandeAppui",
    EchangePatient = "EchangePatient",
    Evenement = "Evenement",
    MSS = "MSS",
    MSSPatient = "MSSPatient",
    NombreNonLu = "NombreNonLu",
    RendezVous = "RendezVous",
    Resultat = "Resultat",
    TeleExpertise = "TeleExpertise",
    ATraiter = "ATraiter",
    Favoris = "Favoris",
    NonLus = "NonLus",
    Tous = "Tous",
    MSSante = "MSSante",
}

export interface TypePiece {
    /** Gets or sets id of the type of piece. */
    id: number;
    /** Gets or sets the category. */
    idCategorie: number;
    /** Gets or sets name of the type of piece */
    nom: string;
    isUrgence: boolean;
    isSynthese: boolean;
    nomCourt: string;
    commentaire: string;
    numOrdre?: number | undefined;
    idPere?: number | undefined;
    /** VisibleMenu contient : Expanded (type affiché de manière dépliée par défaut) , Collapsed (type affiché de manière repliée par défaut) ou Hidden (type caché à l'affichage). */
    visibleMenu: string;
    /** UrlAction contient : ViewerAnalyseBiologie, ProchainsRdv, url site web ou null. Détermine une action à réaliser vis à vis du type de document. (on ne veut pas juste afficher le document comme les autres types). */
    urlAction: string;
    isSupprime: boolean;
    /** Indique les droits de l'utilisateur false=lecture / true=lecture+écriture */
    userCanWrite?: boolean | undefined;
}

/** Regroupe les types de sollicitation */
export enum TypeSollicitation {
    TeleExpertise = "TeleExpertise",
    DemandeAppui = "DemandeAppui",
}

/** Codes des types d'utilisateurs déclarés pour une sollicitation */
export enum TypeUtilisateurSollicitation {
    Expert = "Expert",
    EquipeRessource = "EquipeRessource",
}

/** Contient les données nécessaires à la mise à jour du contenu d'une conversation */
export interface UpdateConversationContenuRequest {
    /** Identifiant du PS déléguant pour lequel l'utilisateur travaille */
    idTechPsIdentifie: string;
    /** Identifiant de la conversation */
    idConversation: string;
    /** Sujet de la conversation */
    sujet: string;
    /** Type de la conversation (utilisé pour le routage entre Snacs.Messagerie et l'ApiSanté) */
    typeMessagerie?: MessagerieType | undefined;
}

/** Contient les données permettant de mettre à jour les conversations d'un utilisateur */
export interface UpdateConversationsUtilisateurRequest {
    /** Indique si les conversations sont à archiver ou non */
    archiver: boolean;
    /** Indique si les échanges des conversations doivent être mis "Lu" ou non */
    mettreALu: boolean;
    /** Filtre de recherche sur les conversations archivées */
    archives?: boolean | undefined;
    /** Filtre de recherche sur les conversations contenant des échanges non lus */
    estNonLu?: boolean | undefined;
    /** Filtre de recherche sur les conversations marquées "A traiter" */
    estATraiter?: boolean | undefined;
    /** Filtre de recherche sur les conversations marquées comme favorites */
    estFavori?: boolean | undefined;
    /** Filtre de recherche sur les conversations centrées patient */
    estCentrePatient?: boolean | undefined;
    /** Identifiant du PS dont les conversations sont à mettre à jour */
    idTechPsCible: string;
    /** Filtre de recherche sur le type de conversations à mettre à jour */
    typeConversation: string;
}

export interface UpdateDocumentTravailRequest {
    documentTravail: DocumentTravail;
    idTechPsIdentifie: string;
    /** Type du workflow en cours tchat instantané ou mail */
    typeMessagerie?: MessagerieType | undefined;
}

export interface UpdateFichierTravailRequest {
    fichierTravail: FichierTravail;
    idTechPsIdentifie: string;
    typeMessagerie?: MessagerieType | undefined;
}

export interface UpdateNomFichierTravailRequest {
    idFichierTravail: string;
    nomFichierTravail: string;
    idTechPsIdentifie: string;
    ippr: string;
    typeMessagerie?: MessagerieType | undefined;
}

export interface UpdatePSEmailInDpprAndInAsWithSynchroRequest {
    idTechPsCible: string;
    email: string;
    idTechPsIdentifie: string;
    isEmailNotification?: boolean | undefined;
}

export interface UpdatePSInDpprAndInAsWithSynchroRequest {
    idTechPsIdentifie: string;
    professionnel: ProfessionnelAdministration;
}

export interface UpdateStatutConversationRequest {
    idTechPsIdentifie: string;
    idConversation: string;
    source?: ConversationSource | undefined;
    estLue?: boolean | undefined;
    archivee?: boolean | undefined;
    favorite?: boolean | undefined;
    aTraiter?: boolean | undefined;
    mutee?: boolean | undefined;
    type: string;
    estImportant?: boolean | undefined;
    estQuestion?: boolean | undefined;
    idTechPsCible: string;
    emailMssCible?: string | undefined;
    typeMessagerie?: MessagerieType | undefined;
}

export interface UserCredentiels {
    userLogin: string;
    password: string;
}

export interface UserInfo {
    /** Private property for Libelle */
    libelle: string;
    /** Civilité du PS (M. Mme. Dr. ...) */
    civilite: string;
    /** Prénom du PS */
    prenom: string;
    /** Nom du PS */
    nomUsuel: string;
    mail: string;
    emailMSS: string;
    /** Private property for IdCarte */
    idCarte: string;
    /** Private property for IdTechPSConnecte */
    idTechPSConnecte: string;
    /** Liste des délégants de l'utilisateur connecté */
    listeDelegants: ProfessionnelReduitDelegant[];
    /** Stocke toutes les informations du jeton. */
    tokenAttributes: TokenAttributes;
    /** Stocke les informations du patient s'il a été connecté par Carte Vitale. */
    patientCarteVitale: PatientCarteVitale;
    /** Info qui permet de savoir si le PS connecté à droit de se connecter en Bris de Glace */
    isBrisDeGlaceAuthorized: boolean;
    /** L'utilisateur connecté est administrateur : accès autorisé à toutes les interfaces d'administration et d'appeller les services d'admin */
    isAdmin: boolean;
    /** L'utilisateur connecté est gestionnaire d'équipe : accès autorisé aux interfaces d'administration des équipes/établissements + webs services d'admin des équipes */
    isAdminTeams: boolean;
    /** L'utilisateur connecté est hotliner : accès autorisé à la page d'administration : gestion des comptes uniquement */
    isHotliner: boolean;
    /** Indique si l'utilisateur est habilité à acceder a l'écran "MesParcours" */
    habilitedMesParcoursMocas: boolean;
    /** Indique si l'utilisateur est habilité à acceder a l'écran de création d'un parcours */
    habilitedCreationParcoursMocas: boolean;
    /** Indique si l'utilisateur a déjà validé les CGUs. */
    hasValidatedCGU?: boolean | undefined;
    /** Date de dernière activité, null si jamais connecté */
    dateDerniereActivite?: Date | undefined;
}

export interface UserInfoV2 extends UserInfo {
    listeDelegants: ProfessionnelReduitDelegantWithStatus[];
    statut?: Statut;
}

export interface Ville {
    /** Identifiant de la ville. */
    id: number;
    /** Nom de la ville. */
    name: string;
    /** Code postal de la ville. */
    cp: string;
    /** Code INSEE de la ville. */
    codeINSEE: string;
}

export interface WebmailMessageDocument {
    lienDocument: string;
    nomDocument: string;
    libelleTypePiece: string;
    /** Identifiant local du document s'il provient d'un échange Zepra */
    idLocalDoc: string;
    etablissementId: number;
    idPiece?: string | undefined;
    date: Date;
    idTypePiece?: number | undefined;
    typeMime: string;
}

export interface WhoSuggestions {
    texteSuggestions: string[];
    personnePhysiqueSuggestions: PersonnePhysique[];
    serviceSuggestions: Service[];
}

export interface Widget {
    authenticationLevel: number;
    id: number;
    isFavori: boolean;
    liens: WidgetLink[];
    mainUrl: string;
    nom: string;
    urlLogo: string;
}

export interface WidgetLink {
    isSsoLink: boolean;
    nom: string;
    originalApplicationUrl: string;
    url: string;
}

export interface WidgetList {
    widgets: Widget[];
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}